import React, { useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { BrowserRouter as Router, Routes, Route, Link, NavLink, useParams, useLocation, useNavigationType, useNavigate } from 'react-router-dom';

// ---------------------------------------------------------
// ВРЪЗКИ КЪМ РЕАЛНИТЕ ПЛАЩАНИЯ В STRIPE (НАПЪЛНО НАСТРОЕНИ!)
// ---------------------------------------------------------
const STRIPE_LINKS = {
  // Абонаменти за профили (Месечни)
  standardSubscription: 'https://buy.stripe.com/7sY8wS9Y68nk1hq7hrcbC03',
  premiumSubscription: 'https://buy.stripe.com/8x2aF04DM6fcf8g31bcbC04',

  // Еднократни курсове
  beginnerCourse: 'https://buy.stripe.com/eVqfZkc6eeLIf8gatDcbC00',
  advancedCourse: 'https://buy.stripe.com/fZueVggmu6fcbW4fNXcbC01',
  examPrepCourse: 'https://buy.stripe.com/5kQ00m8U21YWd086dncbC02',
};

// ---------------------------------------------------------

// ---------------------------------------------------------
// 2. ДАННИ ЗА ПРОЕКТИТЕ
// ---------------------------------------------------------
const moviesList = [
  {
    id: 'kralyat-na-ulicata',
    title: 'Кралят на улицата',
    category: 'Тийнейджърски сериал',
    status: 'В продукция',
    poster: '/pictures/Кралят на улицата/1IMG_6189.jpeg',
    cover: '/pictures/Кралят на улицата/1IMG_6189.jpeg',
    trailerId: null,
    description: '„Кралят на улицата“ е тийнейджърска романтична комедия за първата любов, приятелството и обърканите избори на младостта.\n\nБоби мечтае да спечели Теди — най-популярното момиче в училище. За целта разчита на най-добрата си приятелка Ния, която пък е влюбена в Ники — харизматичното „лошо момче“, известно като Краля на улицата.\n\nДвамата сключват сделка: Боби ще помогне на Ния да стигне до Ники, а тя ще му помогне да впечатли Теди. Планът обаче ги въвлича в комични ситуации, ревност и недоразумения, които постепенно ги карат да се запитат дали наистина искат хората, които преследват.\n\nСвежа и емоционална история за първите влюбвания, грешните представи и смелостта да признаеш какво всъщност чувстваш.',
    director: 'Матей Генчев',
    producer: 'Devil Cinema и Матей Генчев',
    cast: ['Спас Ангелов', 'Антоан Ивков', 'Гергана Георгиева', 'Даря Мочукова'],
    crew: [
      { role: 'Оператор', name: 'Виктор Тодоров' },
      { role: 'Първи асистент режисьор', name: 'Даниела Петкова' }
    ]
  },
  {
    id: 'galyovnia',
    title: 'Гальовния',
    category: 'Пълнометражен игрален филм',
    status: 'В продукция',
    poster: '/pictures/Гальовния/ChatGPT Image Jun 24, 2026 at 05_23_12 PM.png',
    cover: '/pictures/Гальовния/ChatGPT Image Jun 24, 2026 at 05_23_12 PM.png',
    trailerId: null,
    description: '„Гальовния“ е мрачен психологически ноар за любовта, предателството и разпада на човешкия ум.\n\nДевет месеца след раздялата с Косара, писателят Пламен живее между алкохола, безсънието и спомените. Изолиран от света, той започва да разговаря с Гальовния — тъмното си вътрешно его, което превръща болката, ревността и яростта му в опасни мисли.\n\nДо него остава Богдан — най-добрият му приятел и брат на Косара, но и човекът, който я държи близо до света, унищожаващ я. Между тримата стоят вина, недоверие и неизказани тайни.\n\nВ град без светлина Пламен трябва да избере дали да се изправи срещу демоните си, или окончателно да им се подчини. Но кой всъщност говори в главата му — болката, истината или Гальовния?',
    director: 'Матей Генчев',
    producer: 'Дема Филм',
    cast: ['Милен Пенев', 'Йоана Джендова', 'Максим Генчев', 'Матей Генчев']
  },
  {
    id: 'prazna-stranica',
    title: 'Празна страница',
    category: 'Пълнометражен игрален филм',
    status: 'В продукция',
    poster: '/pictures/Празна страница/празнастраница1.png',
    cover: '/pictures/Празна страница/празнастраница1.png',
    trailerId: null,
    description: '„Празна страница“ е тийнейджърска романтична драма с криминални елементи за любовта, травмата и смелостта да започнеш отначало.\n\nМира е проблемното момиче в училище — агресивна, непредсказуема и винаги готова да се защити. Зад грубата ѝ външност обаче стоят години на домашно насилие, разбито семейство и токсични връзки. Единствената ѝ истинска слабост е по-малката ѝ сестра Ния, която се опитва да предпази от същия мрачен свят.\n\nЖивотът на Мира се променя, когато в квартала се завръща Жоро. Той вижда в нея не слуховете и миналото ѝ, а човек, който заслужава любов и ново начало. Но бившият ѝ приятел Марио отказва да я пусне и подготвя капан, който може да унищожи всичко между тях.\n\n„Празна страница“ е история за младостта без захаросване, за любовта, която може да спаси, и за избора дали да останеш затворен в миналото, или сам да напишеш бъдещето си.',
    director: 'Матей Генчев',
    producer: 'Дема Филм',
    cast: ['Очаква информация']
  },
  { id: 'bqgai', title: 'Бягай', category: 'Пълнометражен игрален филм', poster: '/pictures/bqgai/poster.png', cover: '/pictures/bqgai/cover.png', trailerId: 'Gj4fjkyvPxo', description: 'Експлозивна тийнейджърска драма с криминални елементи, която бележи смелия пълнометражен дебют на младия режисьор Матей Генчев. Лентата улавя пулса на съвременното изгубено поколение, разкъсвано между суровата улична реалност, моралните избори и копнежа за свобода. Създаден с безкомпромисен визуален стил и сурова естетика, проектът бързо се превърна в истински интернет феномен сред младежката аудитория в България.', director: 'Матей Генчев', producer: 'Десислава Ковачева, Кристиян Ангелов и Симеон Филипов', cast: ['Матей Генчев', 'Симона Милушева'] },
  { id: 'do-posleden-duh', title: 'До последен дъх', category: 'Пълнометражен игрален филм', poster: '/pictures/do-posleden-duh/poster.png', cover: '/pictures/do-posleden-duh/cover.png', trailerId: 'jpkP91kiDMI', description: 'Вълнуваща и дълбоко емоционална спортна драма, която проследява устрема на 16-годишния Естебан към неговата най-голяма мечта – ендуро мотоциклетизма. Режисиран от Матей Генчев, филмът майсторски преплита рева на двигателите по калните трасета с красива, чиста романтична нишка. Лентата прави психологическа дисекция на волята за победа и изследва докъде е готов да стигне човек, когато залогът пред камерата и в живота е собствената му съдба.', director: 'Матей Генчев', producer: 'Десислава Ковачева и Маги Георгиева', cast: ['Калин Радев', 'Дебора Георгиева'] },
  { id: 'levski', title: 'Дякон Левски', category: 'Пълнометражен игрален филм', poster: '/pictures/levski/poster.png', cover: '/pictures/levski/cover.png', trailerId: 'PY-EqT7RJ84', description: 'Мащабно историческо платно на режисьора Максим Генчев, което дръзко преобръща класическите представи за българския национален епос. Представена като кинематографично „житие на светец“, лентата извежда образа на Васил Левски извън рамките на христоматийния паметник, разкривайки неговия изключително дълбок вътрешен свят. Проектът впечатлява с визуална поезия, епичен мащаб на масовките и силно актьорско присъствие, улавяйки пътя от усамотението на манастирската килия до безсмъртието на бесилото.', director: 'Максим Генчев', producer: 'Златина Филипова', cast: ['Веселин Плачков', 'Симеон Филипов'] },
  { id: 'botev', title: 'Ботев', category: 'Пълнометражен игрален филм', poster: '/pictures/botev/poster.png', cover: '/pictures/botev/cover.png', trailerId: 'MxzlxA7Sd8g', description: 'Епичен биографичен филм, който вдъхва нов, ярък живот на една от най-великите, комплексни и трагични фигури в българската история. Режисьорът Максим Генчев и сценаристът Десислава Ковачева изграждат силен, импулсивен, жив и уязвим образ на Христо Ботев. Лентата улавя поетичния му гений и неудържимия му революционен плам, превеждайки зрителя през лабиринта на подготовката, заверата, превземането на кораба „Радецки“ и безсмъртния подвиг на Милин камък.', director: 'Максим Генчев', producer: 'Десислава Ковачева', cast: ['Деян Жеков', 'Неда Спасова'] },
  { id: 'geracite', title: 'Гераците', category: 'Пълнометражен игрален филм', poster: '/pictures/geracite/poster.png', cover: '/pictures/geracite/cover.png', trailerId: 'BkTkHLxjFdE', description: 'Майсторска и дълбоко атмосферна екранизация на едноименната класическа повест от Елин Пелин, която пренася зрителя в мрачния залез на стария български патриархален ред. Филмът прави безмилостна дисекция на болезненото разпадане на семейните ценности, алчността и греха, които бавно разяждат някогашната хармония в дома на заможния Йордан Герака. Кинематографията залага на тежки, наситени кадри, които превръщат битовата драма в общочовешка трагедия за погубената любов.', director: 'Максим Генчев', producer: 'Очаква информация', cast: ['Максим Генчев', 'Симеон Алексиев'] },
  { id: 'na-pedq', title: 'На педя от земята', category: 'Пълнометражен игрален филм', poster: '/pictures/na-pedq/poster.png', cover: '/pictures/na-pedq/cover.png', trailerId: 'GsWQHmpVAYo', description: 'Напрегната, мрачна и психологически наситена историческа драма, разгръщаща се в най-жестоките години на ранния социализъм през 1951 г. В зората на Студената война, на заградената с бодлива тел граница между два коренно различни свята, филмът изследва параноята, предателството и непосилната цена на свободата. Режисурата залага на трилър елементи и хладен визуален език, където човешкото достойнство и живот буквално висят на една педя от земята.', director: 'Максим Генчев', producer: 'Златина Филипова', cast: ['Цветомир Ангелов', 'Десислава Чутуркова'] },
  { id: 'smartphone', title: 'Смартфонът беглец', category: 'Пълнометражен игрален филм', poster: '/pictures/smartphone/poster.png', cover: '/pictures/smartphone/cover.png', trailerId: 'A-2DmJPltwU', description: 'Динамично, вълнуващо и забавно фантастично приключение във времето, което по изключително модерен начин съчетава съвременните дигитални технологии с българската митология и хайдушка история. Трима тийнейджъри се впускат в опасна мисия, за да спасят човешки живот, но благодарение на модифициран смартфон отварят мистичен портал. Те се оказват в миналото, изправени лице в лице с легендарния Вълчан войвода и неговото златно съкровище.', director: 'Максим Генчев', producer: 'Златина Филипова', cast: ['Симеон Филипов', 'Матей Генчев'] },
  { id: 'v-lojata', title: 'В ложата на тротоара', category: 'Пълнометражен документален филм', poster: '/pictures/v-lojata/poster.png', cover: '/pictures/v-lojata/cover.png', trailerId: null, description: 'Дълбоко хуманен и поетичен документален разказ, който превръща грубия градски асфалт в сцена за неподправено творчество. Лентата нежно проследява ежедневието, несподелените болки и скритите съдби на уличните музиканти в България. Камерата улавя магията и суровата искреност на тези артисти, разкривайки душите на хора, които притежават огромен талант, но често остават напълно невидими и анонимни за забързаните минувачи.', director: 'Максим Генчев', producer: 'Десислава Ковачева', cast: ['Екип на продукцията'] },
  { id: 'pregled', title: 'Преглед на вътрешните пространства', category: 'Пълнометражен игрален филм', poster: '/pictures/pregled/poster.png', cover: '/pictures/pregled/cover.png', trailerId: null, description: 'Камерна, интимна и психологически наситена независима драма на режисьора Максим Генчев. Филмът прави безмилостна художествена дисекция на сложните, понякога разрушителни и токсични отношения в един брак между 35-годишната Нина и нейния значително по-възрастен съпруг Макс. Сценарият потапя зрителя в лабиринт от неизказани истини, емоционални зависимости и борба за надмощие, развиващи се изцяло в затворените пространства на дома и ума.', director: 'Максим Генчев', producer: 'Десислава Ковачева', cast: ['Десислава Ковачева', 'Максим Генчев'] },
  { id: 'teen-scene', title: 'Teen Scene Talk Show', category: 'Talk Show', poster: '/pictures/teen-scene/poster.jpg', cover: '/pictures/teen-scene/cover.jpg', trailerId: '_N9YDH2vWlk', description: 'Първото по рода си мащабно онлайн тийнейджърско токшоу в България, създадено, режисирано и продуцирано изцяло от Матей Генчев още през 2017 година. Проектът се превърна в абсолютен дигитален феномен, давайки свободен и искрен глас на младото поколение. Шоуто се утвърди като най-гледаната интернет платформа, срещайки тийнейджърите с най-влиятелните поп-културни, музикални и шоубизнес личности в страната, натрупвайки рекордна гледаемост от над 3.5 милиона показвания.', director: 'Матей Генчев', producer: 'Матей Генчев', cast: ['Симона Милушева', 'Матей Генчев'], gallery: ['/pictures/teen-scene/img1.jpg', '/pictures/teen-scene/img2.jpg', '/pictures/teen-scene/img3.jpg', '/pictures/teen-scene/img4.jpg', '/pictures/teen-scene/img5.jpg', '/pictures/teen-scene/img6.jpg', '/pictures/teen-scene/img7.jpg', '/pictures/teen-scene/img8.jpg', '/pictures/teen-scene/img9.jpg', '/pictures/teen-scene/img10.jpg', '/pictures/teen-scene/img11.jpg', '/pictures/teen-scene/img12.jpg'] }
];

// ---------------------------------------------------------
// 3. ДАННИ ЗА АКТЬОРИТЕ
// ---------------------------------------------------------
const actorsList = [
  {
    id: 29,
    name: 'Радослава Колева',
    category: 'Професионални актьори',
    photo: '/pictures/actors/radoslava-koleva/rkprofilepremium.png',
    hoverVideo: null,
    isPremium: true,
    gender: 'Жена',
    age: 32,
    screenAge: '27–32',
    region: 'София',
    hairColor: 'Кафява коса',
    height: 173,
    eyes: 'Кафяви',
    experience: 'Радослава Колева е актриса от София с практически опит пред камера в рекламни и филмови продукции. Преминала е три актьорски курса при Деси Тенеджиева, Гери Стреч и Леарт Докле, чрез които развива подготовката си за работа пред камера и изграждане на различни персонажи. Отворена е към участие във филмови, телевизионни и рекламни продукции.',
    skills: 'Танци, спорт, рисуване, конна езда, бойни изкуства – бокс',
    languages: 'Български, френски, сръбски, английски',
    availability: 'При предварително уточнение',
    education: 'Три актьорски курса при Деси Тенеджиева, Гери Стреч и Леарт Докле',
    gallery: [
      '/pictures/actors/radoslava-koleva/rkprofilepremium.png',
      '/pictures/actors/radoslava-koleva/rkprofilepremium0.png',
      '/pictures/actors/radoslava-koleva/rkprofilepremium1.png',
      '/pictures/actors/radoslava-koleva/rkprofilepremium2.png',
      '/pictures/actors/radoslava-koleva/rkprofilepremium3.png',
      '/pictures/actors/radoslava-koleva/rkprofilepremium4.png',
      '/pictures/actors/radoslava-koleva/rkprofilepremium5.png',
      '/pictures/actors/radoslava-koleva/rkprofilepremium6.png',
      '/pictures/actors/radoslava-koleva/rkprofilepremium7.png',
      '/pictures/actors/radoslava-koleva/rkprofilepremium8.png',
      '/pictures/actors/radoslava-koleva/rkprofilepremium9.png',
    ],
  },
  {
    id: 28,
    name: 'Любомира Христова',
    category: 'Професионални актьори',
    photo: '/pictures/actors/lyubomira-hristova/lhprofilepremium.png',
    hoverVideo: null,
    isPremium: true,
    gender: 'Жена',
    age: 31,
    screenAge: '29–33',
    region: 'София',
    hairColor: 'Кестенява коса',
    height: 170,
    eyes: 'Сини',
    experience: 'Любомира Христова е професионална актриса с международна подготовка и практически опит в киното, телевизията и модните продукции. Обучавала се е по техниката на Ивана Чъбак във Film Forge – Nu Boyana, преминала е stunt training в Nu Boyana Film Studios, обучение по self-tape, audition techniques и business of acting с Julian Kostov, както и актьорски класове в Anthony Meindl’s Actor Workshop в Чикаго. Допълнителната ѝ подготовка включва камера актьорство, cinema acting, драматичен театър и бакалавърска степен по психология от Софийския университет „Св. Климент Охридски“. Сред екранните ѝ участия са „Blurred“, „High Fashion High Tension“, „Bloody Merry Christmas“, „Runway Reels – Fashion on Film“, „The Sect Of The Phoenix“, „Digital Asylum“, „Snowcrawler“ и телевизионният сериал „Белези“, включително главни роли и day-player участия.',
    skills: 'Моделинг, карате, жиу-жицу, сценичен бой, voice-over, пилатес, стрелба с пистолет, поп пеене, йога, волейбол, шофиране, фехтовка, конна езда',
    languages: 'Български – роден език; английски – професионално ниво',
    availability: 'При предварително уточнение',
    education: 'Ивана Чъбак техника – Film Forge, Nu Boyana; stunt course – Nu Boyana Film Studios; self-tape, audition techniques and the business of acting – Julian Kostov; Anthony Meindl’s Actor Workshop – Chicago; Acting Studio 360 с Елена Петрова; New Actors Studio; НАТФИЗ „Кръстьо Сарафов“; бакалавър по психология – Софийски университет „Св. Климент Охридски“',
    gallery: [
      '/pictures/actors/lyubomira-hristova/lhprofilepremium.png',
      '/pictures/actors/lyubomira-hristova/lhprofilepremium0.png',
      '/pictures/actors/lyubomira-hristova/lhprofilepremium1.png',
      '/pictures/actors/lyubomira-hristova/lhprofilepremium2.png',
      '/pictures/actors/lyubomira-hristova/lhprofilepremium3.png',
      '/pictures/actors/lyubomira-hristova/lhprofilepremium4.png',
      '/pictures/actors/lyubomira-hristova/lhprofilepremium5.png',
      '/pictures/actors/lyubomira-hristova/lhprofilepremium6.png',
      '/pictures/actors/lyubomira-hristova/lhprofilepremium7.png',
      '/pictures/actors/lyubomira-hristova/lhprofilepremium8.png',
    ],
  },
  {
    id: 18,
    name: 'Емили Влайкова',
    category: 'Професионални актьори',
    photo: '/pictures/actors/emily-vlaykova/evprofilepremium.png',
    hoverVideo: null,
    isPremium: true,
    gender: 'Жена',
    age: 24,
    screenAge: '19–26',
    region: 'София',
    hairColor: 'Руса коса',
    height: 165,
    eyes: 'Зелени',
    experience: 'Емили Влайкова е професионална актриса, модел и танцьорка с образование и практически опит в България, Великобритания и Съединените щати. Притежава бакалавърска степен от University of Derby и магистърска степен от НАТФИЗ „Кръстьо Сарафов“. Допълнително се е обучавала във Film Forge Nu Boyana, The Lee Strasberg Theatre and Film Institute и Marinov Actor’s Studio в Лос Анджелис. Има главни роли в късометражни филми, музикални клипове и реклами, както и участия в телевизионни предавания и концерти в България и чужбина. Сред проектите ѝ са „Fallaway“, „The Price of Truth“, „Viral Dawn“, „High Fashion High Tension“, „Хващаме бас“, „Единствена“ и „Белези“. Емили е деветкратен шампион на България по спортни танци и десет последователни години е била първенец в националната ранглиста.',
    skills: 'Танци в различни стилове, тенис, плуване, ски, футбол, баскетбол, волейбол, ролкови кънки, зимни кънки, боравене с огнестрелно оръжие, шофьорска книжка категория B, скейтборд',
    languages: 'Български, английски, немски, сръбски',
    availability: 'При предварително уточнение',
    education: 'University of Derby; магистърска степен от НАТФИЗ; Film Forge Nu Boyana; The Lee Strasberg Theatre and Film Institute; Marinov Actor’s Studio',
    gallery: [
      '/pictures/actors/emily-vlaykova/evprofilepremium.png',
      '/pictures/actors/emily-vlaykova/evgallerypremium0.png',
      '/pictures/actors/emily-vlaykova/evgallerypremium1.png',
      '/pictures/actors/emily-vlaykova/evgallerypremium2.png',
      '/pictures/actors/emily-vlaykova/evgallerypremium3.png',
      '/pictures/actors/emily-vlaykova/evgallerypremium4.png',
      '/pictures/actors/emily-vlaykova/evgallerypremium5.png',
      '/pictures/actors/emily-vlaykova/evgallerypremium6.png',
      '/pictures/actors/emily-vlaykova/evgallerypremium7.png',
    ],
  },
  {
    id: 1,
    name: 'Гергана Иванова',
    category: 'Професионални актьори',
    photo: '/pictures/actors/gergana-ivanova/giprofile.jpg',
    hoverVideo: null,
    isPremium: true,
    gender: 'Жена',
    age: 17,
    screenAge: '15–19',
    region: 'София',
    hairColor: 'Тъмночервена коса',
    height: 173,
    eyes: 'Пъстри',
    experience: 'Гергана Иванова е млада актриса с практически опит в киното и телевизията. Участвала е в три филма и два телевизионни сериала, като ѝ предстои четвърто филмово участие. Продължава активно да развива актьорските си умения и да разширява своята филмография.',
    skills: '',
    languages: 'Български',
    availability: 'При предварително уточнение',
    gallery: [
      '/pictures/actors/gergana-ivanova/giprofile.jpg',
      '/pictures/actors/gergana-ivanova/gigallery.jpg',
      '/pictures/actors/gergana-ivanova/gigallery1.jpg',
      '/pictures/actors/gergana-ivanova/gigallery2.jpg',
      '/pictures/actors/gergana-ivanova/gigallery3.jpg',
      '/pictures/actors/gergana-ivanova/gigallery4.jpg',
      '/pictures/actors/gergana-ivanova/gigallery5.jpg',
      '/pictures/actors/gergana-ivanova/gigallery6.jpg',
    ],
  },
  {
    id: 13,
    name: 'Спас Ангелов',
    category: 'Професионални актьори',
    photo: '/pictures/actors/spas-angelov/saprofile.png',
    hoverVideo: null,
    isPremium: false,
    gender: 'Мъж',
    age: 19,
    screenAge: '17–21',
    region: 'Чирпан',
    hairColor: 'Руса коса',
    height: 180,
    eyes: 'Пъстри',
    experience: 'Спас Ангелов има опит в киното, телевизията и театъра. Участвал е в продукциите „Вече играеш Стоичков“, „Кралят на улицата“, „Един грам живот“ и „Вампирите от Норич“, както и в множество главни мъжки роли в театрални постановки. Завършил е паралелка „Софтуерни и хардуерни науки“ в СУ „П. К. Яворов“ – Чирпан и е студент в НАТФИЗ.',
    skills: 'Пеене, свирене на китара, програмиране, видеоигри',
    languages: 'Български',
    availability: 'При предварително уточнение',
    education: 'Студент в НАТФИЗ, клас на Здравко Митков',
    gallery: [
      '/pictures/actors/spas-angelov/saprofile.png',
      '/pictures/actors/spas-angelov/sagallery.png',
      '/pictures/actors/spas-angelov/sagallery1.png',
      '/pictures/actors/spas-angelov/sagallery2.png',
      '/pictures/actors/spas-angelov/sagallery3.png',
    ],
  },
  {
    id: 9,
    name: 'Виктория Петрова',
    category: 'Професионални актьори',
    photo: '/pictures/actors/viktoriya-petrova/vpprofile.png',
    hoverVideo: null,
    isPremium: false,
    gender: 'Жена',
    age: 16,
    screenAge: '15–19',
    region: 'Божурище',
    hairColor: 'Тъмноруса коса',
    height: 177,
    eyes: 'Пъстри',
    experience: 'Виктория Петрова се занимава професионално с актьорско майсторство от седем години и има богат опит пред камера и на професионална снимачна площадка. Участвала е в български и международни продукции, сред които сериалите „Децата на времето“ и „Под прикритие“, както и американската продукция „One Second After“. Работила е като stand-in в международни филмови продукции, включително за актрисата Ella McCutcheon. Има участия в международни рекламни кампании за FIFA и Saint Laurent, както и опит в модни фотосесии, рекламни проекти и билборд кампании. Развива се и като режисьор, като е създала и режисирала три късометражни филма, в които участва и като актриса.',
    skills: '',
    languages: 'Български',
    availability: 'При предварително уточнение',
    gallery: [
      '/pictures/actors/viktoriya-petrova/vpprofile.png',
      '/pictures/actors/viktoriya-petrova/vpgallery.png',
      '/pictures/actors/viktoriya-petrova/vpgallery1.png',
      '/pictures/actors/viktoriya-petrova/vpgallery2.png',
      '/pictures/actors/viktoriya-petrova/vpgallery3.png',
    ],
  },
  {
    id: 23,
    name: 'Селена Гайдова',
    category: 'Нови лица',
    photo: '/pictures/actors/selena-gaydova/seprofile.png',
    hoverVideo: null,
    isPremium: false,
    gender: 'Жена',
    age: 22,
    screenAge: '18–22',
    region: 'Пазарджик',
    hairColor: 'Променлив цвят на косата',
    height: 162,
    eyes: 'Кафяви',
    experience: 'Селена Гайдова е от Пазарджик и има практически опит пред камера с участия в три филма, два кратки сериала и различни рекламни продукции. Почти през целия си живот се занимава с музика и танци, а през последните близо две години развива активно и актьорските си умения. Пеенето и танците са основна част от артистичната ѝ подготовка и сценично присъствие.',
    skills: 'Пеене, танци',
    languages: 'Български',
    availability: 'При предварително уточнение',
    education: 'Средно образование',
    gallery: [
      '/pictures/actors/selena-gaydova/seprofile.png',
      '/pictures/actors/selena-gaydova/segallery.png',
      '/pictures/actors/selena-gaydova/segallery1.png',
      '/pictures/actors/selena-gaydova/segallery2.png',
      '/pictures/actors/selena-gaydova/segallery3.png',
    ],
  },
  {
    id: 12,
    name: 'Дария Мочукова',
    category: 'Нови лица',
    photo: '/pictures/actors/dariya-mochukova/dmprofile.png',
    hoverVideo: null,
    isPremium: false,
    gender: 'Жена',
    age: 14,
    screenAge: '12–16',
    region: 'с. Марково',
    hairColor: 'Кафява коса',
    height: 160,
    eyes: 'Кафяви',
    experience: 'Дария Мочукова е младо ново лице с практически опит пред камера. Изпълнява главната женска роля в сериала „Кралят на улицата“. Мотивирана е да продължава развитието си и да участва в нови филмови, телевизионни и рекламни продукции.',
    skills: '',
    languages: 'Български',
    availability: 'При предварително уточнение',
    gallery: [
      '/pictures/actors/dariya-mochukova/dmprofile.png',
      '/pictures/actors/dariya-mochukova/dmgallery.png',
      '/pictures/actors/dariya-mochukova/dmgallery1.png',
      '/pictures/actors/dariya-mochukova/dmgallery2.png',
      '/pictures/actors/dariya-mochukova/dmgallery3.png',
    ],
  },
  {
    id: 2,
    name: 'Мартин Валериев',
    category: 'Професионални актьори',
    photo: '/pictures/actors/martin-valeriev/mvprofile.png',
    hoverVideo: null,
    isPremium: false,
    gender: 'Мъж',
    age: 18,
    screenAge: '16–20',
    region: 'Перник',
    hairColor: 'Светла коса',
    height: 176,
    eyes: 'Пъстри',
    experience: 'Мартин Валериев има опит в реклами, филми, телевизионни сериали и рекламни кампании за социалните мрежи. Чувства се естествено и уверено пред камера и има практически опит в работата с професионални снимачни екипи. Завършил е средно образование с професионална квалификация „Компютърен график“ и е студент по „Филмова и телевизионна режисура“ в Югозападния университет „Неофит Рилски“.',
    skills: '',
    languages: 'Български',
    availability: 'При предварително уточнение',
    gallery: [
      '/pictures/actors/martin-valeriev/mvprofile.png',
      '/pictures/actors/martin-valeriev/mvgallery.png',
      '/pictures/actors/martin-valeriev/mvgallery1.png',
      '/pictures/actors/martin-valeriev/mvgallery2.png',
    ],
  },
  {
    id: 3,
    name: 'Стефан Славчев',
    category: 'Нови лица',
    photo: '/pictures/actors/stefan-slavchev/ssprofile.png',
    hoverVideo: null,
    isPremium: false,
    gender: 'Мъж',
    age: 18,
    screenAge: '16–20',
    region: 'София',
    hairColor: 'Тъмна коса',
    height: 193,
    eyes: 'Пъстри',
    experience: 'Стефан Славчев е младо ново лице с опит от участие в телевизионен сериал. Чувства се уверен пред камера и е отворен към разнообразни актьорски предизвикателства. Енергичният му характер и високият му ръст го правят подходящ за динамични роли и персонажи със силно физическо присъствие.',
    skills: '',
    languages: 'Български',
    availability: 'При предварително уточнение',
    gallery: [
      '/pictures/actors/stefan-slavchev/ssprofile.png',
      '/pictures/actors/stefan-slavchev/ssgallery.png',
      '/pictures/actors/stefan-slavchev/ssgallery1.png',
    ],
  },
  {
    id: 25,
    name: 'Михаил Николов',
    category: 'Нови лица',
    photo: '/pictures/actors/mihail-nikolov/mnprofile.png',
    hoverVideo: null,
    isPremium: false,
    gender: 'Мъж',
    age: 17,
    screenAge: '16–20',
    region: 'Димитровград',
    hairColor: 'Черна коса',
    height: 190,
    eyes: 'Кафяви',
    experience: 'Михаил Николов е млад актьор от Димитровград с участия в проектите „Скандалните“, „Един грам живот“ и „Кралят на улицата“. В момента се обучава за втора година в кино академия, а преди това е посещавал театрална школа. Занимава се с актьорско майсторство от 11-годишна възраст, а музиката е част от живота му още от четиригодишен.',
    skills: 'Пиано, барабани',
    languages: 'Български',
    availability: 'При предварително уточнение',
    education: 'Втора година в кино академия; предходно обучение в театрална школа',
    gallery: [
      '/pictures/actors/mihail-nikolov/mnprofile.png',
      '/pictures/actors/mihail-nikolov/mngallery.png',
      '/pictures/actors/mihail-nikolov/mngallery1.png',
      '/pictures/actors/mihail-nikolov/mngallery2.png',
      '/pictures/actors/mihail-nikolov/mngallery3.png',
    ],
  },
  {
    id: 11,
    name: 'Симона Радева',
    category: 'Нови лица',
    photo: '/pictures/actors/simona-radeva/srprofile.png',
    hoverVideo: null,
    isPremium: false,
    gender: 'Жена',
    age: 16,
    screenAge: '14–18',
    region: 'София',
    hairColor: 'Кестенява коса',
    height: 157,
    eyes: 'Пъстри',
    experience: 'Симона Радева е младо ново лице от София с участия в продукциите „Един грам живот“ и „Скандалните“. От две години се обучава в кино академия за таланти. Като дете е работила и като модел, а интересът ѝ към камерата и визуалните изкуства я мотивира да продължава развитието си в киното и телевизията.',
    skills: '',
    languages: 'Български',
    availability: 'При предварително уточнение',
    education: 'Ученичка',
    gallery: [
      '/pictures/actors/simona-radeva/srprofile.png',
      '/pictures/actors/simona-radeva/srgallery.png',
      '/pictures/actors/simona-radeva/srgallery1.png',
      '/pictures/actors/simona-radeva/srgallery2.png',
      '/pictures/actors/simona-radeva/srgallery3.png',
    ],
  },
  {
    id: 19,
    name: 'Илияна Захариева',
    category: 'Нови лица',
    photo: '/pictures/actors/iliyana-zaharieva/izprofile.png',
    hoverVideo: null,
    isPremium: false,
    gender: 'Жена',
    age: 24,
    screenAge: '20–25',
    region: 'София',
    hairColor: 'Естествено тъмна коса с руси екстеншън кичури',
    height: 172,
    eyes: 'Светлокестеняви',
    experience: 'Илияна Захариева е родена в Дупница, а в момента живее в близост до София. Има практически опит пред камера, натрупан основно в американски продукции, рекламни проекти и масови сцени, заснемани в „Ню Бояна“. Работила е и по по-смели артистични сцени. Отворена е към различни персонажи, сюжети и творчески предизвикателства и подхожда към киното като към поле за артистично развитие. Развива активно присъствие в социалните мрежи и се чувства уверено пред камера и публика.',
    skills: 'Стендъп комедия и импровизирани комедийни монолози',
    languages: 'Български, английски, френски',
    availability: 'При предварително уточнение',
    education: 'В момента не учи',
    gallery: [
      '/pictures/actors/iliyana-zaharieva/izprofile.png',
      '/pictures/actors/iliyana-zaharieva/izgallery.png',
      '/pictures/actors/iliyana-zaharieva/izgallery1.png',
      '/pictures/actors/iliyana-zaharieva/izgallery2.png',
      '/pictures/actors/iliyana-zaharieva/izgallery3.png',
    ],
  },
  {
    id: 4,
    name: 'Виктория Ганева',
    category: 'Нови лица',
    photo: '/pictures/actors/viktoria-ganeva/vgprofile.png',
    hoverVideo: null,
    isPremium: false,
    gender: 'Жена',
    age: 17,
    screenAge: '15–19',
    region: 'Габрово',
    hairColor: 'Кафява коса',
    height: 160,
    eyes: 'Кафяви',
    experience: 'Виктория Ганева е ново лице от Габрово, което прави първите си стъпки в актьорското изкуство. Все още няма професионален актьорски опит, но проявява силен интерес към работата пред камера и желание да придобива нови практически умения. Мотивирана е да се развива и да участва във филмови, телевизионни, рекламни и музикални продукции.',
    skills: '',
    languages: 'Български',
    availability: 'При предварително уточнение',
    gallery: [
      '/pictures/actors/viktoria-ganeva/vgprofile.png',
      '/pictures/actors/viktoria-ganeva/vggallery.png',
      '/pictures/actors/viktoria-ganeva/vggallery1.png',
    ],
  },
  {
    id: 5,
    name: 'Габриела Ненова',
    category: 'Професионални актьори',
    photo: '/pictures/actors/gabriela-nenova/gnprofile.png',
    hoverVideo: null,
    isPremium: false,
    gender: 'Жена',
    age: 16,
    screenAge: '14–18',
    region: 'Благоевград',
    hairColor: 'Тъмноруса коса',
    height: 167,
    eyes: 'Пъстри',
    experience: 'Габриела Ненова е млада актриса с практически опит в продукциите „Един грам живот“, „Скандалните“ и „Страшен филм“. Родена е в Дупница, а в момента живее в Благоевград. Киното и театърът са нейна голяма творческа страст и тя е мотивирана да продължава професионалното си развитие пред камера.',
    skills: 'Танци, пеене, волейбол, тенис',
    languages: 'Български',
    availability: 'При предварително уточнение',
    gallery: [
      '/pictures/actors/gabriela-nenova/gnprofile.png',
      '/pictures/actors/gabriela-nenova/gngallery.png',
      '/pictures/actors/gabriela-nenova/gngallery1.png',
      '/pictures/actors/gabriela-nenova/gngallery2.png',
    ],
  },
  {
    id: 6,
    name: 'Красимир Кюмурков',
    category: 'Нови лица',
    photo: '/pictures/actors/krasimir-kyumurkov/kkprofile.png',
    hoverVideo: null,
    isPremium: false,
    gender: 'Мъж',
    age: 43,
    screenAge: '41–45',
    region: 'Радомир',
    hairColor: 'Черна коса',
    height: 178,
    eyes: 'Сини',
    experience: 'Красимир Кюмурков има практически опит пред камера от участия в късометражен образователен филм и няколко рекламни продукции. Късометражният проект е насочен към превенция на интернет измами и финансови пирамиди сред учениците в България. Участвал е и в реклама за социалните мрежи на Karam.bg, както и в две допълнителни рекламни продукции, които предстои да бъдат публично излъчени.',
    skills: 'Шофьорска книжка',
    languages: 'Български',
    availability: 'При предварително уточнение',
    education: 'Средно специално образование',
    gallery: [
      '/pictures/actors/krasimir-kyumurkov/kkprofile.png',
      '/pictures/actors/krasimir-kyumurkov/kkgallery.png',
      '/pictures/actors/krasimir-kyumurkov/kkgallery1.png',
      '/pictures/actors/krasimir-kyumurkov/kkgallery2.png',
    ],
  },
  {
    id: 7,
    name: 'Стоян Господинов',
    category: 'Нови лица',
    photo: '/pictures/actors/stoyan-gospodinov/sgprofile.png',
    hoverVideo: null,
    isPremium: false,
    gender: 'Мъж',
    age: 24,
    screenAge: '22–26',
    region: 'Шивачево, област Сливен',
    hairColor: 'Черна коса',
    height: 170,
    eyes: 'Кафяви',
    experience: 'Стоян Господинов е професионален музикант, диригент, педагог и композитор с богата сценична и творческа дейност. Завършва НУФИ „Филип Кутев“ в Котел със специалност „Гъдулка“, след което придобива бакалавърска степен по „Музика“ и магистърска степен по „Ръководство на вокални и инструментални състави с дирижиране и гъдулка“ в Пловдивския университет „Паисий Хилендарски“. Той е основател, ръководител и вокалист на Формация „Котел“. Няма предишен актьорски опит, но притежава значителен сценичен и студиен опит.',
    skills: 'Пеене, свирене на гъдулка, композиране, музикално аранжиране, дирижиране',
    languages: 'Български',
    availability: 'При предварително уточнение',
    education: 'Висше образование',
    gallery: [
      '/pictures/actors/stoyan-gospodinov/sgprofile.png',
      '/pictures/actors/stoyan-gospodinov/sggallery.png',
    ],
  },
  {
    id: 8,
    name: 'Виталий Брадичев',
    category: 'Нови лица',
    photo: '/pictures/actors/vitaliy-bradichev/vbprofile.png',
    hoverVideo: null,
    isPremium: false,
    gender: 'Мъж',
    age: 15,
    screenAge: '14–17',
    region: 'Златоград',
    hairColor: 'Кафява коса',
    height: 184,
    eyes: 'Пъстри',
    experience: 'Виталий Брадичев е младо и силно мотивирано ново лице от Златоград. Роден е в София, но още като дете се премества със семейството си в Златоград. Има сценичен опит от участия в училищни пиеси и сценки. Мечтае да стане професионален актьор и е мотивиран да развива уменията си, да трупа практически опит и да участва във филмови, телевизионни и рекламни продукции.',
    skills: 'Футбол, волейбол, видеоигри',
    languages: 'Български',
    availability: 'При предварително уточнение',
    gallery: [
      '/pictures/actors/vitaliy-bradichev/vbprofile.png',
      '/pictures/actors/vitaliy-bradichev/vbgallery.png',
      '/pictures/actors/vitaliy-bradichev/vbgallery1.png',
    ],
  },
  {
    id: 10,
    name: 'Калина Трифонова',
    category: 'Професионални актьори',
    photo: '/pictures/actors/kalina-trifonova/ktprofile.png',
    hoverVideo: null,
    isPremium: false,
    gender: 'Жена',
    age: 19,
    screenAge: '17–21',
    region: 'Пловдив / Бургас',
    hairColor: 'Тъмноруса коса',
    height: 175,
    eyes: 'Зелени',
    experience: 'Калина Трифонова има практически опит пред камера с участия в продукциите „Русалки“, „Един грам живот“, „Мераклии“, „Вампирите от Норич“ и българо-американска продукция. От тази година предстои да продължи професионалното си обучение в НАТФИЗ. Има интерес към киното, телевизията и сценичните изкуства и е мотивирана да развива актьорската си кариера.',
    skills: 'Латино танци, спортни танци, модерен балет, народни танци, плуване',
    languages: 'Български',
    availability: 'При предварително уточнение',
    education: 'Предстоящо обучение в НАТФИЗ',
    gallery: [
      '/pictures/actors/kalina-trifonova/ktprofile.png',
      '/pictures/actors/kalina-trifonova/ktgallery.png',
      '/pictures/actors/kalina-trifonova/ktgallery1.png',
      '/pictures/actors/kalina-trifonova/ktgallery2.png',
      '/pictures/actors/kalina-trifonova/ktgallery3.png',
    ],
  },
  {
    id: 14,
    name: 'Александра Петкова',
    category: 'Нови лица',
    photo: '/pictures/actors/aleksandra-petkova/approfile.png',
    hoverVideo: null,
    isPremium: false,
    gender: 'Жена',
    age: 20,
    screenAge: '18–22',
    region: 'София',
    hairColor: 'Тъмнокестенява коса',
    height: 174,
    eyes: 'Черни',
    experience: 'Александра Петкова е родена в Стара Загора, а в момента живее в София. Като дете участва в театрална трупа и има опит в рекламни продукции. Следва „Комуникационен мениджмънт“ в Софийския университет „Св. Климент Охридски“. Натрупва практически опит в телевизионната среда като стажант-репортер в bTV, където развива уменията си в журналистиката, комуникацията и работата пред камера.',
    skills: 'Рисуване, танци',
    languages: 'Български',
    availability: 'При предварително уточнение',
    education: 'Студентка в Софийския университет „Св. Климент Охридски“, специалност „Комуникационен мениджмънт“',
    gallery: [
      '/pictures/actors/aleksandra-petkova/approfile.png',
      '/pictures/actors/aleksandra-petkova/apgallery.png',
      '/pictures/actors/aleksandra-petkova/apgallery1.png',
      '/pictures/actors/aleksandra-petkova/apgallery2.png',
      '/pictures/actors/aleksandra-petkova/apgallery3.png',
    ],
  },
  {
    id: 15,
    name: 'Георги Драганов',
    category: 'Нови лица',
    photo: '/pictures/actors/georgi-draganov/gdprofile.png',
    hoverVideo: null,
    isPremium: false,
    gender: 'Мъж',
    age: 34,
    screenAge: '32–36',
    region: 'София',
    hairColor: 'Руса коса / бръсната глава',
    height: 174,
    eyes: 'Сини',
    experience: 'Георги Драганов живее в София и се обучава в Кино академия за таланти. Има практически опит пред камера с участия в сериалите „Наем под напрежение“ и „Кралят на улицата“. Извън актьорството се развива като брокер на недвижими имоти и се отличава с комуникативност, адаптивност и лекота в работата с различни хора.',
    skills: 'Управление на мотоциклет, гребане с каяк',
    languages: 'Български',
    availability: 'При предварително уточнение',
    education: 'Средно специално образование',
    gallery: [
      '/pictures/actors/georgi-draganov/gdprofile.png',
      '/pictures/actors/georgi-draganov/gdgallery.png',
      '/pictures/actors/georgi-draganov/gdgallery1.png',
      '/pictures/actors/georgi-draganov/gdgallery2.png',
      '/pictures/actors/georgi-draganov/gdgallery3.png',
    ],
  },
  {
    id: 16,
    name: 'Антон Величков',
    category: 'Професионални актьори',
    photo: '/pictures/actors/anton-velichkov/avprofile.png',
    hoverVideo: null,
    isPremium: false,
    gender: 'Мъж',
    age: 29,
    screenAge: '25–29',
    region: 'София',
    hairColor: 'Тъмноруса коса',
    height: 180,
    eyes: 'Кехлибарени',
    experience: 'Антон Величков е актьор с опит в телевизионни и онлайн реклами, рекламни кампании и различни кинопроекти. Обучавал се е в школа „Арлекин“ – Варна. Чувства се уверено пред камера и подхожда към работата си с дисциплина, професионално отношение и способност бързо да изгражда различни образи.',
    skills: 'Каскадьорски изпълнения, акробатични салта, танци, плуване, шофиране',
    languages: 'Български',
    availability: 'При предварително уточнение',
    education: 'Школа „Арлекин“ – Варна',
    gallery: [
      '/pictures/actors/anton-velichkov/avprofile.png',
      '/pictures/actors/anton-velichkov/avgallery.png',
      '/pictures/actors/anton-velichkov/avgallery1.png',
      '/pictures/actors/anton-velichkov/avgallery2.png',
      '/pictures/actors/anton-velichkov/avgallery3.png',
    ],
  },
  {
    id: 17,
    name: 'Ванеса Мазгалова',
    category: 'Нови лица',
    photo: '/pictures/actors/vanesa-mazgalova/vmprofile.png',
    hoverVideo: null,
    isPremium: false,
    gender: 'Жена',
    age: 16,
    screenAge: '16–20',
    region: 'София',
    hairColor: 'Кафява с руси кичури',
    height: 174,
    eyes: 'Кафяви',
    experience: 'Ванеса Мазгалова е родена в Сандански, а в момента живее в София. Започва да се занимава с актьорско майсторство на 11-годишна възраст и има практически опит от участия в театрални представления, реклами и късометражни филми. Тренирала е хип-хоп танци, народни танци и волейбол. В момента изучава интериорен дизайн и италиански език в ПГД „Елисавета Вазова“.',
    skills: 'Хип-хоп танци, народни танци, волейбол',
    languages: 'Български, италиански',
    availability: 'При предварително уточнение',
    education: 'Интериорен дизайн и италиански език в ПГД „Елисавета Вазова“',
    gallery: [
      '/pictures/actors/vanesa-mazgalova/vmprofile.png',
      '/pictures/actors/vanesa-mazgalova/vmgallery.png',
      '/pictures/actors/vanesa-mazgalova/vmgallery1.png',
      '/pictures/actors/vanesa-mazgalova/vmgallery2.png',
      '/pictures/actors/vanesa-mazgalova/vmgallery3.png',
    ],
  },
  {
    id: 20,
    name: 'Ивана Стоянова',
    category: 'Нови лица',
    photo: '/pictures/actors/ivana-stoyanova/isprofile.png',
    hoverVideo: null,
    isPremium: false,
    gender: 'Жена',
    age: 22,
    screenAge: '20–24',
    region: 'София',
    hairColor: 'Червена коса',
    height: 158,
    eyes: 'Кафяви',
    experience: 'Ивана Стоянова е родена и израснала във Враца, а в момента живее в София. Започва да се занимава с актьорско майсторство на 19-годишна възраст. Обучавала се е в две театрални школи, а в момента продължава подготовката си в школа по киноактьорско майсторство. Има практически опит пред камера от участията си в пет късометражни филма.',
    skills: 'Танци, огнено изкуство, скейтборд, пеене',
    languages: 'Български',
    availability: 'При предварително уточнение',
    gallery: [
      '/pictures/actors/ivana-stoyanova/isprofile.png',
      '/pictures/actors/ivana-stoyanova/isgallery.png',
      '/pictures/actors/ivana-stoyanova/isgallery1.png',
      '/pictures/actors/ivana-stoyanova/isgallery2.png',
      '/pictures/actors/ivana-stoyanova/isgallery3.png',
    ],
  },
  {
    id: 21,
    name: 'Кристиан Дичков',
    category: 'Нови лица',
    photo: '/pictures/actors/kristian-dichkov/kdprofile.png',
    hoverVideo: null,
    isPremium: false,
    gender: 'Мъж',
    age: 26,
    screenAge: '24–28',
    region: 'Добрич',
    hairColor: 'Черна коса',
    height: 175,
    eyes: 'Кафяви',
    experience: 'Кристиан Дичков е ново лице от град Добрич. Има първи практически опит пред камера с участие като охрана в сцена в билярден бар във филма „Бягай“. Желае да продължава да трупа опит и да се включва в нови филмови, телевизионни и рекламни продукции.',
    skills: '',
    languages: 'Български',
    availability: 'При предварително уточнение',
    gallery: [
      '/pictures/actors/kristian-dichkov/kdprofile.png',
      '/pictures/actors/kristian-dichkov/kdgallery.png',
      '/pictures/actors/kristian-dichkov/kdgallery1.png',
      '/pictures/actors/kristian-dichkov/kdgallery2.png',
      '/pictures/actors/kristian-dichkov/kdgallery3.png',
    ],
  },
  {
    id: 22,
    name: 'Рая Заркова',
    category: 'Нови лица',
    photo: '/pictures/actors/raya-zarkova/rzprofile.png',
    hoverVideo: null,
    isPremium: false,
    gender: 'Жена',
    age: 15,
    screenAge: '13–17',
    region: 'София',
    hairColor: 'Кестенява коса',
    height: 155,
    eyes: 'Кафяви',
    experience: 'Рая Заркова е младо ново лице от София с опит на сцена от участия в спектакли на актьорски клас и училищни празници. Има интерес към актьорското изкуство и желае да продължава да развива сценичното си присъствие и уменията си пред камера. Освен с актьорство, Рая се занимава с писане на стихотворения, чрез което развива творческото си мислене и умението си да изразява различни емоции и идеи.',
    skills: 'Писане на стихотворения',
    languages: 'Български',
    availability: 'При предварително уточнение',
    gallery: [
      '/pictures/actors/raya-zarkova/rzprofile.png',
      '/pictures/actors/raya-zarkova/rzgallery.png',
      '/pictures/actors/raya-zarkova/rzgallery1.png',
      '/pictures/actors/raya-zarkova/rzgallery2.png',
      '/pictures/actors/raya-zarkova/rzgallery3.png',
    ],
  },
  {
    id: 24,
    name: 'Калоян Христов',
    category: 'Нови лица',
    photo: '/pictures/actors/kaloyan-hristov/khprofile.png',
    hoverVideo: null,
    isPremium: false,
    gender: 'Мъж',
    age: 18,
    screenAge: '15–19',
    region: 'Габрово',
    hairColor: 'Руса коса',
    height: 178,
    eyes: 'Сини',
    experience: 'Калоян Христов е млад актьор от Габрово с участия в проектите „Краля на улиците“, „Един грам живот“ и „One Second After“. Определя се като усмихнат човек с чувство за хумор и самоирония. Интересува се от психология и теми, свързани с човешкия ум. От 12 години се занимава с български народни танци, което му дава богат сценичен опит и увереност пред публика.',
    skills: 'Български народни танци',
    languages: 'Български',
    availability: 'При предварително уточнение',
    education: 'Ученик',
    gallery: [
      '/pictures/actors/kaloyan-hristov/khprofile.png',
      '/pictures/actors/kaloyan-hristov/khgallery.png',
      '/pictures/actors/kaloyan-hristov/khgallery1.png',
      '/pictures/actors/kaloyan-hristov/khgallery2.png',
      '/pictures/actors/kaloyan-hristov/khgallery3.png',
    ],
  },
  {
    id: 26,
    name: 'Моника Савова',
    category: 'Професионални актьори',
    photo: '/pictures/actors/monika-savova/msprofile.png',
    hoverVideo: null,
    isPremium: false,
    gender: 'Жена',
    age: 16,
    screenAge: '15–19',
    region: 'Варна',
    hairColor: 'Кестенява коса',
    height: 172,
    eyes: 'Кестеняви',
    experience: 'Моника Савова е млада актриса от Варна, която се занимава с актьорско майсторство от ранна детска възраст. Посещавала е театрална агенция и има практически опит пред камера с участия в два филма и музикални видеоклипове. Проявява силен интерес към модата и актьорското изкуство и е мотивирана да продължава да се развива във филмови, телевизионни и визуални продукции.',
    skills: '',
    languages: 'Български',
    availability: 'При предварително уточнение',
    education: 'Обучение по актьорско майсторство в театрална агенция',
    gallery: [
      '/pictures/actors/monika-savova/msprofile.png',
      '/pictures/actors/monika-savova/msgallery.png',
      '/pictures/actors/monika-savova/msgallery1.png',
      '/pictures/actors/monika-savova/msgallery2.png',
      '/pictures/actors/monika-savova/msgallery3.png',
    ],
  },
  {
    id: 27,
    name: 'Габриел Асенов',
    category: 'Нови лица',
    photo: '/pictures/actors/gabriel-asenov/gagallery.png',
    hoverVideo: null,
    isPremium: false,
    gender: 'Мъж',
    age: 36,
    screenAge: '34–38',
    region: 'Елин Пелин',
    hairColor: 'Тъмнокестенява коса',
    height: 177,
    eyes: 'Пъстри',
    experience: 'Габриел Асенов е ново лице от град Елин Пелин, което прави първите си стъпки пред камера. Определя житейския си опит като своя най-голяма школа и подхожда към актьорството с естественост, открито отношение и желание да се развива.',
    skills: '',
    languages: 'Български',
    availability: 'При предварително уточнение',
    education: 'Средно образование',
    gallery: [
      '/pictures/actors/gabriel-asenov/gagallery.png',
      '/pictures/actors/gabriel-asenov/gagallery1.png',
      '/pictures/actors/gabriel-asenov/gagallery2.png',
      '/pictures/actors/gabriel-asenov/gagallery3.png',
      '/pictures/actors/gabriel-asenov/gagallery4.png',
    ],
  },

];

// ---------------------------------------------------------
// 4. ДАННИ ЗА ОТЗИВИ
// ---------------------------------------------------------
const testimonials = [
  { quote: "Благодарение на MG Casting намерихме главния герой за нашия филм само за 2 дни. Изключителен професионализъм и бърза реакция.", author: "Режисьор на пълнометражен филм" },
  { quote: "Най-добрата база данни, с която сме работили. Винаги получаваме точно селектирани предложения, които отговарят на 100% на брифа.", author: "Кастинг директор" },
  { quote: "Процесът е толкова улеснен! Актьорите идват подготвени, а комуникацията с агенцията е безпроблемна. Препоръчвам горещо.", author: "Продуцент на реклами и видеоклипове" }
];

// ---------------------------------------------------------
// УМЕН КОМПОНЕНТ ЗА СКРОЛ
// ---------------------------------------------------------

// =========================================================
// MG CASTING — PRODUCTION-READY FRONTEND REWRITE
// =========================================================
// Runtime configuration can be injected before the React bundle:
// window.__MG_CASTING_CONFIG__ = {
//   verifyCheckoutEndpoint: '/api/stripe/verify-session',
//   generalInquiryEndpoint: '/api/forms/contact',
//   actorInquiryEndpoint: '/api/forms/actor-inquiry',
//   customerPortalUrl: 'https://billing.stripe.com/p/login/...'
// };

/**
 * Optional runtime configuration injected before the React bundle loads.
 * Bracket notation prevents IDEs from treating the custom window property as unresolved.
 * @type {{
 *   verifyCheckoutEndpoint?: string,
 *   generalInquiryEndpoint?: string,
 *   actorInquiryEndpoint?: string,
 *   customerPortalUrl?: string
 * }}
 */
const RUNTIME_CONFIG = typeof window !== 'undefined'
    ? (window['__MG_CASTING_CONFIG__'] || {})
    : {};

const SITE = {
  name: 'MG Casting',
  domain: 'https://mgcasting.com',
  email: 'teenscenetalkshow@gmail.com',
  phoneDisplay: '+359 876 393 940',
  phoneHref: '+359876393940',
  logo: '/logomg.png',
  shareImage: 'https://mgcasting.com/images/mg-casting-share.jpg',
  legalName: '„ДЕМА ФИЛМ“ ООД',
  eik: '205529116',
  address: 'гр. Елин Пелин',
  manager: 'Максим Колев Генчев',
};

const API_ENDPOINTS = {
  verifyCheckout: RUNTIME_CONFIG.verifyCheckoutEndpoint || '',
  customerPortal: RUNTIME_CONFIG.customerPortalUrl || '',
};

const CHECKOUT_PRODUCTS = {
  standard: {
    stripeUrl: STRIPE_LINKS.standardSubscription,
    title: 'Стандартен актьорски профил',
    kind: 'subscription',
    successTitle: 'Стандартният ти профил е заявен',
    successText: 'До 24 часа ще се свържем с теб на имейла от плащането, за да получим снимките, биографията и данните за профила.',
  },
  premium: {
    stripeUrl: STRIPE_LINKS.premiumSubscription,
    title: 'Премиум актьорски профил',
    kind: 'subscription',
    successTitle: 'Премиум присъствието ти започва',
    successText: 'До 24 часа ще се свържем с теб за снимките, видео визитката и краткото видео, което ще се показва в каталога.',
  },
  beginner: {
    stripeUrl: STRIPE_LINKS.beginnerCourse,
    title: 'Актьорско майсторство за начинаещи',
    kind: 'course',
    successTitle: 'Мястото ти е заявено',
    successText: 'Ще получиш имейл с потвърждение, график, платформа за онлайн занятията и необходимата подготовка преди първата среща.',
  },
  advanced: {
    stripeUrl: STRIPE_LINKS.advancedCourse,
    title: 'Актьорско майсторство за напреднали',
    kind: 'course',
    successTitle: 'Записването ти е получено',
    successText: 'Екипът ще се свърже с теб за потвърждение на нивото, графика и подготовката за първото занятие.',
  },
  exam: {
    stripeUrl: STRIPE_LINKS.examPrepCourse,
    title: 'Академична подготовка',
    kind: 'course',
    successTitle: 'Подготовката ти започва',
    successText: 'Ще се свържем с теб за първоначална консултация, подбор на материал и разпределение в подходяща група.',
  },
};

const actorProfiles = actorsList.map((actor) => ({
  ...actor,
  slug: actor.slug || `${actor.id}-${actor.name.toLowerCase().replace(/[^a-zа-я0-9]+/gi, '-').replace(/^-|-$/g, '')}`,
  screenAge: actor.screenAge || `${Math.max(1, actor.age - 2)}–${actor.age + 2}`,
  languages: actor.languages || 'Български',
  showreel: actor.showreel || actor.hoverVideo || null,
  availability: actor.availability || 'При предварително уточнение',
}));

const castingOffers = [
  { project: 'Пълнометражен исторически филм', lookingFor: 'Мъже (25–40 г.) с опит в ездата' },
  { project: 'Музикален видеоклип', lookingFor: 'Танцьори и статисти (18–25 г.)' },
  { project: 'ТВ реклама на спортен бранд', lookingFor: 'Спортисти и атлетични лица (20–35 г.)' },
  { project: 'Нов тийн сериал', lookingFor: 'Момчета и момичета (15–19 г.) за главни роли' },
];

const INSTRUCTOR = {
  name: 'Максим Генчев',
  photo: '/pictures/acting/мг1.png',
  role: 'Актьор, режисьор, сценарист и преподавател',
  biography: [
    'Максим Генчев е утвърдено име в българското кино и театър с дългогодишен професионален опит като актьор, режисьор, сценарист и творец с ярко присъствие в културния живот на България.',
    'Завършва ВИТИЗ „Кръстьо Сарафов“ в класа на проф. Крикор Азарян. Като актьор е работил на сцените на водещи български театри. Практическият му опит пред публика и камера изгражда силна основа в работата с актьора, сценичното поведение, партньорството и подготовката за кастинг.',
    'Като режисьор стои зад филми като „Дякон Левски“, „Ботев“, „Гераците“ и „Смартфонът беглец“. В обученията той предава не само техника, а реално познание за професията директно от сцената и снимачната площадка.',
  ],
};

const LEGAL_DOCUMENTS = JSON.parse(String.raw`[{"slug": "terms", "route": "/legal/terms", "title": "ОБЩИ УСЛОВИЯ ЗА ПОЛЗВАНЕ НА ПЛАТФОРМАТА „MG CASTING“", "updated": "Последна редакция: 20 юли 2026 г.", "intro": ["Настоящите Общи условия уреждат отношенията между „ДЕМА ФИЛМ“ ООД (наричано по-долу „Доставчик“ или „Организатор“) и всеки потребител, посетител, актьор или курсист (наричан по-долу „Потребител“/„Клиент“), използващ уебсайта и дигиталната платформа MG Casting (mgcasting.com)."], "sections": [{"heading": "I. ПРЕДМЕТ И ОБЩИ ПОЛОЖЕНИЯ", "paragraphs": ["1.1. Платформата MG Casting представлява специализиран дигитален каталог, информационен портал и среда за кастинг презентация, създадена и управлявана от нейните собственици Максим Генчев и Матей Генчев, чрез търговското дружество „ДЕМА ФИЛМ“ ООД.", "1.2. С влизането в сайта, създаването на профил, заплащането на абонамент или записването за обучение, Потребителят декларира, че е запознат, приема безусловно и се задължава да спазва настоящите Общи условия."]}, {"heading": "II. ДАННИ ЗА ДОСТАВЧИКА", "paragraphs": ["2.1. Наименование: „ДЕМА ФИЛМ“ ООД, ЕИК 205529116", "2.2. Седалище и адрес на управление: Република България, област София, община Елин Пелин, гр. Елин Пелин, п.к. 2100, бул. „Новоселци“ № 82", "2.3. Представляващ: Максим Колев Генчев – Управител", "2.4. Официален контакт за кореспонденция и правни въпроси: teenscenetalkshow@gmail.com, тел.: +359 876 393 940."]}, {"heading": "III. АКТЬОРСКИ ПРОФИЛИ И АБОНАМЕНТНИ ПЛАНОВЕ", "paragraphs": ["3.1. Платформата предоставя възможност за поддържане на актьорски профили срещу заплащане на месечна абонаментна такса по един от следните планове:", "Standard: Включва базово присъствие, структуриране и достъпност на профила в общия каталог на платформата.", "Premium: Включва приоритетно позициониране, отличителна визуална маркировка (златна значка) и възможност за интеграция на видео представяне (визитка/шоурийл), при условие че Клиентът е предоставил материали, отговарящи на техническите и естетическите стандарти на платформата.", "3.2. Правно естество на услугата: Заплащането на абонаментна такса представлява възнаграждение за предоставяне на дигитално пространство, техническа поддръжка, административно администриране и визуализация на профила. Тази услуга не представлява посреднически договор за заетост, импресарски договор, нито поемане на задължение или гаранция от страна на Доставчика или неговите собственици за осигуряване на роля, участие в кастинг, сключване на договор с продукция или каквато и да е друга професионална или творческа реализация на Потребителя."]}, {"heading": "IV. ПРАВА И ЗАДЪЛЖЕНИЯ. АВТОРСКИ ПРАВА И ИНДЕМНИФИКАЦИЯ", "paragraphs": ["4.1. Потребителят носи пълна и изключителна отговорност за достоверността, актуалността и законността на предоставените от него биографични данни, снимки, видеозаписи и текстове.", "4.2. С качването или изпращането на материали за публикуване в MG Casting, Потребителят декларира и гарантира, че е носител на съответните авторски и сродни права или разполага с изричното писмено съгласие на техните автори (фотографи, оператори, режисьори).", "4.3. Обезщетение (Indemnification): В случай че срещу „ДЕМА ФИЛМ“ ООД, неговите управители, служители или партньори бъде предявен иск, административна санкция или претенция от трето лице (вкл. от носители на авторски права, продуценти или надзорни органи), произтичащи от неправомерно предоставен от Потребителя материал, Потребителят се задължава да встъпи в спора на своя отговорност и да обезщети изцяло Доставчика за всички претърпени имуществени вреди, пропуснати ползи, наложени глоби и разумни адвокатски хонорари."]}, {"heading": "V. КУРСОВЕ, ОБУЧЕНИЯ И ТВОРЧЕСКИ ПРОЕКТИ", "paragraphs": ["5.1. MG Casting и неговите основатели организират практически курсове, майсторски класове и актьорски обучения. Графикът, платформата за провеждане и организационните детайли се предоставят на курсиста след потвърдено плащане. Организаторът запазва правото си да извършва предварителна селекция на кандидати въз основа на предоставени материали.", "5.2. Права над създаденото съдържание: С участието си в курсове, кастинги, пробни снимки, уъркшопи или обучения, организирани от или свързани с MG Casting, Потребителят (или неговият законен представител) дава своето безусловно, неотменимо и безсрочно съгласие всякакви заснети фото-, видео- и аудиоматериали, етюди, изпълнения и записи по време на обучителния или кастинг процеса, да бъдат заснемани и записвани.", "5.3. Всички имуществени и неимуществени авторски и сродни права върху създадените по т. 5.2 материали възникват и принадлежат изцяло, ексклузивно и без ограничения на „ДЕМА ФИЛМ“ ООД, съответно на Максим Генчев и Матей Генчев като творчески ръководители и продуценти. Те имат право да използват, редактират, разпространяват, публично показват и интегрират тези материали за рекламни цели на платформата MG Casting, в социални мрежи, както и в бъдещи комерсиални, филмови, телевизионни и дигитални проекти, без да дължат допълнително съгласие или финансово възнаграждение на участниците."]}, {"heading": "VI. НЕПЪЛНОЛЕТНИ ЛИЦА", "paragraphs": ["6.1. Лица, ненавършили 18-годишна възраст, могат да бъдат регистрирани в платформата или да участват в обучения единствено чрез, и с изричното съгласие на техен родител или законно назначен настойник/попечител.", "6.2. Всички правни действия, плащания и комуникация се извършват от законния представител. С приемането на тези Общи условия родителят/настойникът поема пълна правна и материална отговорност за спазването им, както и за безопасното участие на непълнолетното лице в дейностите на платформата. За защита на децата, техните директни контактни данни (телефон, имейл, точен адрес) никога не се публикуват публично на сайта."]}, {"heading": "VII. ОГРАНИЧАВАНЕ НА ОТГОВОРНОСТТА (LIMITATION OF LIABILITY)", "paragraphs": ["7.1. Платформата MG Casting функционира на принципа „както е“ (as is). Доставчикът полага разумни професионални грижи за непрекъснатото функциониране на сайта и достоверното представяне на профилите, но не гарантира липсата на технически прекъсвания, хакерски атаки или форсмажорни обстоятелства.", "7.2. Доставчикът не носи отговорност за решенията, субективните оценки, действията или бездействията на външни продуценти, режисьори, кастинг директори, рекламни агенции или трети лица, които разглеждат профилите в платформата.", "7.3. Лимит на отговорността: В случай на доказано по съдебен ред виновни неизпълнение или техническа грешка от страна на Доставчика, довело до пряка и непосредствена вреда за Потребителя, общата максимална финансова отговорност на „ДЕМА ФИЛМ“ ООД се ограничава строго до размера на заплатената от конкретния Потребител такса за съответния текущ месечен период (при абонамент) или таксата за съответния курс. Доставчикът не отговаря за пропуснати ползи, нереализирани хонорари от филмови проекти или косвени вреди."]}, {"heading": "VIII. РЕШАВАНЕ НА СПОРОВЕ И ПРИЛОЖИМО ПРАВО", "paragraphs": ["8.1. Задължителна предсъдебна процедура: При възникване на спорове, рекламации или неудовлетвореност от предоставените услуги, Потребителят е длъжен да уведоми писмено Доставчика на имейл адрес teenscenetalkshow@gmail.com в срок до 7 (седем) календарни дни от настъпване на събитието, предмет на спора. В уведомлението се посочват конкретни детайли и искания. Страните се задължават да проведат добронамерени преговори в 14-дневен срок за постигане на извънсъдебно споразумение.", "8.2. Предявяването на писмена рекламация по реда на т. 8.1 е задължителна предпоставка за предприемане на последващи правни действия, доколкото това не противоречи на императивни разпоредби на Закона за защита на потребителите.", "8.3. Всички неразрешени спорове се отнасят за решаване пред компетентния български съд съгласно седалището на Доставчика (гр. Елин Пелин / гр. София), като се прилага действащото законодателство на Република България."]}]}, {"slug": "cancellation", "route": "/legal/cancellation", "title": "ПОЛИТИКА ЗА АБОНАМЕНТ, ПЛАЩАНИЯ И ОТКАЗ", "updated": "Последна редакция: 20 юли 2026 г.", "intro": ["Настоящата политика е неразделна част от Общите условия на MG Casting и регламентира финансовите взаимоотношения, процеса по таксуване, подновяване на абонаменти, закупуване на курсове и правните ограничения относно правата на отказ."], "sections": [{"heading": "I. ОБЩИ ПРИНЦИПИ И СИГУРНОСТ НА ПЛАЩАНИЯТА", "paragraphs": ["1.1. Всички плащания в платформата MG Casting се извършват по електронен път чрез лицензирания международен платежен оператор Stripe.", "1.2. Сигурност и финансова защита: С цел максимална защита и спокойствие на Потребителя, „ДЕМА ФИЛМ“ ООД и уебсайтът MG Casting не обработват, не получават и не съхраняват на свои сървъри пълни данни за банков карти (номера на карти, CVC/CVV кодове, дати на валидност). Цялата финансова транзакция се криптира и обработва изключително в защитената среда на Stripe."]}, {"heading": "II. АВТОМАТИЧНО ПОДНОВЯВАНЕ НА АБОНАМЕНТА", "paragraphs": ["2.1. Абонаментните планове Standard и Premium са услуги с периодично (месечно) таксуване.", "2.2. С първоначалното заплащане на избрания план, Потребителят дава своето изрично съгласие и авторизира системата на Stripe да таксува автоматично регистрирания платежен метод за всеки следващ последователен месечен период, докато абонаментът не бъде прекратен по установения ред."]}, {"heading": "III. ПРЕКРАТЯВАНЕ НА АБОНАМЕНТ (ОТКАЗ ОТ ПОДНОВЯВАНЕ)", "paragraphs": ["3.1. Потребителят има пълен контрол и право да прекрати автоматичното подновяване на своя абонамент по всяко време чрез:", "Специализирания клиентски портал (Stripe Customer Portal), интегриран в сайта (когато е активен); или", "Изпращане на изрично писмено искане от регистрирания в профила имейл адрес до teenscenetalkshow@gmail.com.", "3.2. Срокове за прекратяване: За да не бъде таксуван за следващия отчетен месец, искането за прекратяване трябва да бъде получено и обработено най-малко 24 часа преди датата на следващото автоматично подновяване.", "3.3. Действие след прекратяване: Прекратяването на абонамента има действие занапред (ex nunc). Потребителският профил остава напълно активен и видим в каталога до изтичане на вече заплатения текущ месечен период. След тази дата профилът се деактивира/скрива от публичния каталог, без да се генерират нови такси или задължения."]}, {"heading": "IV. ЕДНОКРАТНИ ПЛАЩАНИЯ (КУРСОВЕ) И ИЗКЛЮЧВАНЕ НА ПРАВОТО НА ОТКАЗ", "paragraphs": ["4.1. Заплащането на такса за участие в актьорски курс, майсторски клас или индивидуална консултация представлява еднократна покупка на специализирана обучителна услуга.", "4.2. Правно ограничение съгласно ЗЗП: Потребителят е информиран и изрично се съгласява, че съгласно разпоредбите на чл. 57, ал. 1, т. 1 и т. 13 от Закона за защита на потребителите (ЗЗП), правото на отказ от договора от разстояние и възстановяване на заплатена сума НЕ се прилага, когато:", "Изпълнението на услугата (абонамент или обучение) е започнало с изричното предварително съгласие на потребителя;", "Предоставя се достъп до дигитално съдържание, което не се доставя на материален носител, и изпълнението е започнало;", "Касае се за услуги, свързани със свободното време (кастинги, уъркшопи), за които е предвидена специфична дата или период на изпълнение.", "4.3. В тази връзка, вече заплатени такси за текущ месечен абонамент или за актьорски курс/обучение, чието провеждане е започнало или за което мястото е резервирано и графикът е генериран, не подлежат на възстановяване (No Refund Policy), освен при доказване на пълно неизпълнение от страна на Организатора."]}, {"heading": "V. ПЛАТЕЖНИ ПРОБЛЕМИ И ЗАЩИТА ОТ НЕОСНОВАТЕЛНИ ОСПОРВАНИЯ (CHARGEBACKS)", "paragraphs": ["5.1. При възникване на технически проблем, съмнение за двойно таксуване или неразпозната транзакция, Потребителят се задължава незабавно да се свърже с екипа на MG Casting на teenscenetalkshow@gmail.com, посочвайки имейла на регистрация, датата и сумата, без да изпраща чувствителни картови данни. Доставчикът ще извърши проверка в рамките на 3 работни дни.", "5.2. Неоснователно оспорване на плащане (Chargeback abuse): В случай че Потребител инициира неоснователно оспорване на транзакция пред своята банка или платежна институция за услуга, която реално е била предоставена или активирана, Доставчикът има право незабавно да блокира профила на Потребителя, да предяви регресен иск за възстановяване на оспорената сума, заедно с всички банкови такси, глоби от Stripe и административни разходи по оспорването, както и да откаже бъдещ достъп до платформата."]}]}, {"slug": "privacy", "route": "/legal/privacy", "title": "ПОЛИТИКА ЗА ПОВЕРИТЕЛНОСТ И ЗАЩИТА НА ЛИЧНИТЕ ДАННИ", "updated": "Последна редакция: 20 юли 2026 г.", "intro": ["Настоящата Политика за поверителност описва как „ДЕМА ФИЛМ“ ООД и платформата MG Casting обработват, съхраняват и защитават личните данни на своите потребители в стриктно съответствие с Общия регламент относно защитата на данните (Регламент (ЕС) 2016/679 - GDPR) и Закона за защита на личните данни (ЗЗЛД) на Република България."], "sections": [{"heading": "I. АДМИНИСТРАТОР НА ЛИЧНИ ДАННИ", "paragraphs": ["1.1. Администратор на лични данни е „ДЕМА ФИЛМ“ ООД, ЕИК 205529116, със седалище и адрес на управление: гр. Елин Пелин, бул. „Новоселци“ № 82, представлявано от Максим Генчев.", "1.2. Специализиран контакт за въпроси относно поверителността и упражняване на права: teenscenetalkshow@gmail.com."]}, {"heading": "II. КАТЕГОРИИ ОБРАБОТВАНИ ДАННИ", "paragraphs": ["За целите на предоставяне на услугите, Администраторът може да обработва следните категории данни:", "Идентификационни данни: Име и фамилия, дата на раждане, пол, възраст.", "Контактни данни: Имейл адрес, телефон за връзка, населено място.", "Професионални и физически характеристики (за кастинг цели): Ръст, тегло, цвят на очи и коса, специфични умения, владение на езици, творчески опит, образование.", "Аудио-визуални материали: Портретни снимки, фотографии в цял ръст, видео визитки, шоурийлове, записи от кастинги и курсове.", "Технически и платежни данни: IP адрес, логове за достъп, данни за история на плащанията (без банкови карти, които се обработват единствено от Stripe)."]}, {"heading": "III. ЦЕЛИ И ПРАВНИ ОСНОВАНИЯ ЗА ОБРАБОТВАНЕ", "paragraphs": ["Администраторът обработва данните на следните правни основания съгласно чл. 6 от ОРЗД (GDPR):", "3.1. Изпълнение на договор (чл. 6, ал. 1, б. „б“ от ОРЗД): За създаване и техническо поддържане на актьорския профил, осигуряване на достъп до курсове, административна комуникация и обработка на плащания.", "3.2. Легитимен интерес на Администратора и неговите партньори (чл. 6, ал. 1, б. „е“ от ОРЗД): За селекция, подбор и препоръчване на актьори за филмови, телевизионни, театрални и рекламни проекти; за администриране на кастинги, организирани от Максим Генчев, Матей Генчев, „ДЕМА ФИЛМ“ ООД или техните доверени партньори от кино и телевизионната индустрия; за осигуряване на мрежова сигурност и предотвратяване на измами.", "3.3. Изрично съгласие (чл. 6, ал. 1, б. „а“ от ОРЗД): При маркетингови кампании, използване на допълнителни аналитични бисквитки или обработване на специфични категории данни.", "3.4. Законово задължение (чл. 6, ал. 1, б. „в“ от ОРЗД): За спазване на разпоредбите на Закона за счетоводството, ДОПК и данъчното законодателство на Р. България."]}, {"heading": "IV. ПУБЛИЧНОСТ НА ПРОФИЛИТЕ И ЗАЩИТА НА НЕПЪЛНОЛЕТНИ ЛИЦА", "paragraphs": ["4.1. Гаранция за сигурност: В публичния каталог на MG Casting, видим за посетителите на сайта, се показва единствено информацията, строго необходима за професионалното кастинг представяне (имена или псевдоним, възраст, физически характеристики, умения, опит, снимки и видеоматериали).", "4.2. Поверителност на контактите: Частни контактни данни като имейл адрес, телефонен номер, точен физически адрес, данни за плащане и контактни данни на родители/настойници НИКОГА не се публикуват публично на сайта. Връзката между актьора и потенциален работодател се координира сигурно чрез платформата или администраторите.", "4.3. Специална защита на деца: Обработването на данни на лица под 18 години се извършва при засилени мерки за сигурност, само след удостоверено съгласие на родител/настойник. Всяка комуникация относно непълнолетен кандидат се води изключително с неговия законен представител."]}, {"heading": "V. ПОЛУЧАТЕЛИ НА ДАННИ И СПОДЕЛЯНЕ", "paragraphs": ["5.1. Личните данни на Потребителите се пазят в строга конфиденциалност и могат да бъдат споделяни само със следните категории получатели при доказана необходимост:", "Доверени външни продуцентски компании, режисьори, кастинг директори и рекламни агенции – единствено с цел професионална реализация и участие на Потребителя в кастинги и продукции;", "Обработващи лични данни по договор – доставчици на хостинг услуги, техническа поддръжка, правни и счетоводни консултации, с които Администраторът има сключени споразумения за поверителност;", "Платежни оператори (Stripe) за администриране на транзакциите;", "Компетентни държавни органи, когато това се изисква по силата на императивен закон."]}, {"heading": "VI. СРОКОВЕ НА СЪХРАНЕНИЕ И СИГУРНОСТ", "paragraphs": ["6.1. Данните се съхраняват докато профилът на Потребителя е активен в платформата. При изтриване на профила, Администраторът може да запази определени технически или счетоводни данни (напр. фактури, история на плащания) за срок до 5 (пет) години, съгласно давностните срокове в ЗЗД и Закона за счетоводството.", "6.2. Администраторът прилага съвременни организационни и технически мерки за защита – SSL криптиране, контрол на достъпа, защита срещу неправомерен достъп и загуба на информация."]}, {"heading": "VII. ПРАВА НА СУБЕКТИТЕ НА ДАННИ", "paragraphs": ["Съгласно ОРЗД, всеки Потребител има право на: достъп до собствените си данни; корекция на неточности; изтриване („право да бъдеш забравен“), освен ако за пазеното няма законово основание; ограничаване на обработването; преносимост на данните; възражение срещу обработване на база легитимен интерес; жалба пред Комисията за защита на личните данни (КЗЛД) на адрес: гр. София 1592, бул. „Проф. Цветан Лазаров“ № 2, www.cpdp.bg."]}]}, {"slug": "cookies", "route": "/legal/cookies", "title": "ПОЛИТИКА ЗА ИЗПОЛЗВАНЕ НА „БИСКВИТКИ“ (COOKIE POLICY)", "updated": "Последна редакция: 20 юли 2026 г.", "intro": ["Уебсайтът MG Casting (mgcasting.com) използва малки текстови файлове, наречени „бисквитки“ (cookies) и сходни локални технологии за съхранение, с цел осигуряване на правилното функциониране на платформата, сигурност на сесиите и персонализиране на потребителското изживяване."], "sections": [{"heading": "I. КАКВО ПРЕДСТАВЛЯВАТ БИСКВИТКИТЕ", "paragraphs": ["Бисквитките са малки информационни файлове, които се запазват на Вашето устройство (компютър, мобилен телефон, таблет) при посещение на сайта. Те не вредят на устройството и не съдържат вируси."]}, {"heading": "II. ВИДОВЕ ТЕХНОЛОГИИ, ИЗПОЛЗВАНИ В ПЛАТФОРМАТА", "paragraphs": ["Сайтът MG Casting използва следните категории технологии съгласно европейските директиви за електронна поверителност (ePrivacy Directive):", "2.1. Задължителни / Необходими бисквитки (Strictly Necessary Cookies):", "Цел: Тези технологии са критично необходими за основното функциониране на сайта. Те осигуряват защитена навигация, запазване на потребителската сесия, запазване на избора на план преди пренасочване към платежната страница (Stripe Checkout) и запазване на Вашите предпочитания относно съгласието за бисквитки.", "Правно основание: Не изискват предварително съгласие, тъй като без тях предоставянето на исканата от Вас дигитална услуга е технически невъзможно.", "2.2. Аналитични бисквитки (Analytics & Performance):", "Цел: Използват се за събиране на анонимна статистика за това как посетителите взаимодействат със сайта (кои страници са най-посещавани, откъде идва трафикът), за да можем да оптимизираме структурата и дизайна на каталога.", "Правно основание: Активират се единствено и само след Вашето изрично предварително съгласие (Opt-in). Настоящата система не зарежда автоматично аналитични скриптове, преди да сте дали потвърждение.", "2.3. Бисквитки от трети страни (External Content & Providers):", "При използване на платформата, интеграции от трети страни могат да поставят свои собствени бисквитки на устройството Ви:", "Stripe: При администриране и защита на плащанията, платежният оператор Stripe използва технологии за предотвратяване на финансови измами и потвърждаване на сесията.", "YouTube / Vimeo (или видео хостинг): При отваряне на актьорски видео презентации (визитки, шоурийлове), вградени от външни видео платформи, съответните доставчици могат да използват собствени проследяващи технологии съгласно техните политики за поверителност."]}, {"heading": "III. УПРАВЛЕНИЕ И ИЗЧИСТВАНЕ НА БИСКВИТКИТЕ", "paragraphs": ["3.1. Посетителят разполага с пълен контрол и може по всяко време да промени настройките си за бисквитки чрез интерактивния панел за предпочитания на сайта (когато е наличен) или чрез настройките на своя уеб браузър (Google Chrome, Safari, Firefox, Edge).", "3.2. Можете да настроите браузъра си да блокира или да Ви предупреждава за всички бисквитки, но имайте предвид, че при блокиране на Задължителните бисквитки, основни функции на платформата MG Casting (като вход в профил или плащане) може да престанат да работят коректно."]}]}]`);

const classNames = (...classes) => classes.filter(Boolean).join(' ');

// Normalized filter categories. These values affect only filtering; the original
// profile fields remain unchanged and continue to be displayed verbatim.
const HAIR_FILTER_OPTIONS = ['Руса', 'Кафява', 'Черна', 'Друга'];

const getHairFilterCategory = (hairColor = '') => {
  const value = hairColor.toLocaleLowerCase('bg-BG');
  // Brown/chestnut is checked first so mixed descriptions such as
  // "кафява с руси кичури" remain in the dominant brown category.
  if (/(кафяв|кестеняв)/u.test(value)) return 'Кафява';
  if (/(черн)/u.test(value)) return 'Черна';
  if (/(рус)/u.test(value)) return 'Руса';
  return 'Друга';
};

const REGION_FILTER_MAP = {
  'София': ['София-град'],
  'София-град': ['София-град'],
  'Елин Пелин': ['София област'],
  'Божурище': ['София област'],
  'В близост до София': ['София област'],
  'Перник': ['Перник'],
  'Радомир': ['Перник'],
  'Габрово': ['Габрово'],
  'Благоевград': ['Благоевград'],
  'Шивачево, област Сливен': ['Сливен'],
  'Златоград': ['Смолян'],
  'Пловдив / Бургас': ['Пловдив', 'Бургас'],
  'с. Марково': ['Пловдив'],
  'Чирпан': ['Стара Загора'],
  'Добрич': ['Добрич'],
  'Пазарджик': ['Пазарджик'],
  'Димитровград': ['Хасково'],
  'Варна': ['Варна'],
};

const getActorRegionCategories = (region = '') => {
  if (REGION_FILTER_MAP[region]) return REGION_FILTER_MAP[region];

  const normalized = region.replace(/^област\s+/iu, '').trim();
  const knownAreas = [
    'Благоевград', 'Бургас', 'Варна', 'Велико Търново', 'Видин', 'Враца',
    'Габрово', 'Добрич', 'Кърджали', 'Кюстендил', 'Ловеч', 'Монтана',
    'Пазарджик', 'Перник', 'Плевен', 'Пловдив', 'Разград', 'Русе',
    'Силистра', 'Сливен', 'Смолян', 'София област', 'Стара Загора',
    'Търговище', 'Хасково', 'Шумен', 'Ямбол',
  ];
  if (knownAreas.includes(normalized)) return [normalized];
  return ['Друга област'];
};


const Icon = ({ name, className = 'w-5 h-5' }) => {
  const paths = {
    menu: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 7h16M4 12h16M4 17h16" />,
    close: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18 18 6M6 6l12 12" />,
    arrow: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 12h14m-5-5 5 5-5 5" />,
    back: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 12H5m5 5-5-5 5-5" />,
    check: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.4" d="m5 13 4 4L19 7" />,
    search: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m21 21-4.35-4.35m1.35-5.65a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />,
    filter: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M7 12h10m-7 6h4" />,
    play: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m9 7 8 5-8 5V7Z" />,
    phone: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5.5A2.5 2.5 0 0 1 5.5 3H8l1.5 4-2 1.5a15 15 0 0 0 8 8l1.5-2 4 1.5v2.5A2.5 2.5 0 0 1 18.5 21C10 20.5 3.5 14 3 5.5Z" />,
    mail: <><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 5h16v14H4z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m4 7 8 6 8-6" /></>,
    camera: <><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 7h4l1.5-2h5L16 7h4v12H4z" /><circle cx="12" cy="13" r="3.5" strokeWidth="2" /></>,
    user: <><circle cx="12" cy="8" r="4" strokeWidth="2" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 21a8 8 0 0 1 16 0" /></>,
    briefcase: <><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 8h16v11H4z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 8V5h6v3m-11 4h16" /></>,
    shield: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 3 5 6v5c0 4.5 2.8 8 7 10 4.2-2 7-5.5 7-10V6l-7-3Z" />,
    star: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m12 3 2.6 5.3 5.9.9-4.3 4.2 1 5.9-5.2-2.8-5.2 2.8 1-5.9-4.3-4.2 5.9-.9L12 3Z" />,
    upload: <><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 16V4m0 0-4 4m4-4 4 4" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 15v5h16v-5" /></>,
    download: <><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v12m0 0 4-4m-4 4-4-4" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 19h16" /></>,
  };
  return <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">{paths[name] || paths.arrow}</svg>;
};

const normalizeMetaDescription = (value, maxLength = 210) => {
  const clean = String(value || '')
      .replace(/\s+/g, ' ')
      .trim();

  if (!clean) return 'MG Casting – професионална платформа за актьори, нови лица, кастинги и филмови продукции.';
  if (clean.length <= maxLength) return clean;

  const shortened = clean.slice(0, maxLength - 1);
  const lastSpace = shortened.lastIndexOf(' ');
  return `${shortened.slice(0, lastSpace > 130 ? lastSpace : maxLength - 1).trim()}…`;
};

const SEO = ({ title, description, image = SITE.shareImage, canonical }) => {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE.name}` : SITE.name;
    const metaDescription = normalizeMetaDescription(description);
    const fullCanonical = canonical || (typeof window !== 'undefined' ? window.location.href.split(/[?#]/)[0] : SITE.domain);
    const resolvedImage = image
        ? (image.startsWith('http') ? image : `${SITE.domain}${image}`)
        : SITE.shareImage;
    const imageAlt = title
        ? `${title} – ${SITE.name}`
        : 'MG Casting – кастинг платформа за кино, телевизия и реклама';

    document.title = fullTitle;

    let favicon = document.head.querySelector('link[rel="icon"]');
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }
    favicon.type = 'image/png';
    favicon.href = SITE.logo;

    let appleTouchIcon = document.head.querySelector('link[rel="apple-touch-icon"]');
    if (!appleTouchIcon) {
      appleTouchIcon = document.createElement('link');
      appleTouchIcon.rel = 'apple-touch-icon';
      document.head.appendChild(appleTouchIcon);
    }
    appleTouchIcon.href = SITE.logo;

    const setMeta = (selector, attributes) => {
      let element = document.head.querySelector(selector);
      if (!element) {
        element = document.createElement('meta');
        document.head.appendChild(element);
      }
      Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, String(value)));
    };

    const removeMeta = (selector) => {
      document.head.querySelector(selector)?.remove();
    };

    setMeta('meta[name="description"]', { name: 'description', content: metaDescription });
    setMeta('meta[name="application-name"]', { name: 'application-name', content: SITE.name });
    setMeta('meta[name="apple-mobile-web-app-title"]', { name: 'apple-mobile-web-app-title', content: SITE.name });
    setMeta('meta[name="theme-color"]', { name: 'theme-color', content: '#070b19' });

    setMeta('meta[property="og:title"]', { property: 'og:title', content: fullTitle });
    setMeta('meta[property="og:site_name"]', { property: 'og:site_name', content: SITE.name });
    setMeta('meta[property="og:description"]', { property: 'og:description', content: metaDescription });
    setMeta('meta[property="og:image"]', { property: 'og:image', content: resolvedImage });
    setMeta('meta[property="og:image:secure_url"]', { property: 'og:image:secure_url', content: resolvedImage });
    setMeta('meta[property="og:image:type"]', {
      property: 'og:image:type',
      content: resolvedImage.toLowerCase().split(/[?#]/)[0].endsWith('.png') ? 'image/png' : 'image/jpeg',
    });
    setMeta('meta[property="og:image:alt"]', { property: 'og:image:alt', content: imageAlt });

    if (resolvedImage === SITE.shareImage) {
      setMeta('meta[property="og:image:width"]', { property: 'og:image:width', content: '1200' });
      setMeta('meta[property="og:image:height"]', { property: 'og:image:height', content: '630' });
    } else {
      removeMeta('meta[property="og:image:width"]');
      removeMeta('meta[property="og:image:height"]');
    }

    setMeta('meta[property="og:type"]', { property: 'og:type', content: 'website' });
    setMeta('meta[property="og:url"]', { property: 'og:url', content: fullCanonical });
    setMeta('meta[property="og:locale"]', { property: 'og:locale', content: 'bg_BG' });

    setMeta('meta[name="twitter:card"]', { name: 'twitter:card', content: 'summary_large_image' });
    setMeta('meta[name="twitter:title"]', { name: 'twitter:title', content: fullTitle });
    setMeta('meta[name="twitter:description"]', { name: 'twitter:description', content: metaDescription });
    setMeta('meta[name="twitter:image"]', { name: 'twitter:image', content: resolvedImage });
    setMeta('meta[name="twitter:image:alt"]', { name: 'twitter:image:alt', content: imageAlt });

    let canonicalLink = document.head.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.rel = 'canonical';
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.href = fullCanonical;
  }, [title, description, image, canonical]);
  return null;
};

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === 'POP') return;
    if (hash) {
      window.setTimeout(() => {
        document.getElementById(hash.replace('#', ''))?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
      return;
    }
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [pathname, hash, navigationType]);
  return null;
};

const useBodyLock = (locked) => {
  useEffect(() => {
    if (!locked) return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = previous; };
  }, [locked]);
};

const useEscape = (handler, enabled = true) => {
  useEffect(() => {
    if (!enabled) return undefined;
    const listener = (event) => { if (event.key === 'Escape') handler(); };
    window.addEventListener('keydown', listener);
    return () => window.removeEventListener('keydown', listener);
  }, [handler, enabled]);
};

const PrimaryLink = ({ to, children, className = '', icon = true, external = false }) => {
  const styles = classNames(
      'group inline-flex min-h-11 items-center justify-center gap-2.5 rounded-xl px-4 py-3 text-[10px] font-black uppercase tracking-[0.14em] text-[#111827] transition-all duration-300 md:min-h-12 md:gap-3 md:rounded-2xl md:px-6 md:py-3.5 md:text-sm md:tracking-[0.18em]',
      'bg-gradient-to-r from-[#fbbf24] via-[#f59e0b] to-[#d97706] shadow-[0_0_30px_rgba(245,158,11,0.22)] hover:-translate-y-1 hover:shadow-[0_0_45px_rgba(245,158,11,0.4)]',
      className,
  );
  if (external) return <a href={to} className={styles}>{children}{icon && <Icon name="arrow" className="w-4 h-4 transition-transform group-hover:translate-x-1" />}</a>;
  return <Link to={to} className={styles}>{children}{icon && <Icon name="arrow" className="w-4 h-4 transition-transform group-hover:translate-x-1" />}</Link>;
};

const SecondaryLink = ({ to, children, className = '', icon = true }) => (
    <Link to={to} className={classNames('group inline-flex min-h-11 items-center justify-center gap-2.5 rounded-xl border border-white/15 bg-white/[0.06] px-4 py-3 text-[10px] font-black uppercase tracking-[0.14em] text-white backdrop-blur-xl transition-all hover:-translate-y-1 hover:border-[#f59e0b]/60 hover:bg-[#f59e0b]/10 md:min-h-12 md:gap-3 md:rounded-2xl md:px-6 md:py-3.5 md:text-sm md:tracking-[0.18em]', className)}>
      {children}{icon && <Icon name="arrow" className="w-4 h-4 transition-transform group-hover:translate-x-1" />}
    </Link>
);

const SectionHeading = ({ eyebrow, title, accent, description, align = 'center' }) => (
    <div className={classNames('mb-9 md:mb-16', align === 'center' ? 'mx-auto max-w-4xl text-center' : 'max-w-3xl text-left')}>
      {eyebrow && <p className="mb-3 text-[10px] font-black uppercase tracking-[0.22em] text-[#f59e0b] md:mb-4 md:text-xs md:tracking-[0.3em]">{eyebrow}</p>}
      <h2 className="text-3xl font-black uppercase leading-[0.98] tracking-[-0.035em] text-white md:text-6xl md:leading-[0.95] md:tracking-[-0.04em]">
        {title} {accent && <span className="bg-gradient-to-r from-[#fbbf24] via-[#fb923c] to-[#d97706] bg-clip-text text-transparent">{accent}</span>}
      </h2>
      {description && <p className="mt-4 text-sm font-medium leading-relaxed text-slate-300 md:mt-6 md:text-lg">{description}</p>}
    </div>
);

const GlowBackdrop = () => (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      <div className="absolute -left-40 top-20 h-[420px] w-[420px] rounded-full bg-[#f59e0b]/10 blur-[120px]" />
      <div className="absolute -right-40 top-1/3 h-[500px] w-[500px] rounded-full bg-[#d97706]/12 blur-[130px]" />
      <div className="absolute bottom-0 left-1/3 h-[350px] w-[350px] rounded-full bg-amber-500/8 blur-[120px]" />
    </div>
);

const AnimatedCounter = ({ endValue, duration = 1800, suffix = '' }) => {
  const [count, setCount] = useState(0);
  const [hasStarted, setHasStarted] = useState(false);
  const elementRef = useRef(null);

  useEffect(() => {
    const element = elementRef.current;
    if (!element || typeof IntersectionObserver === 'undefined') { setHasStarted(true); return undefined; }
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { setHasStarted(true); observer.unobserve(entry.target); }
    }, { threshold: 0.35 });
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!hasStarted) return undefined;
    let frame;
    let startedAt;
    const animate = (timestamp) => {
      if (!startedAt) startedAt = timestamp;
      const progress = Math.min((timestamp - startedAt) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(eased * endValue));
      if (progress < 1) frame = window.requestAnimationFrame(animate);
    };
    frame = window.requestAnimationFrame(animate);
    return () => window.cancelAnimationFrame(frame);
  }, [hasStarted, endValue, duration]);

  return <span ref={elementRef} className="bg-gradient-to-r from-[#fbbf24] via-white to-[#fb923c] bg-clip-text text-2xl font-black uppercase tracking-tight text-transparent md:text-5xl">{new Intl.NumberFormat('bg-BG').format(count)}{suffix}</span>;
};

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!window.localStorage.getItem('mg-cookie-choice'));
  }, []);

  const choose = (choice) => {
    window.localStorage.setItem('mg-cookie-choice', choice);
    window.dispatchEvent(new CustomEvent('mg-cookie-choice', { detail: choice }));
    setVisible(false);
  };

  if (!visible) return null;
  return (
      <div className="fixed inset-x-3 bottom-3 z-[120] mx-auto max-w-4xl rounded-2xl border border-white/15 bg-[#0a0f1d]/95 p-4 shadow-[0_20px_80px_rgba(0,0,0,0.65)] backdrop-blur-2xl md:inset-x-4 md:bottom-4 md:rounded-3xl md:p-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between md:gap-5">
          <div className="max-w-2xl">
            <p className="mb-2 text-sm font-black uppercase tracking-[0.18em] text-white">Поверителност и бисквитки</p>
            <p className="text-sm leading-relaxed text-slate-300">Използваме необходими локални записи за работата на сайта. Аналитични технологии могат да бъдат активирани само след твоя избор. <Link to="/legal" className="font-bold text-[#fbbf24] underline underline-offset-4">Научи повече</Link>.</p>
          </div>
          <div className="flex flex-col gap-2 sm:flex-row">
            <button type="button" onClick={() => choose('necessary')} className="rounded-xl border border-white/15 bg-white/5 px-5 py-3 text-xs font-black uppercase tracking-widest text-white hover:bg-white/10">Само необходими</button>
            <button type="button" onClick={() => choose('accepted')} className="rounded-xl bg-[#f59e0b] px-5 py-3 text-xs font-black uppercase tracking-widest text-black hover:bg-[#fcd34d]">Приемам</button>
          </div>
        </div>
      </div>
  );
};

const CheckoutRedirect = () => {
  const { productKey } = useParams();
  const product = CHECKOUT_PRODUCTS[productKey];

  useEffect(() => {
    if (!product) return;
    window.localStorage.setItem('mg-pending-product', productKey);
    const timer = window.setTimeout(() => window.location.assign(product.stripeUrl), 450);
    return () => window.clearTimeout(timer);
  }, [product, productKey]);

  if (!product) return <NotFound compact />;
  return (
      <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#070b19] px-4 text-center md:px-6">
        <GlowBackdrop />
        <SEO title="Сигурно плащане" description={`Пренасочване към Stripe за ${product.title}.`} />
        <div className="relative z-10 max-w-xl rounded-3xl border border-white/12 bg-white/[0.05] p-6 backdrop-blur-2xl md:rounded-[32px] md:p-12">
          <div className="mx-auto mb-7 h-16 w-16 animate-spin rounded-full border-4 border-white/10 border-t-[#f59e0b]" />
          <h1 className="mb-4 text-2xl font-black uppercase tracking-tight text-white md:text-3xl">Пренасочваме те към Stripe</h1>
          <p className="text-slate-300">Избрана услуга: <strong className="text-white">{product.title}</strong>. Плащането се извършва на защитената страница на Stripe.</p>
        </div>
      </div>
  );
};

const PaymentSuccessModal = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const query = useMemo(() => new URLSearchParams(location.search), [location.search]);

  const shouldOpen =
      query.get('payment') === 'success' ||
      query.get('success') === 'true' ||
      query.get('checkout') === 'success' ||
      query.get('redirect_status') === 'succeeded' ||
      location.hash === '#payment-success';

  const productKey = query.get('product') || window.localStorage.getItem('mg-pending-product') || 'standard';
  const isProfilePayment = productKey === 'standard' || productKey === 'premium';

  useBodyLock(shouldOpen);

  const close = () => {
    window.localStorage.removeItem('mg-pending-product');
    navigate(location.pathname, { replace: true });
  };

  if (!shouldOpen) return null;

  return (
      <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="payment-success-title"
          aria-describedby="payment-success-description"
          className="fixed inset-0 z-[150] flex items-center justify-center bg-[#100018]/95 p-4 backdrop-blur-xl"
      >
        <style>{`
          @keyframes mg-success-pop {
            0% { opacity: 0; transform: scale(.72) translateY(20px); }
            65% { opacity: 1; transform: scale(1.06) translateY(0); }
            100% { opacity: 1; transform: scale(1) translateY(0); }
          }
          @keyframes mg-success-ring {
            0% { opacity: 0; transform: scale(.45); }
            55% { opacity: .85; transform: scale(1.18); }
            100% { opacity: 0; transform: scale(1.55); }
          }
          @keyframes mg-success-check {
            0% { stroke-dashoffset: 48; opacity: 0; }
            35% { opacity: 1; }
            100% { stroke-dashoffset: 0; opacity: 1; }
          }
          @keyframes mg-success-sparkle {
            0%, 100% { opacity: .25; transform: scale(.7) rotate(0deg); }
            50% { opacity: 1; transform: scale(1.2) rotate(18deg); }
          }
          .mg-success-card { animation: mg-success-pop .72s cubic-bezier(.2,.9,.25,1.2) both; }
          .mg-success-ring { animation: mg-success-ring 1.8s ease-out infinite; }
          .mg-success-check { stroke-dasharray: 48; animation: mg-success-check .75s .25s ease-out both; }
          .mg-success-sparkle { animation: mg-success-sparkle 1.8s ease-in-out infinite; }
        `}</style>

        <div className="mg-success-card relative w-full max-w-lg overflow-hidden rounded-[32px] border border-[#c084fc]/35 bg-gradient-to-b from-[#32104d] via-[#1b082b] to-[#0c0312] px-6 pb-8 pt-16 text-center shadow-[0_0_90px_rgba(126,34,206,.38)] md:px-10 md:pb-10 md:pt-20">
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(192,132,252,.22),transparent_44%),radial-gradient(circle_at_bottom,rgba(88,28,135,.18),transparent_45%)]" />

          <button
              type="button"
              aria-label="Затвори прозореца"
              onClick={close}
              className="absolute right-4 top-4 z-20 flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-black/25 text-white transition-all hover:scale-105 hover:border-white/30 hover:bg-white/10"
          >
            <Icon name="close" className="h-6 w-6" />
          </button>

          <div className="relative z-10">
            <div className="relative mx-auto mb-7 flex h-24 w-24 items-center justify-center">
              <span className="mg-success-ring absolute inset-0 rounded-full border-2 border-[#d8b4fe]/65" />
              <span className="absolute inset-2 rounded-full bg-gradient-to-br from-[#a855f7] to-[#6b21a8] shadow-[0_0_42px_rgba(168,85,247,.55)]" />
              <svg className="relative h-12 w-12 text-white" viewBox="0 0 52 52" fill="none" aria-hidden="true">
                <path className="mg-success-check" d="M13 27.5 22 36l17-20" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span className="mg-success-sparkle absolute -right-3 top-1 text-xl text-[#f5d0fe]">✦</span>
              <span className="mg-success-sparkle absolute -left-4 bottom-2 text-base text-[#c4b5fd]" style={{ animationDelay: '.45s' }}>✦</span>
            </div>

            <h2 id="payment-success-title" className="mb-4 text-4xl font-black uppercase tracking-[0.04em] text-white md:text-5xl">
              Успех
            </h2>

            <p id="payment-success-description" className="mb-5 text-lg font-bold text-[#ede9fe] md:text-xl">
              Провери имейла си.
            </p>

            {isProfilePayment && (
                <div className="mb-5 rounded-2xl border border-[#c084fc]/20 bg-[#c084fc]/[0.07] px-5 py-4 text-sm font-medium leading-relaxed text-[#ede9fe] md:text-base">
                  Профилът ви ще бъде активиран до 24 часа. Очаквайте обаждане от нашия екип. Ще получите съобщение от имейл адрес{' '}
                  <a href={`mailto:${SITE.email}`} className="font-black text-white underline decoration-[#c084fc]/70 underline-offset-4 transition-colors hover:text-[#f5d0fe]">
                    {SITE.email}
                  </a>
                  , затова, моля, проверявайте и папка „Спам“.
                </div>
            )}

            <div className="rounded-2xl border border-white/10 bg-white/[0.055] px-5 py-4 text-sm font-medium leading-relaxed text-[#ddd6fe] md:text-base">
              При възникнал проблем се свържи с нас на:
              <a href={`tel:${SITE.phoneHref}`} className="mt-1 block text-lg font-black text-white transition-colors hover:text-[#e9d5ff]">
                0876 393 940
              </a>
            </div>
          </div>
        </div>
      </div>
  );
};

const HomeHeroVideo = () => {
  const videoRef = useRef(null);
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return undefined;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) { video.pause(); return undefined; }
    const play = () => video.play().catch(() => {});
    play();
    const onVisibility = () => document.hidden ? video.pause() : play();
    document.addEventListener('visibilitychange', onVisibility);
    return () => document.removeEventListener('visibilitychange', onVisibility);
  }, []);
  return <video ref={videoRef} className="absolute inset-0 h-full w-full object-cover" src="/videos/home-hero.mp4" autoPlay muted loop playsInline preload="metadata" disablePictureInPicture controls={false} aria-label="MG Casting showreel" />;
};

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useBodyLock(open);
  useEscape(() => setOpen(false), open);
  useEffect(() => setOpen(false), [location.pathname, location.hash]);

  const links = [
    { to: '/', label: 'Начало', end: true },
    { to: '/actors', label: 'Актьори' },
    { to: '/courses', label: 'Курсове' },
    { to: '/pricing', label: 'Цени' },
    { to: '/#about', label: 'За нас', hash: true },
    { to: '/contact', label: 'Контакти' },
  ];

  const renderDesktopLink = ({ to, label, end, hash }) => {
    if (hash) {
      return (
          <Link key={to} to={to} className="group relative flex h-[86px] items-center text-[11px] font-black uppercase tracking-[0.15em] text-slate-300 transition-colors hover:text-white">
            {label}
            <span className="absolute inset-x-0 bottom-0 h-[2px] origin-center scale-x-0 bg-gradient-to-r from-[#f59e0b] to-[#d97706] transition-transform duration-300 group-hover:scale-x-100" />
          </Link>
      );
    }

    return (
        <NavLink key={to} to={to} end={end} className="group relative flex h-[86px] items-center">
          {({ isActive }) => (
              <>
                <span className={classNames('text-[11px] font-black uppercase tracking-[0.15em] transition-colors', isActive ? 'text-white' : 'text-slate-300 group-hover:text-white')}>{label}</span>
                <span className={classNames('absolute inset-x-0 bottom-0 h-[2px] origin-center bg-gradient-to-r from-[#f59e0b] to-[#d97706] transition-transform duration-300', isActive ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100')} />
              </>
          )}
        </NavLink>
    );
  };

  return (
      <nav className="fixed inset-x-0 top-0 z-[90] border-b border-white/[0.07] bg-[#070b19]/88 backdrop-blur-2xl">
        <div className="mx-auto flex h-[72px] max-w-[1540px] items-center justify-between px-4 sm:px-5 md:px-8 xl:h-[86px] xl:px-10 2xl:px-14">
          <Link to="/" className="group flex min-w-0 items-center gap-3" aria-label="MG Casting – начало">
            <img src={SITE.logo} alt="MG casting" className="h-11 w-11 flex-none rounded-xl object-contain drop-shadow-[0_0_16px_rgba(245,158,11,.28)] xl:h-[52px] xl:w-[52px]" />
            <div className="hidden min-[430px]:block">
              <span className="block whitespace-nowrap text-base font-black uppercase leading-none tracking-[0.15em] text-white xl:text-lg">MG Casting</span>
              <span className="mt-1 block whitespace-nowrap text-[8px] font-bold uppercase tracking-[0.25em] text-[#fbbf24] xl:text-[9px]">Film casting agency</span>
            </div>
          </Link>

          <div className="hidden items-center gap-5 xl:flex 2xl:gap-7">
            <div className="flex items-center gap-5 2xl:gap-7">
              {links.map(renderDesktopLink)}
            </div>

            <div className="ml-1 flex items-center gap-3 border-l border-white/10 pl-5">
              <Link to="/pricing" className="rounded-xl border border-[#f59e0b]/30 bg-[#f59e0b]/8 px-4 py-3 text-[10px] font-black uppercase tracking-[0.15em] text-[#fcd34d] transition-all hover:-translate-y-0.5 hover:border-[#f59e0b]/60 hover:bg-[#f59e0b]/14">
                Създай профил
              </Link>
              <a href={`tel:${SITE.phoneHref}`} aria-label={`Запиши се на телефон ${SITE.phoneDisplay}`} className="group inline-flex items-center gap-2.5 rounded-xl bg-gradient-to-r from-[#f59e0b] via-[#fbbf24] to-[#d97706] px-5 py-3 text-[10px] font-black uppercase tracking-[0.16em] text-[#111827] shadow-[0_0_30px_rgba(245,158,11,.22)] transition-all hover:-translate-y-0.5 hover:shadow-[0_0_42px_rgba(217,119,6,.38)]">
                <Icon name="phone" className="h-4 w-4" />
                Запиши се
                <Icon name="arrow" className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </a>
            </div>
          </div>

          <div className="flex items-center gap-2 xl:hidden">
            <a href={`tel:${SITE.phoneHref}`} aria-label={`Запиши се на телефон ${SITE.phoneDisplay}`} className="inline-flex min-h-11 items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-[#f59e0b] to-[#d97706] px-3 text-[10px] font-black uppercase tracking-[0.12em] text-[#111827] shadow-[0_0_22px_rgba(245,158,11,.2)] min-[390px]:px-4">
              <Icon name="phone" className="h-4 w-4" />
              <span className="hidden min-[360px]:inline">Запиши се</span>
            </a>
            <button
                type="button"
                aria-label={open ? 'Затвори менюто' : 'Отвори менюто'}
                aria-expanded={open}
                aria-controls="mobile-navigation"
                onClick={() => setOpen((value) => !value)}
                className="flex h-11 w-11 items-center justify-center rounded-xl border border-white/12 bg-white/[0.055] text-white transition-colors hover:bg-white/10"
            >
              <Icon name={open ? 'close' : 'menu'} className="h-6 w-6" />
            </button>
          </div>
        </div>

        <div
            id="mobile-navigation"
            aria-hidden={!open}
            className={classNames(
                'absolute inset-x-0 top-full z-[110] px-3 pb-3 transition-[opacity,transform,visibility] duration-300 xl:hidden',
                open ? 'visible translate-y-0 opacity-100' : 'invisible -translate-y-3 opacity-0',
            )}
        >
          <button
              type="button"
              aria-label="Затвори мобилното меню"
              onClick={() => setOpen(false)}
              className={classNames(
                  'fixed inset-0 top-[72px] z-0 bg-black/55 backdrop-blur-sm transition-opacity duration-300',
                  open ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0',
              )}
          />

          <div className="relative z-10 mx-auto max-h-[calc(100dvh-88px)] max-w-lg overflow-y-auto rounded-b-[26px] border border-t-0 border-white/[0.1] bg-[#070b19]/98 p-3 shadow-[0_24px_70px_rgba(0,0,0,.58)] backdrop-blur-2xl">
            <div className="space-y-1.5">
              {links.map(({ to, label }) => {
                const active = !to.includes('#') && (to === '/' ? location.pathname === '/' : location.pathname.startsWith(to));
                return (
                    <Link
                        key={to}
                        to={to}
                        onClick={() => setOpen(false)}
                        className={classNames(
                            'group flex min-h-[48px] items-center justify-between rounded-xl border px-4 text-sm font-black uppercase tracking-[0.11em] transition-all',
                            active
                                ? 'border-[#f59e0b]/40 bg-[#f59e0b]/12 text-white'
                                : 'border-transparent text-slate-200 hover:border-white/10 hover:bg-white/[0.055]',
                        )}
                    >
                      <span>{label}</span>
                      <Icon name="arrow" className={classNames('h-4 w-4 transition-transform group-hover:translate-x-1', active ? 'text-[#fbbf24]' : 'text-slate-500')} />
                    </Link>
                );
              })}
            </div>

            <div className="mt-3 grid grid-cols-1 gap-2 border-t border-white/[0.08] pt-3 min-[420px]:grid-cols-2">
              <Link
                  to="/pricing"
                  onClick={() => setOpen(false)}
                  className="flex min-h-[48px] items-center justify-center rounded-xl border border-[#f59e0b]/30 bg-[#f59e0b]/10 px-4 text-center text-[10px] font-black uppercase tracking-[0.13em] text-[#fcd34d]"
              >
                Създай профил
              </Link>
              <a
                  href={`tel:${SITE.phoneHref}`}
                  onClick={() => setOpen(false)}
                  className="flex min-h-[48px] items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-[#f59e0b] via-[#fbbf24] to-[#d97706] px-4 text-[10px] font-black uppercase tracking-[0.13em] text-[#111827]"
              >
                <Icon name="phone" className="h-4 w-4" />
                Обади се
              </a>
            </div>
          </div>
        </div>
      </nav>
  );
};

const AudienceCard = ({ type, title, description, bullets, primary, secondary, icon }) => (
    <div className="group relative overflow-hidden rounded-2xl border border-white/10 bg-white/[0.045] p-5 backdrop-blur-xl transition-all duration-500 hover:-translate-y-2 hover:border-[#fbbf24]/35 hover:shadow-[0_25px_90px_rgba(0,0,0,.38)] md:rounded-[32px] md:p-10">
      <div className="pointer-events-none absolute -right-20 -top-20 h-60 w-60 rounded-full bg-gradient-to-br from-[#f59e0b]/12 to-[#f59e0b]/15 blur-3xl transition-transform duration-700 group-hover:scale-125" />
      <div className="relative z-10">
        <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-xl border border-white/10 bg-gradient-to-br from-[#f59e0b]/20 to-[#d97706]/20 text-[#fbbf24] shadow-inner md:mb-7 md:h-16 md:w-16 md:rounded-2xl"><Icon name={icon} className="h-7 w-7 md:h-8 md:w-8" /></div>
        <p className="mb-2 text-[10px] font-black uppercase tracking-[0.2em] text-[#fbbf24] md:mb-3 md:text-xs md:tracking-[0.25em]">{type}</p>
        <h3 className="mb-4 text-2xl font-black uppercase tracking-tight text-white md:mb-5 md:text-4xl">{title}</h3>
        <p className="mb-5 text-sm leading-relaxed text-slate-300 md:mb-7 md:text-base">{description}</p>
        <ul className="mb-6 space-y-2.5 md:mb-8 md:space-y-3">
          {bullets.map((bullet) => <li key={bullet} className="flex gap-3 text-sm font-medium text-slate-200"><span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-[#f59e0b]/15 text-[#fcd34d]"><Icon name="check" className="h-3 w-3" /></span>{bullet}</li>)}
        </ul>
        <div className="flex flex-col gap-2.5 sm:flex-row md:gap-3">
          <PrimaryLink to={primary.to} className="flex-1">{primary.label}</PrimaryLink>
          <SecondaryLink to={secondary.to} className="flex-1">{secondary.label}</SecondaryLink>
        </div>
      </div>
    </div>
);

const ProjectCard = ({ movie, wide = false }) => (
    <Link to={`/projects/${movie.id}`} className={classNames('group relative block overflow-hidden rounded-2xl border border-white/10 bg-black shadow-2xl transition-all duration-500 hover:-translate-y-1 hover:border-[#fbbf24]/45 hover:shadow-[0_20px_70px_rgba(0,0,0,.5)] md:rounded-[28px]', wide ? 'h-[220px] md:h-[380px]' : 'aspect-[2/3]')}>
      <img src={wide ? movie.cover : movie.poster} alt={`${movie.title} – ${movie.category}`} loading="lazy" decoding="async" className={classNames('absolute inset-0 h-full w-full transition-all duration-700 group-hover:scale-105 group-hover:brightness-110', wide && movie.id === 'teen-scene' ? 'object-contain p-4 md:p-10' : 'object-cover')} />
      <div className="absolute inset-0 bg-gradient-to-t from-[#070b19] via-[#070b19]/18 to-black/5 transition-colors group-hover:from-[#070b19]/95" />
      {movie.status === 'В продукция' && <div className="absolute right-0 top-3 z-20 rounded-l-lg bg-red-600 px-3 py-1.5 text-[9px] font-black uppercase tracking-[0.15em] text-white shadow-[0_0_18px_rgba(220,38,38,.55)] md:top-5 md:rounded-l-xl md:px-4 md:py-2 md:text-[10px] md:tracking-[0.18em]">В продукция</div>}
      <div className="absolute inset-x-0 bottom-0 z-10 p-4 md:p-8">
        <p className="mb-1.5 text-[9px] font-black uppercase tracking-[0.18em] text-[#f59e0b] md:mb-2 md:text-xs md:tracking-[0.22em]">{movie.category}</p>
        <h3 className="mb-3 text-xl font-black uppercase leading-tight tracking-tight text-white md:mb-5 md:text-3xl">{movie.title}</h3>
        <span className="inline-flex items-center gap-2 text-[10px] font-black uppercase tracking-[0.14em] text-white md:text-xs md:tracking-[0.18em]">Разгледай проекта <Icon name="arrow" className="h-4 w-4 transition-transform group-hover:translate-x-1" /></span>
      </div>
    </Link>
);

const MainPage = () => {
  const films = moviesList.filter((movie) => movie.id !== 'teen-scene');
  const teenScene = moviesList.find((movie) => movie.id === 'teen-scene');
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => setCurrentTestimonial((current) => (current + 1) % testimonials.length), 5000);
    return () => window.clearInterval(timer);
  }, []);

  return (
      <main className="relative min-h-screen overflow-hidden bg-[#070b19]">
        <SEO title="Кастинг агенция за кино, телевизия и реклама" description="MG Casting свързва актьори и нови лица с режисьори, продуценти и професионални продукции за кино, телевизия, реклама и музикални проекти." />
        <header className="relative flex min-h-[100svh] items-center justify-center overflow-hidden px-4 pb-10 pt-24 md:px-8 md:pb-16 md:pt-28">
          <div
              className="absolute inset-0 bg-cover bg-center"
              style={{ backgroundImage: "url('https://images.unsplash.com/photo-1485846234645-a62644f84728?q=85&w=2200')" }}
              aria-hidden="true"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-[#2a1706]/35 to-[#070b19]" />
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(245,158,11,.16),transparent_38%)]" />

          <div className="relative z-10 mx-auto flex w-full max-w-6xl flex-col items-center text-center">
            <h1 className="text-[clamp(3.2rem,17vw,4.7rem)] font-black uppercase leading-[0.84] tracking-[-0.06em] text-white drop-shadow-2xl md:text-[clamp(4rem,10vw,8.5rem)] md:leading-[0.82] md:tracking-[-0.07em]">
              Усети <span className="block bg-gradient-to-r from-amber-300 via-amber-400 to-amber-600 bg-clip-text text-transparent">емоцията</span>
            </h1>

            <div className="relative mt-6 w-full max-w-3xl overflow-hidden rounded-2xl border border-amber-300/35 bg-black shadow-[0_20px_65px_rgba(0,0,0,.52),0_0_32px_rgba(245,158,11,.16)] md:mt-9 md:rounded-3xl md:shadow-[0_25px_90px_rgba(0,0,0,.55),0_0_45px_rgba(245,158,11,.18)]">
              <div className="relative aspect-video">
                <HomeHeroVideo />
              </div>
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-amber-950/10" />
              <div className="pointer-events-none absolute inset-0 rounded-2xl ring-1 ring-white/10 md:rounded-3xl" />
            </div>

            <p className="mt-6 max-w-4xl text-sm font-semibold leading-relaxed text-slate-100 md:mt-8 md:text-xl">
              MG Casting свързва актьори и нови лица с режисьори, продуценти и професионални продукции за кино, телевизия, реклама и музикални проекти. Създай професионално присъствие, бъди откриван за подходящи кастинги и направи реална крачка към кариера пред камера.
            </p>

            <p className="mt-3 max-w-3xl text-xs font-medium leading-relaxed text-slate-300 md:mt-4 md:text-sm">
              Подборът за всяка роля се извършва от конкретната продукция и не може да бъде гарантиран.
            </p>

            <div className="mt-6 flex w-full max-w-md flex-col justify-center gap-2.5 sm:flex-row md:mt-9 md:max-w-xl md:gap-3">
              <PrimaryLink to="/pricing" className="flex-1">Създай свой профил</PrimaryLink>
              <a
                  href={`tel:${SITE.phoneHref}`}
                  className="group inline-flex min-h-11 flex-1 items-center justify-center gap-2.5 rounded-xl border border-amber-300/35 bg-black/35 px-4 py-3 text-[10px] font-black uppercase tracking-[0.14em] text-white backdrop-blur-xl transition-all duration-300 hover:-translate-y-1 hover:border-amber-400/70 hover:bg-amber-500/10 md:min-h-12 md:gap-3 md:rounded-2xl md:px-6 md:py-3.5 md:text-sm md:tracking-[0.18em]"
              >
                <Icon name="phone" className="h-5 w-5 text-amber-400" />
                Обади се
              </a>
            </div>
          </div>
        </header>

        <section id="about" className="relative scroll-mt-24 px-4 py-14 md:px-8 md:py-28">
          <GlowBackdrop />
          <div className="relative z-10 mx-auto max-w-7xl">
            <SectionHeading eyebrow="Две страни. Една сцена." title="Точният талант среща" accent="точния проект" description="Избери пътя, който отговаря на целта ти. MG Casting работи едновременно като професионален каталог за продукции и като платформа за развитие и представяне на актьори." />
            <div className="grid grid-cols-1 gap-5 md:gap-7 lg:grid-cols-2">
              <AudienceCard type="За актьори и нови лица" title="Покажи се професионално" description="Създаваме и поддържаме силно актьорско представяне, което е лесно за разглеждане от хората, вземащи решения за роли." bullets={['Профил със снимки, данни и професионална биография', 'Premium видео визитка и приоритетно позициониране', 'Актьорски обучения и подготовка за кастинг']} primary={{ to: '/pricing', label: 'Създай профил' }} secondary={{ to: '/courses', label: 'Виж обученията' }} icon="user" />
              <AudienceCard type="За режисьори и продукции" title="Открий правилното лице" description="Търси директно в каталога или се свържи с екипа на MG Casting по телефона." bullets={['Филтриране по типаж, възраст, регион и умения', 'Запитване за конкретен актьор от неговия профил', 'Директна комуникация с екипа на MG Casting']} primary={{ to: '/actors', label: 'Отвори каталога' }} secondary={{ to: '/contact', label: 'Свържи се' }} icon="briefcase" />
            </div>

            <div className="mt-7 grid grid-cols-1 gap-3 md:mt-10 md:grid-cols-3 md:gap-5">
              {[
                ['01', 'Реален кино опит', 'Зад платформата стои екип с реализирани игрални, документални и онлайн продукции.'],
                ['02', 'Подредена селекция', 'Профилите са структурирани така, че ключовата информация да се открива бързо и ясно.'],
                ['03', 'Човешка комуникация', 'След плащане или телефонно обаждане екипът поема процеса и комуникира необходимите следващи стъпки.'],
              ].map(([num, title, text]) => <div key={num} className="rounded-2xl border border-white/[0.08] bg-white/[0.035] p-5 md:rounded-3xl md:p-6"><span className="mb-5 block text-sm font-black tracking-[0.2em] text-[#fbbf24]">{num}</span><h3 className="mb-3 text-xl font-black uppercase text-white">{title}</h3><p className="text-sm leading-relaxed text-slate-400">{text}</p></div>)}
            </div>
          </div>
        </section>

        {/* Лентата остава с текущото съдържание и поведение. */}
        <div className="relative z-20 mb-8 flex w-full overflow-hidden border-y border-amber-400/50 bg-amber-500 py-2.5 text-black shadow-[0_0_20px_rgba(245,158,11,0.2)] md:mb-12 md:py-3">
          <div className="mg-marquee flex w-max items-center font-black uppercase tracking-widest text-xs md:text-sm">
            {[...castingOffers, ...castingOffers].map((offer, index) => <span key={`${offer.project}-${index}`} className="mx-8 flex items-center gap-3 whitespace-nowrap md:mx-12"><span className="h-2.5 w-2.5 animate-pulse rounded-full bg-red-600 shadow-[0_0_10px_rgba(220,38,38,.8)]" /><span>АКТИВЕН КАСТИНГ: {offer.project}</span><span className="opacity-50">•</span><span>Търсим: {offer.lookingFor}</span></span>)}
          </div>
        </div>

        <section id="projects" className="relative px-4 py-14 md:px-8 md:py-28">
          <div className="mx-auto max-w-7xl">
            <SectionHeading eyebrow="Кино и продукции" title="Каталог" accent="проекти" description="Реализирани и предстоящи заглавия, които показват визуалния език, опита и средата, в която MG Casting работи." />
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 md:gap-7 lg:grid-cols-3">
              {films.map((movie) => <ProjectCard key={movie.id} movie={movie} />)}
              {teenScene && <div className="sm:col-span-2 lg:col-span-3"><ProjectCard movie={teenScene} wide /></div>}
            </div>
          </div>
        </section>

        <section className="relative border-y border-white/[0.06] bg-black/20 px-4 py-14 md:px-8 md:py-20">
          <div className="mx-auto grid max-w-6xl grid-cols-1 gap-5 text-center md:grid-cols-3 md:gap-6">
            <AnimatedCounter endValue={12} suffix=" ФИЛМА" />
            <AnimatedCounter endValue={1000} suffix="+ УЧАСТНИЦИ" />
            <AnimatedCounter endValue={1000000} suffix="+ ГЛЕДАНИЯ" />
          </div>
        </section>

        {/* Отзивите остават със същото съдържание. */}
        <section className="relative px-4 py-16 md:px-8 md:py-24">
          <div className="relative z-10 mx-auto max-w-4xl text-center">
            <div className="mb-2 font-serif text-6xl leading-none text-amber-500 opacity-50 md:mb-4 md:text-7xl">&quot;</div>
            <div className="relative flex h-52 items-center justify-center md:h-40">
              {testimonials.map((testimonial, index) => <div key={testimonial.author} className={classNames('absolute w-full transition-opacity duration-1000', index === currentTestimonial ? 'z-10 opacity-100' : 'z-0 opacity-0')}><p className="mb-5 text-lg italic leading-relaxed text-gray-200 drop-shadow-md md:mb-6 md:text-3xl">{testimonial.quote}</p><p className="text-sm font-bold uppercase tracking-widest text-amber-500">— {testimonial.author}</p></div>)}
            </div>
          </div>
        </section>

        <section className="relative overflow-hidden px-4 py-16 md:px-8 md:py-32">
          <GlowBackdrop />
          <div className="relative z-10 mx-auto max-w-6xl overflow-hidden rounded-3xl border border-white/12 bg-gradient-to-br from-[#2a1d0c]/85 via-[#17120b]/90 to-[#2a1808]/85 p-6 text-center shadow-[0_24px_80px_rgba(0,0,0,.48)] md:rounded-[38px] md:p-14 md:shadow-[0_30px_110px_rgba(0,0,0,.5)]">
            <p className="mb-4 text-xs font-black uppercase tracking-[0.28em] text-[#fbbf24]">Следващата роля започва оттук</p>
            <h2 className="mx-auto max-w-4xl text-3xl font-black uppercase leading-[1] tracking-tight text-white md:text-7xl md:leading-[.98]">Създай присъствие, което се забелязва.</h2>
            <p className="mx-auto mt-4 max-w-2xl text-sm text-slate-300 md:mt-6 md:text-base">Избери профил, разгледай обученията или се свържи с екипа за своята продукция.</p>
            <div className="mt-6 flex flex-col justify-center gap-2.5 sm:flex-row md:mt-9 md:gap-3"><PrimaryLink to="/pricing">Виж плановете</PrimaryLink><SecondaryLink to="/contact">Свържи се</SecondaryLink></div>
          </div>
        </section>
      </main>
  );
};

const ProjectDetails = () => {
  const { id } = useParams();
  const movie = moviesList.find((item) => item.id === id);
  if (!movie) return <NotFound compact />;

  const relatedMovies = moviesList
      .filter((item) => item.id !== movie.id && item.id !== 'teen-scene')
      .sort((a, b) => {
        const aScore = Number(a.director === movie.director) + Number(a.category === movie.category);
        const bScore = Number(b.director === movie.director) + Number(b.category === movie.category);
        return bScore - aScore;
      }).slice(0, 3);
  const hasSidebar = Boolean(movie.trailerId || movie.gallery?.length || movie.cast?.length);

  return (
      <main className="min-h-screen bg-[#070b19] pt-[72px] md:pt-[76px]">
        <SEO title={movie.title} description={movie.description.split('\n')[0]} image={movie.cover || movie.poster} canonical={`${SITE.domain}/projects/${movie.id}`} />
        <section className="relative flex min-h-[55vh] items-end overflow-hidden px-4 pb-9 pt-16 md:min-h-[82vh] md:px-8 md:pb-14 md:pt-24">
          <img src={movie.cover || movie.poster} alt={`${movie.title} – официално изображение`} className={classNames('absolute inset-0 h-full w-full opacity-80', movie.id === 'teen-scene' ? 'object-contain p-4 md:p-8' : 'object-cover')} />
          <div className="absolute inset-0 bg-gradient-to-t from-[#070b19] via-[#070b19]/45 to-black/10" />
          <div className="relative z-10 mx-auto w-full max-w-7xl">
            <Link to="/#projects" className="mb-5 inline-flex items-center gap-2 text-[10px] font-black uppercase tracking-[0.14em] text-[#fbbf24] hover:text-white md:mb-8 md:text-xs md:tracking-[0.18em]"><Icon name="back" /> Назад към проектите</Link>
            <div className="mb-3 flex flex-wrap items-center gap-2 text-[10px] font-black uppercase tracking-[0.14em] text-[#fbbf24] md:mb-4 md:gap-3 md:text-xs md:tracking-[0.18em]"><span>{movie.category}</span>{movie.status && <><span className="opacity-40">•</span><span className="rounded-lg border border-red-500/25 bg-red-500/10 px-2 py-1 text-red-400">{movie.status}</span></>}</div>
            <h1 className="max-w-6xl text-4xl font-black uppercase leading-[.92] tracking-[-.045em] text-white drop-shadow-2xl md:text-8xl md:leading-[.9] md:tracking-[-.055em]">{movie.title}</h1>
          </div>
        </section>

        <section className={classNames('mx-auto grid max-w-7xl gap-8 px-4 py-12 md:gap-12 md:px-8 md:py-24', hasSidebar ? 'lg:grid-cols-[1fr_360px]' : 'max-w-5xl')}>
          <div className="space-y-10 md:space-y-16">
            <div>
              <p className="mb-4 text-xs font-black uppercase tracking-[0.23em] text-[#fbbf24]">За проекта</p>
              <p className="whitespace-pre-line text-base font-medium leading-[1.75] text-slate-300 md:text-lg md:leading-[1.85]">{movie.description}</p>
            </div>
            {movie.trailerId && <div><h2 className="mb-4 text-xl font-black uppercase tracking-[0.12em] text-white md:mb-6 md:text-2xl md:tracking-widest">{movie.category === 'Talk Show' ? 'Епизод' : 'Официален трейлър'}</h2><div className="aspect-video overflow-hidden rounded-2xl border border-white/10 bg-black shadow-2xl md:rounded-3xl"><iframe loading="lazy" width="100%" height="100%" src={`https://www.youtube-nocookie.com/embed/${movie.trailerId}`} title={`${movie.title} видео`} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen /></div></div>}
            {movie.gallery?.length > 0 && <Gallery images={movie.gallery} altPrefix={movie.title} />}
          </div>
          {hasSidebar && <aside className="h-fit rounded-2xl border border-white/10 bg-white/[0.045] p-5 backdrop-blur-xl md:rounded-[30px] md:p-7 lg:sticky lg:top-28"><p className="mb-6 text-xs font-black uppercase tracking-[0.22em] text-[#fbbf24]">Екип и участници</p><div className="space-y-6"><MetaBlock label="Режисьор" value={movie.director} /><MetaBlock label="Продуцент" value={movie.producer} />{movie.crew?.map((member) => <MetaBlock key={`${member.role}-${member.name}`} label={member.role} value={member.name} />)}{movie.cast?.length > 0 && <div className="border-t border-white/8 pt-5"><p className="mb-3 text-[10px] font-black uppercase tracking-[0.2em] text-slate-500">Участват</p><div className="flex flex-wrap gap-2">{movie.cast.map((actorName) => <span key={String(actorName)} className="rounded-lg border border-white/8 bg-black/25 px-3 py-1.5 text-sm text-slate-300">{String(actorName)}</span>)}</div></div>}</div></aside>}
        </section>

        <section className="border-t border-white/[0.07] px-4 py-14 md:px-8 md:py-20"><div className="mx-auto max-w-7xl"><SectionHeading eyebrow="Още заглавия" title="Свързани" accent="проекти" /><div className="grid grid-cols-1 gap-5 sm:grid-cols-2 md:gap-7 lg:grid-cols-3">{relatedMovies.map((related) => <ProjectCard key={related.id} movie={related} />)}</div></div></section>
      </main>
  );
};

const MetaBlock = ({ label, value }) => <div><p className="mb-1 text-[10px] font-black uppercase tracking-[0.2em] text-[#f59e0b]">{label}</p><p className="text-lg font-semibold text-white">{value || 'Очаква информация'}</p></div>;

const Gallery = ({ images, altPrefix, premium = false }) => {
  const initialImages = useMemo(
      () => [...new Set((images || []).filter(Boolean))],
      [images]
  );
  const [visibleImages, setVisibleImages] = useState(initialImages);
  const [active, setActive] = useState(null);

  useEffect(() => {
    setVisibleImages(initialImages);
    setActive(null);
  }, [initialImages]);

  useBodyLock(active !== null);
  useEscape(() => setActive(null), active !== null);

  const removeBrokenImage = (brokenImage) => {
    setVisibleImages((currentImages) => {
      const nextImages = currentImages.filter((image) => image !== brokenImage);

      setActive((currentIndex) => {
        if (currentIndex === null) return null;
        if (nextImages.length === 0) return null;
        if (currentIndex >= nextImages.length) return nextImages.length - 1;
        return currentIndex;
      });

      return nextImages;
    });
  };

  const previous = () => {
    setActive((index) => {
      if (index === null || visibleImages.length === 0) return null;
      return (index - 1 + visibleImages.length) % visibleImages.length;
    });
  };

  const next = () => {
    setActive((index) => {
      if (index === null || visibleImages.length === 0) return null;
      return (index + 1) % visibleImages.length;
    });
  };

  if (visibleImages.length === 0) return null;

  return (
      <div className={premium ? 'mg-premium-reveal mg-premium-delay-3' : ''}>
        <div className="mb-5 flex items-end justify-between gap-4 md:mb-7">
          <div>
            {premium && <p className="mb-2 text-[9px] font-black uppercase tracking-[0.34em] text-amber-300 md:text-[10px]">Premium portfolio</p>}
            <h2 className="text-xl font-black uppercase tracking-[0.12em] text-white md:text-2xl md:tracking-widest">Галерия</h2>
          </div>
          {premium && <span className="rounded-full border border-amber-300/30 bg-amber-300/10 px-3 py-1.5 text-[9px] font-black uppercase tracking-[0.2em] text-amber-200 backdrop-blur-xl">{visibleImages.length} кадъра</span>}
        </div>

        <div className={classNames('grid grid-cols-2 gap-2.5 md:gap-4', premium ? 'md:grid-cols-2 lg:grid-cols-3' : 'md:grid-cols-3')}>
          {visibleImages.map((image, index) => (
              <button
                  type="button"
                  key={`${image}-${index}`}
                  onClick={() => setActive(index)}
                  style={premium ? { animationDelay: `${0.08 * index}s` } : undefined}
                  className={classNames('overflow-hidden bg-black text-left transition-all duration-500', premium ? 'mg-premium-gallery-item aspect-[4/5] rounded-2xl border border-amber-300/55 ring-1 ring-amber-200/20 shadow-[0_0_0_1px_rgba(251,191,36,.12),0_0_24px_rgba(245,158,11,.14),0_18px_55px_rgba(0,0,0,.42)] hover:-translate-y-1 hover:border-amber-200/85 hover:ring-amber-200/35 hover:shadow-[0_0_34px_rgba(245,158,11,.28),0_24px_70px_rgba(0,0,0,.5)] md:rounded-[26px]' : 'aspect-square rounded-xl border border-white/8 md:rounded-2xl')}
              >
                <img
                    src={image}
                    alt={`${altPrefix} – снимка ${index + 1}`}
                    loading="lazy"
                    decoding="async"
                    onError={() => removeBrokenImage(image)}
                    className={classNames('h-full w-full object-cover transition-transform hover:scale-105', premium ? 'duration-700' : 'duration-500')}
                />
              </button>
          ))}
        </div>

        {active !== null && visibleImages[active] && createPortal(
            <div
                role="dialog"
                aria-modal="true"
                className="fixed inset-0 z-[9999] flex min-h-[100dvh] w-screen items-center justify-center overflow-hidden bg-black/95 p-3 backdrop-blur-xl md:p-6"
                onClick={() => setActive(null)}
            >
              <button
                  type="button"
                  aria-label="Затвори галерията"
                  onClick={() => setActive(null)}
                  className="absolute right-3 top-3 rounded-full border border-white/15 bg-white/5 p-2.5 text-white md:right-5 md:top-5 md:p-3"
              >
                <Icon name="close" />
              </button>

              {visibleImages.length > 1 && (
                  <button
                      type="button"
                      aria-label="Предишна снимка"
                      onClick={(event) => {
                        event.stopPropagation();
                        previous();
                      }}
                      className="absolute left-2 rounded-full border border-white/15 bg-black/35 p-2.5 text-white md:left-8 md:p-3"
                  >
                    <Icon name="back" />
                  </button>
              )}

              <img
                  src={visibleImages[active]}
                  alt={`${altPrefix} – снимка ${active + 1}`}
                  onError={() => removeBrokenImage(visibleImages[active])}
                  className={classNames(
                      'block h-auto w-auto rounded-xl object-contain shadow-2xl md:rounded-2xl',
                      premium
                          ? 'max-h-[calc(100dvh-6rem)] max-w-[calc(100vw-4rem)] md:max-h-[calc(100dvh-4rem)] md:max-w-[calc(100vw-8rem)]'
                          : 'max-h-[84vh] max-w-[90vw] md:max-h-[88vh] md:max-w-[92vw]'
                  )}
                  style={premium ? { maxHeight: 'calc(100dvh - 6rem)', maxWidth: 'calc(100vw - 4rem)' } : undefined}
                  onClick={(event) => event.stopPropagation()}
              />

              {visibleImages.length > 1 && (
                  <button
                      type="button"
                      aria-label="Следваща снимка"
                      onClick={(event) => {
                        event.stopPropagation();
                        next();
                      }}
                      className="absolute right-2 rounded-full border border-white/15 bg-black/35 p-2.5 text-white md:right-8 md:p-3"
                  >
                    <Icon name="arrow" />
                  </button>
              )}

              <span className="absolute bottom-4 text-[10px] font-bold tracking-widest text-slate-300 md:bottom-5 md:text-xs">
                {active + 1} / {visibleImages.length}
              </span>
            </div>,
            document.body
        )}
      </div>
  );
};

const ActorCard = ({ actor }) => {
  const videoRef = useRef(null);
  const [touchPreview, setTouchPreview] = useState(false);
  const play = () => videoRef.current?.play().catch(() => {});
  const stop = () => { if (videoRef.current) { videoRef.current.pause(); videoRef.current.currentTime = 0; } };

  return (
      <article className={classNames('group relative overflow-hidden rounded-2xl transition-all duration-500 hover:-translate-y-2 md:rounded-[26px]', actor.isPremium ? 'border border-amber-300/45 bg-gradient-to-b from-[#17120a] via-[#0d101b] to-[#080b13] shadow-[0_24px_80px_rgba(245,158,11,.16)] hover:border-amber-200 hover:shadow-[0_30px_95px_rgba(245,158,11,.24)]' : 'border border-white/10 bg-[#0a0f1d] hover:border-[#fbbf24]/45 hover:shadow-[0_25px_70px_rgba(0,0,0,.55)]')}>
        {actor.isPremium && <div className="pointer-events-none absolute inset-0 z-20 bg-[radial-gradient(circle_at_20%_0%,rgba(251,191,36,.16),transparent_38%)]" />}
        {actor.isPremium && <div className="pointer-events-none absolute right-0 top-0 z-30 h-20 w-20 overflow-hidden md:h-24 md:w-24"><div className="absolute right-[-37px] top-[15px] w-[122px] rotate-45 bg-gradient-to-r from-amber-300 via-yellow-400 to-amber-600 py-1 text-center text-[7px] font-black uppercase tracking-widest text-black shadow-[0_0_18px_rgba(245,158,11,.72)] md:right-[-35px] md:top-[18px] md:w-[130px] md:text-[8px]">Premium</div></div>}
        <Link to={`/actors/${actor.slug}`} className="block" onMouseEnter={play} onMouseLeave={stop}>
          <div className="relative aspect-[3/4] overflow-hidden bg-zinc-950">
            {actor.showreel && <video ref={videoRef} src={actor.showreel} muted loop playsInline preload="none" className={classNames('absolute inset-0 z-10 h-full w-full object-cover transition-opacity duration-500', touchPreview ? 'opacity-100' : 'opacity-0 group-hover:opacity-100')} />}
            <img src={actor.photo} alt={`${actor.name} – актьорски профил`} loading="lazy" decoding="async" className={classNames('absolute inset-0 h-full w-full object-cover transition-all duration-700 group-hover:scale-105', actor.showreel && (touchPreview ? 'opacity-0' : 'group-hover:opacity-0'))} />
            <div className="absolute inset-0 z-20 bg-gradient-to-t from-[#0a0f1d] via-transparent to-black/5" />
            <div className="absolute bottom-0 left-0 right-0 z-30 p-4 md:p-5">
              <div className="mb-2.5 flex flex-wrap gap-1.5 md:mb-3 md:gap-2"><span className="rounded-lg border border-white/10 bg-black/40 px-2 py-1 text-[9px] font-bold uppercase tracking-wider text-slate-200 backdrop-blur-md md:px-2.5 md:text-[10px]">{actor.screenAge} екранна възраст</span><span className="rounded-lg border border-white/10 bg-black/40 px-2 py-1 text-[9px] font-bold uppercase tracking-wider text-slate-200 backdrop-blur-md md:px-2.5 md:text-[10px]">{actor.region}</span></div>
              <h3 className={classNames('text-xl font-black uppercase leading-tight tracking-tight md:text-2xl', actor.isPremium ? 'bg-gradient-to-r from-white via-amber-100 to-amber-300 bg-clip-text text-transparent' : 'text-white')}>{actor.name}</h3>
              <p className="mt-1 text-[10px] font-black uppercase tracking-[0.14em] text-[#fbbf24] md:text-xs md:tracking-[0.17em]">{actor.category}</p>
            </div>
          </div>
          <div className="flex items-center justify-between px-4 py-4 md:px-5 md:py-5"><span className="text-[10px] font-black uppercase tracking-[0.14em] text-white md:text-xs md:tracking-[0.16em]">Виж профила</span><span className="flex h-8 w-8 items-center justify-center rounded-full border border-white/10 bg-white/5 text-[#fbbf24] transition-transform group-hover:translate-x-1 md:h-9 md:w-9"><Icon name="arrow" className="h-4 w-4" /></span></div>
        </Link>
        {actor.showreel && <button type="button" aria-label="Пусни видео визитката" onClick={() => { setTouchPreview((value) => !value); window.setTimeout(play, 0); }} className="absolute left-3 top-3 z-40 flex items-center gap-2 rounded-lg border border-white/12 bg-black/45 px-2.5 py-2 text-[9px] font-black uppercase tracking-widest text-white backdrop-blur-md md:hidden"><Icon name={touchPreview ? 'close' : 'play'} className="h-4 w-4" /> Видео</button>}
      </article>
  );
};

const FilterPanel = ({ filters, onChange, onApply, onClear, regions, hairColors, eyeColors, horizontal = false }) => {
  const [showMoreLocations, setShowMoreLocations] = useState(false);
  const primaryLocations = [
    { label: 'София', value: 'София-град' },
    { label: 'София област', value: 'София област' },
    { label: 'Варна', value: 'Варна' },
    { label: 'Пловдив', value: 'Пловдив' },
    { label: 'Бургас', value: 'Бургас' },
  ];
  const primaryValues = primaryLocations.map((item) => item.value);
  const additionalLocations = regions.filter((region) => !primaryValues.includes(region));

  const choose = (name, value) => {
    onChange({ target: { name, value: filters[name] === value ? '' : value } });
  };

  const FilterButton = ({ name, value, children }) => {
    const active = filters[name] === value;
    return (
        <button
            type="button"
            onClick={() => choose(name, value)}
            className={classNames(
                'min-h-10 rounded-xl border px-3 py-2 text-[10px] font-bold transition-all md:px-4 md:text-[11px]',
                active
                    ? 'border-[#f59e0b] bg-[#f59e0b] text-black shadow-[0_8px_24px_rgba(245,158,11,.18)]'
                    : 'border-white/[0.08] bg-white/[0.035] text-slate-300 hover:border-white/20 hover:bg-white/[0.07] hover:text-white'
            )}
        >
          {children}
        </button>
    );
  };

  const compactGroups = [
    ['gender', 'Пол', ['Мъж', 'Жена']],
    ['age', 'Възраст', ['0-13', '14-18', '19-28', '29-44', '45+']],
    ['hairColor', 'Коса', hairColors],
    ['eyes', 'Цвят на очите', eyeColors],
  ];

  return (
      <div
          className="space-y-5"
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              onApply();
            }
          }}
      >
        <fieldset>
          <div className="mb-3 flex items-center justify-between gap-4">
            <legend className="text-[10px] font-black uppercase tracking-[0.18em] text-white md:text-[11px]">Местоположение</legend>
            {filters.region && (
                <button type="button" onClick={() => choose('region', filters.region)} className="text-[10px] font-bold text-[#fbbf24] hover:text-amber-200">Изчисти</button>
            )}
          </div>
          <div className="flex flex-wrap gap-2">
            {primaryLocations.map((location) => (
                <FilterButton key={location.value} name="region" value={location.value}>{location.label}</FilterButton>
            ))}
            <button
                type="button"
                onClick={() => setShowMoreLocations((value) => !value)}
                className={classNames(
                    'inline-flex min-h-10 items-center gap-2 rounded-xl border px-3 py-2 text-[10px] font-black uppercase tracking-[0.12em] transition-all md:px-4 md:text-[11px]',
                    showMoreLocations || (filters.region && !primaryValues.includes(filters.region))
                        ? 'border-[#f59e0b]/45 bg-[#f59e0b]/10 text-[#fbbf24]'
                        : 'border-white/[0.08] bg-white/[0.035] text-slate-300 hover:border-white/20 hover:bg-white/[0.07] hover:text-white'
                )}
            >
              Още
              <Icon name="arrow" className={classNames('h-3.5 w-3.5 transition-transform', showMoreLocations ? '-rotate-90' : 'rotate-90')} />
            </button>
          </div>

          {showMoreLocations && additionalLocations.length > 0 && (
              <div className="mt-3 rounded-2xl border border-white/[0.07] bg-black/20 p-3 md:p-4">
                <p className="mb-3 text-[9px] font-black uppercase tracking-[0.16em] text-slate-500">Други области и местности</p>
                <div className="flex flex-wrap gap-2">
                  {additionalLocations.map((region) => (
                      <FilterButton key={region} name="region" value={region}>{region}</FilterButton>
                  ))}
                </div>
              </div>
          )}
        </fieldset>

        <div className="grid grid-cols-1 gap-x-5 gap-y-6 border-t border-white/[0.07] pt-5 sm:grid-cols-2">
          {compactGroups.map(([name, label, options]) => (
              <fieldset key={name} className="min-w-0 rounded-2xl border border-white/[0.06] bg-black/15 p-3.5">
                <legend className="mb-2 text-[10px] font-black uppercase tracking-[0.16em] text-white md:text-[11px]">{label}</legend>
                <div className="flex flex-wrap gap-2">
                  {options.map((option) => (
                      <FilterButton key={option} name={name} value={option}>{option}</FilterButton>
                  ))}
                </div>
              </fieldset>
          ))}

          <div className="flex flex-wrap gap-2 sm:col-span-2 sm:justify-end">
            <button type="button" onClick={onApply} className="min-h-10 rounded-xl bg-[#f59e0b] px-5 py-2 text-[10px] font-black uppercase tracking-widest text-black shadow-[0_8px_24px_rgba(245,158,11,.16)] hover:bg-[#fbbf24] md:text-[11px]">Приложи</button>
            <button type="button" onClick={onClear} className="min-h-10 rounded-xl border border-white/10 bg-white/5 px-4 py-2 text-[10px] font-black uppercase tracking-widest text-slate-300 hover:bg-white/10 hover:text-white md:text-[11px]">Изчисти</button>
          </div>
        </div>
      </div>
  );
};

const ActorsPage = () => {
  const [activePill, setActivePill] = useState('Всички');
  const empty = { search: '', gender: '', age: '', region: '', hairColor: '', eyes: '' };
  const [tempFilters, setTempFilters] = useState(empty);
  const [activeFilters, setActiveFilters] = useState(empty);
  const [filtersOpen, setFiltersOpen] = useState(false);
  const regions = useMemo(() => [...new Set(actorProfiles.flatMap((actor) => getActorRegionCategories(actor.region)))].sort((a, b) => a.localeCompare(b, 'bg')), []);
  const hairColors = HAIR_FILTER_OPTIONS;
  const eyeColors = useMemo(() => [...new Set(actorProfiles.map((actor) => actor.eyes).filter(Boolean))].sort((a, b) => a.localeCompare(b, 'bg')), []);
  useBodyLock(filtersOpen);
  useEscape(() => setFiltersOpen(false), filtersOpen);

  const handleChange = ({ target: { name, value } }) => setTempFilters((previous) => ({ ...previous, [name]: value }));
  const apply = () => { setActiveFilters({ ...tempFilters, search: tempFilters.search.trim() }); setFiltersOpen(false); };
  const clear = () => { setTempFilters(empty); setActiveFilters(empty); setActivePill('Всички'); };
  const removeFilter = (key) => { const next = { ...tempFilters, [key]: '' }; setTempFilters(next); setActiveFilters(next); };
  const setQuickRegion = (value) => {
    const next = { ...tempFilters, region: value };
    setTempFilters(next);
    setActiveFilters({ ...next, search: next.search.trim() });
  };

  const filteredActors = useMemo(() => actorProfiles.filter((actor) => {
    if (activePill !== 'Всички' && actor.category !== activePill) return false;
    const terms = activeFilters.search.toLowerCase().trim().split(/\s+/).filter(Boolean);
    const profile = `${actor.name} ${actor.age} ${actor.screenAge} ${actor.gender} ${actor.region} ${actor.hairColor} ${actor.height} ${actor.eyes} ${actor.experience} ${actor.skills} ${actor.languages} ${actor.category}`.toLowerCase();
    if (terms.some((term) => !profile.includes(term))) return false;
    if (activeFilters.gender && actor.gender !== activeFilters.gender) return false;
    if (activeFilters.region && !getActorRegionCategories(actor.region).includes(activeFilters.region)) return false;
    if (activeFilters.hairColor && getHairFilterCategory(actor.hairColor) !== activeFilters.hairColor) return false;
    if (activeFilters.eyes && actor.eyes !== activeFilters.eyes) return false;
    if (activeFilters.age === '0-13' && actor.age > 13) return false;
    if (activeFilters.age === '14-18' && (actor.age < 14 || actor.age > 18)) return false;
    if (activeFilters.age === '19-28' && (actor.age < 19 || actor.age > 28)) return false;
    if (activeFilters.age === '29-44' && (actor.age < 29 || actor.age > 44)) return false;
    if (activeFilters.age === '45+') return actor.age >= 45;
    return true;
  }).sort((a, b) => Number(b.isPremium) - Number(a.isPremium)), [activePill, activeFilters]);

  const activeChips = Object.entries(activeFilters).filter(([, value]) => value);

  if (actorProfiles.length === 0) {
    return (
        <main className="relative min-h-screen overflow-hidden bg-[#070b19] px-4 pb-16 pt-24 md:px-8 md:pb-24 md:pt-28 xl:pt-36">
          <SEO title="Актьорски каталог" description="Каталогът на MG Casting се подготвя за публикуване на реални актьори и нови лица." canonical={`${SITE.domain}/actors`} />
          <GlowBackdrop />
          <div className="relative z-10 mx-auto max-w-7xl">
            <SectionHeading eyebrow="Talent database" title="Нашите" accent="актьори" description="Подготвяме каталога за първите реални профили на професионални актьори и нови лица." />

            <section className="mx-auto max-w-3xl rounded-[28px] border border-white/10 bg-white/[0.045] px-5 py-14 text-center shadow-[0_25px_90px_rgba(0,0,0,.28)] backdrop-blur-xl md:rounded-[36px] md:px-10 md:py-20">
              <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl border border-[#f59e0b]/25 bg-[#f59e0b]/10 text-[#fbbf24] md:h-20 md:w-20 md:rounded-3xl">
                <Icon name="user" className="h-8 w-8 md:h-10 md:w-10" />
              </div>
              <p className="mb-3 text-[10px] font-black uppercase tracking-[0.24em] text-[#fbbf24] md:text-xs">Каталогът се подготвя</p>
              <h1 className="mb-5 text-2xl font-black uppercase leading-tight text-white md:text-4xl">Скоро тук ще бъдат добавени новите реални лица</h1>
              <p className="mx-auto max-w-2xl text-sm font-medium leading-relaxed text-slate-300 md:text-base">Каталогът се обновява. Скоро тук ще бъдат публикувани профили на реални професионални актьори и нови лица със снимки, информация и професионален опит.</p>
            </section>
          </div>
        </main>
    );
  }

  return (
      <main className="relative min-h-screen overflow-hidden bg-[#070b19] px-4 pb-16 pt-24 md:px-8 md:pb-24 md:pt-28 xl:pt-36">
        <SEO title="Актьорски каталог" description="Разгледай професионални актьори и нови лица в каталога на MG Casting. Филтрирай по възраст, пол, регион, типаж и умения." canonical={`${SITE.domain}/actors`} />
        <GlowBackdrop />
        <div className="relative z-10 mx-auto max-w-7xl">
          <SectionHeading eyebrow="Talent database" title="Нашите" accent="актьори" />

          <div className="mb-5 rounded-2xl border border-white/10 bg-white/[0.04] p-2.5 shadow-[0_14px_45px_rgba(0,0,0,.16)] backdrop-blur-xl md:mb-7 md:rounded-3xl md:p-3">
            <div className="flex flex-col gap-2.5 lg:flex-row lg:items-center">
              <div className="relative min-w-0 flex-1">
                <input
                    name="search"
                    type="search"
                    inputMode="search"
                    enterKeyHint="search"
                    value={tempFilters.search}
                    onChange={handleChange}
                    onKeyDown={(event) => { if (event.key === 'Enter') { event.preventDefault(); apply(); } }}
                    placeholder="Търси актьор, умение или град…"
                    className="h-11 w-full rounded-xl border border-white/10 bg-black/25 px-3 text-sm text-white outline-none transition-colors placeholder:text-slate-600 focus:border-[#f59e0b]/55 md:h-12"
                />
              </div>

              <select
                  value={activePill}
                  onChange={(event) => setActivePill(event.target.value)}
                  aria-label="Категория актьори"
                  className="h-11 rounded-xl border border-white/10 bg-[#0b101d] px-3 text-xs font-bold text-white outline-none focus:border-[#f59e0b]/55 md:h-12 md:min-w-[190px]"
              >
                <option value="Всички">Всички профили</option>
                <option value="Професионални актьори">Професионални актьори</option>
                <option value="Нови лица">Нови лица</option>
              </select>

              <select
                  value={tempFilters.region}
                  onChange={(event) => setQuickRegion(event.target.value)}
                  aria-label="Местоположение"
                  className="h-11 rounded-xl border border-white/10 bg-[#0b101d] px-3 text-xs font-bold text-white outline-none focus:border-[#f59e0b]/55 md:h-12 md:min-w-[170px]"
              >
                <option value="">Всички локации</option>
                <optgroup label="Основни">
                  <option value="София-град">София</option>
                  <option value="София област">София област</option>
                  <option value="Варна">Варна</option>
                  <option value="Пловдив">Пловдив</option>
                  <option value="Бургас">Бургас</option>
                </optgroup>
                <optgroup label="Още">
                  {regions.filter((region) => !['София-град', 'София област', 'Варна', 'Пловдив', 'Бургас'].includes(region)).map((region) => <option key={region} value={region}>{region}</option>)}
                </optgroup>
              </select>

              <div className="flex gap-2">
                <button type="button" onClick={apply} className="h-11 flex-1 rounded-xl bg-[#f59e0b] px-5 text-[10px] font-black uppercase tracking-widest text-black hover:bg-[#fbbf24] md:h-12 lg:flex-none">Търси</button>
                <button type="button" onClick={() => setFiltersOpen(true)} className="flex h-11 flex-1 items-center justify-center gap-2 rounded-xl border border-white/10 bg-white/5 px-4 text-[10px] font-black uppercase tracking-widest text-white hover:bg-white/10 md:h-12 lg:flex-none">
                  <Icon name="filter" className="h-4 w-4" /> Филтри
                  {activeChips.length > 0 && <span className="rounded-full bg-[#f59e0b] px-1.5 py-0.5 text-[8px] text-black">{activeChips.length}</span>}
                </button>
              </div>
            </div>

            {activeChips.length > 0 && (
                <div className="mt-2.5 flex flex-wrap items-center gap-1.5 border-t border-white/[0.07] pt-2.5">
                  {activeChips.map(([key, value]) => <button type="button" key={key} onClick={() => removeFilter(key)} className="inline-flex items-center gap-1.5 rounded-full border border-[#f59e0b]/20 bg-[#f59e0b]/8 px-2.5 py-1 text-[9px] font-bold text-slate-200">{value}<Icon name="close" className="h-3 w-3" /></button>)}
                  <button type="button" onClick={clear} className="px-2 py-1 text-[9px] font-bold text-[#fbbf24]">Изчисти</button>
                </div>
            )}
          </div>

          <div>
            <div className="mb-5 flex items-center justify-between gap-4 md:mb-7"><p className="text-xs font-bold text-slate-400 md:text-sm">Открити профили</p><p className="text-xs font-black uppercase tracking-[0.13em] text-[#fbbf24] md:text-sm md:tracking-widest">{filteredActors.length} резултата</p></div>
            {filteredActors.length ? <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:gap-8 lg:grid-cols-3">{filteredActors.map((actor) => <ActorCard key={actor.id} actor={actor} />)}</div> : <div className="rounded-2xl border border-white/10 bg-white/[0.035] px-5 py-14 text-center md:rounded-3xl md:px-6 md:py-20"><h3 className="mb-3 text-xl font-black uppercase text-white md:text-2xl">Няма намерени профили</h3><p className="mb-6 text-sm text-slate-400 md:mb-7 md:text-base">Промени търсенето или изчисти част от филтрите.</p><button type="button" onClick={clear} className="rounded-xl bg-[#f59e0b] px-5 py-3 text-[10px] font-black uppercase tracking-widest text-black md:px-6 md:text-xs">Изчисти филтрите</button></div>}
          </div>
        </div>

        <div className={classNames('fixed inset-0 z-[140] bg-black/75 backdrop-blur-sm transition-opacity', filtersOpen ? 'visible opacity-100' : 'invisible opacity-0')} onClick={() => setFiltersOpen(false)} />
        <aside className={classNames('fixed bottom-0 right-0 top-0 z-[150] w-[min(94vw,430px)] overflow-y-auto border-l border-white/10 bg-[#0a0f1d] p-5 shadow-2xl transition-transform duration-300', filtersOpen ? 'translate-x-0' : 'translate-x-full')}><div className="mb-6 flex items-center justify-between"><h2 className="text-lg font-black uppercase tracking-widest text-white">Филтри</h2><button type="button" onClick={() => setFiltersOpen(false)} className="rounded-full border border-white/10 p-2 text-white"><Icon name="close" /></button></div><FilterPanel filters={tempFilters} onChange={handleChange} onApply={apply} onClear={clear} regions={regions} hairColors={hairColors} eyeColors={eyeColors} /></aside>
      </main>
  );
};

const ActorProfile = () => {
  const { id } = useParams();
  const [profileModal, setProfileModal] = useState(null);
  const actor = actorProfiles.find((item) => item.slug === id || String(item.id) === id);
  useBodyLock(Boolean(profileModal));
  useEscape(() => setProfileModal(null), Boolean(profileModal));
  if (!actor) return <NotFound compact />;

  const isFemale = actor.gender === 'Жена';
  const performerLabel = isFemale ? 'актрисата' : 'актьора';
  const suitabilityQuestion = actor.name === 'Емили Влайкова'
      ? 'Подходяща ли е Емили за вашата роля?'
      : isFemale
          ? 'Подходяща ли е актрисата за твоята роля?'
          : 'Подходящ ли е актьорът за твоята роля?';

  const details = [
    ['Пол', actor.gender],
    ['Реална възраст', actor.age ? `${actor.age} г.` : 'Не е посочена'],
    ['Екранна възраст', actor.screenAge],
    ['Ръст', actor.height ? `${actor.height} см` : 'Не е посочен'],
    ['Очи', actor.eyes],
    ['Коса', actor.hairColor],
    ['Регион', actor.region],
    ['Езици', actor.languages],
  ];

  return (
      <main className="min-h-screen bg-[#070b19] pt-[72px] md:pt-[76px]">
        <SEO title={actor.name} description={`${actor.name} – ${actor.category}. ${actor.experience}${actor.skills ? ` Специални умения: ${actor.skills}.` : ''}`} image={actor.photo} canonical={`${SITE.domain}/actors/${actor.slug}`} />

        <section className={classNames('relative overflow-hidden px-4 pb-8 pt-10 md:px-8 md:pb-14 md:pt-16', actor.isPremium && 'min-h-[calc(100vh-72px)] border-b border-amber-300/15')}>
          <img src={actor.photo} alt={`${actor.name} – портрет`} className={classNames('absolute inset-0 h-full w-full object-cover', actor.isPremium ? 'scale-[1.03] opacity-55 mg-premium-hero-image' : 'opacity-45')} />
          <div className={classNames('absolute inset-0', actor.isPremium ? 'bg-gradient-to-r from-[#050507] via-[#07080d]/72 to-[#0b0903]/25' : 'bg-gradient-to-r from-[#070b19] via-[#070b19]/70 to-[#070b19]/35')} />
          {actor.isPremium && <><div className="absolute inset-0 bg-[radial-gradient(circle_at_72%_24%,rgba(251,191,36,.18),transparent_34%)]" /><div className="mg-premium-shimmer absolute inset-y-0 -left-1/3 w-1/3 bg-gradient-to-r from-transparent via-amber-100/10 to-transparent" /></>}
          <div className="absolute inset-0 bg-gradient-to-t from-[#070b19] via-transparent to-black/20" />

          <div className="relative z-10 mx-auto max-w-7xl">
            <Link to="/actors" className="mb-6 inline-flex w-fit items-center gap-2 text-[10px] font-black uppercase tracking-[0.14em] text-[#fbbf24] md:mb-8 md:text-xs md:tracking-[0.18em]"><Icon name="back" /> Назад към актьорите</Link>

            <div className="grid min-h-[560px] items-end gap-7 lg:grid-cols-[minmax(0,1fr)_390px] lg:gap-10">
              <div className={classNames('pb-2 md:pb-4', actor.isPremium && 'mg-premium-reveal mg-premium-delay-1')}>
                <div className="flex flex-wrap items-center gap-2 md:gap-3">
                  <span className="rounded-lg border border-white/12 bg-black/35 px-2.5 py-1.5 text-[9px] font-black uppercase tracking-[0.16em] text-white backdrop-blur-md md:rounded-xl md:px-3 md:py-2 md:text-[10px] md:tracking-[0.2em]">{actor.category}</span>
                  {actor.isPremium && <span className="rounded-lg bg-gradient-to-r from-amber-300 to-amber-600 px-2.5 py-1.5 text-[9px] font-black uppercase tracking-[0.16em] text-black shadow-[0_0_20px_rgba(245,158,11,.35)] md:rounded-xl md:px-3 md:py-2 md:text-[10px] md:tracking-[0.2em]">Premium profile · Featured talent</span>}
                </div>
                <h1 className={classNames('mt-4 max-w-5xl text-4xl font-black uppercase leading-[.92] tracking-[-.045em] text-white md:mt-5 md:text-7xl md:leading-[.88] md:tracking-[-.055em] xl:text-8xl', actor.isPremium && 'mg-premium-name')}>{actor.name}</h1>
                {!actor.isPremium && <p className="mt-4 max-w-2xl text-base font-medium leading-relaxed text-slate-200 md:mt-5 md:text-lg">{actor.experience}</p>}
                {actor.isPremium && (
                    <div className="mt-5 flex flex-wrap gap-2.5 md:mt-7 md:gap-3">
                      <button type="button" onClick={() => setProfileModal('about')} className="inline-flex items-center gap-2 rounded-xl border border-amber-200/35 bg-amber-300/10 px-4 py-3 text-[10px] font-black uppercase tracking-[0.16em] text-amber-100 shadow-[0_10px_30px_rgba(245,158,11,.10)] backdrop-blur-xl transition-all duration-300 hover:-translate-y-0.5 hover:border-amber-200/60 hover:bg-amber-300/20 md:rounded-2xl md:px-5 md:text-xs">Относно <Icon name="arrow" className="h-3.5 w-3.5 rotate-90" /></button>
                      {actor.skills && <button type="button" onClick={() => setProfileModal('skills')} className="inline-flex items-center gap-2 rounded-xl border border-amber-200/35 bg-gradient-to-r from-amber-300/15 to-amber-600/10 px-4 py-3 text-[10px] font-black uppercase tracking-[0.16em] text-amber-100 shadow-[0_10px_30px_rgba(245,158,11,.10)] backdrop-blur-xl transition-all duration-300 hover:-translate-y-0.5 hover:border-amber-200/60 hover:from-amber-300/25 hover:to-amber-600/20 md:rounded-2xl md:px-5 md:text-xs">Специални умения <Icon name="arrow" className="h-3.5 w-3.5 rotate-90" /></button>}
                    </div>
                )}
                <div className="mt-6 flex w-full flex-col gap-2.5 sm:w-auto sm:flex-row md:mt-8 md:gap-3">
                  <a href={`tel:${SITE.phoneHref}`} className="inline-flex w-full items-center justify-center gap-2.5 rounded-xl bg-[#f59e0b] px-5 py-3.5 text-[10px] font-black uppercase tracking-[0.14em] text-black hover:bg-[#fbbf24] sm:w-auto md:gap-3 md:rounded-2xl md:px-7 md:py-4 md:text-xs md:tracking-[0.18em]"><Icon name="phone" /> Обади се за {performerLabel}</a>
                  {actor.showreel && <a href="#showreel" className="inline-flex w-full items-center justify-center gap-2.5 rounded-xl border border-white/15 bg-white/8 px-5 py-3.5 text-[10px] font-black uppercase tracking-[0.14em] text-white backdrop-blur-xl sm:w-auto md:gap-3 md:rounded-2xl md:px-7 md:py-4 md:text-xs md:tracking-[0.18em]"><Icon name="play" /> Видео визитка</a>}
                </div>
              </div>

              <aside className={classNames('rounded-2xl p-5 shadow-2xl backdrop-blur-xl md:rounded-[30px] md:p-6 lg:mb-4', actor.isPremium ? 'mg-premium-info mg-premium-reveal mg-premium-delay-2 border border-amber-300/30 bg-gradient-to-br from-amber-200/[0.11] via-[#0c0d13]/92 to-[#07080c]/95 shadow-[0_28px_90px_rgba(0,0,0,.55)]' : 'border border-white/12 bg-[#0b1020]/85')}>
                <div className="mb-5 flex items-center justify-between gap-3"><p className="text-[10px] font-black uppercase tracking-[0.18em] text-[#fbbf24] md:text-xs md:tracking-[0.22em]">Профил</p>{actor.isPremium && <span className="mg-premium-pulse rounded-full border border-amber-200/35 bg-amber-300/15 px-3 py-1.5 text-[8px] font-black uppercase tracking-[0.2em] text-amber-100">Featured</span>}</div>
                <div className="grid grid-cols-2 gap-3">
                  {details.map(([label, value]) => (
                      <div key={label} className={classNames('rounded-xl p-3.5 transition-all duration-300', actor.isPremium ? 'border border-amber-100/10 bg-white/[0.045] hover:border-amber-200/25 hover:bg-amber-100/[0.07]' : 'border border-white/[0.07] bg-black/25')}>
                        <p className="mb-1 text-[8px] font-black uppercase tracking-[0.14em] text-slate-500 md:text-[9px] md:tracking-[0.17em]">{label}</p>
                        <p className="text-sm font-bold leading-snug text-white md:text-base">{value}</p>
                      </div>
                  ))}
                </div>
                <div className="mt-5 border-t border-white/10 pt-5">
                  {!actor.isPremium && actor.skills && <MetaBlock label="Специални умения" value={actor.skills} />}
                  <div className={!actor.isPremium && actor.skills ? 'mt-5' : ''}><MetaBlock label="Заетост" value={actor.availability} /></div>
                </div>
              </aside>
            </div>
          </div>
        </section>

        <section className={classNames('mx-auto px-4 py-10 md:px-8 md:py-16', actor.isPremium ? 'max-w-[1480px]' : 'max-w-7xl')}>
          <div className="space-y-10 md:space-y-14">
            <Gallery images={actor.gallery?.length ? actor.gallery : [actor.photo]} altPrefix={actor.name} premium={actor.isPremium} />

            {actor.showreel && <section id="showreel" className="scroll-mt-28"><h2 className="mb-4 text-xl font-black uppercase tracking-[0.12em] text-white md:mb-6 md:text-2xl md:tracking-widest">Видео визитка / Showreel</h2><div className="aspect-video overflow-hidden rounded-2xl border border-white/10 bg-black shadow-2xl md:rounded-[28px]"><video src={actor.showreel} controls playsInline preload="metadata" poster={actor.photo} className="h-full w-full object-cover" /></div></section>}

            <section className={classNames('rounded-2xl p-5 md:rounded-[30px] md:p-10', actor.isPremium ? 'mg-premium-reveal mg-premium-delay-4 border border-amber-300/30 bg-gradient-to-br from-amber-300/15 via-[#111018] to-amber-600/10 shadow-[0_24px_80px_rgba(245,158,11,.12)]' : 'border border-[#d97706]/25 bg-gradient-to-br from-[#d97706]/10 to-[#f59e0b]/8')}>
              <p className="mb-3 text-[10px] font-black uppercase tracking-[0.18em] text-[#fbbf24] md:text-xs md:tracking-[0.22em]">За продукционни екипи</p>
              <h2 className={classNames('mb-3 text-2xl font-black text-white md:mb-4 md:text-4xl', actor.isPremium && 'mg-premium-cta-title')}>{suitabilityQuestion}</h2>
              <p className="mb-6 text-sm leading-relaxed text-slate-300 md:mb-7 md:text-base">Свържи се директно с екипа на MG Casting по телефона, за да обсъдим ролята, снимачните дати, града и условията.</p>
              <a href={`tel:${SITE.phoneHref}`} className="inline-flex w-full items-center justify-center gap-3 rounded-xl bg-white px-5 py-3.5 text-[10px] font-black uppercase tracking-[0.14em] text-black sm:w-auto md:rounded-2xl md:px-6 md:py-4 md:text-xs md:tracking-[0.18em]"><Icon name="phone" /> Обади се</a>
            </section>
          </div>
        </section>

        {actor.isPremium && createPortal(
            <div className={classNames('fixed inset-0 z-[10000] flex items-center justify-center px-4 py-8 transition-all duration-300', profileModal ? 'pointer-events-auto visible' : 'pointer-events-none invisible')} aria-hidden={!profileModal}>
              <button type="button" aria-label="Затвори прозореца" onClick={() => setProfileModal(null)} className={classNames('absolute inset-0 bg-black/80 backdrop-blur-md transition-opacity duration-300', profileModal ? 'opacity-100' : 'opacity-0')} />
              <section role="dialog" aria-modal="true" aria-labelledby="premium-info-title" className={classNames('relative z-10 w-full max-w-2xl overflow-hidden rounded-[28px] border border-amber-200/30 bg-gradient-to-br from-[#17130a] via-[#0b0d14] to-[#07080d] p-6 shadow-[0_35px_120px_rgba(0,0,0,.72),0_0_55px_rgba(245,158,11,.12)] transition-all duration-300 md:p-9', profileModal ? 'translate-y-0 scale-100 opacity-100' : 'translate-y-5 scale-[.97] opacity-0')}>
                <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_85%_10%,rgba(251,191,36,.16),transparent_35%)]" />
                <div className="relative">
                  <div className="mb-6 flex items-start justify-between gap-5">
                    <div>
                      <p className="mb-2 text-[9px] font-black uppercase tracking-[0.24em] text-amber-300">Premium profile</p>
                      <h2 id="premium-info-title" className="text-2xl font-black uppercase tracking-[-.02em] text-white md:text-4xl">{profileModal === 'skills' ? 'Специални умения' : 'Относно'}</h2>
                    </div>
                    <button type="button" onClick={() => setProfileModal(null)} className="rounded-full border border-amber-100/20 bg-white/[0.05] p-2.5 text-amber-100 transition hover:border-amber-100/40 hover:bg-white/10"><Icon name="close" /></button>
                  </div>
                  <div className="h-px bg-gradient-to-r from-amber-300/50 via-amber-100/15 to-transparent" />
                  <p className="mt-6 text-base font-medium leading-8 text-slate-200 md:text-lg md:leading-9">{profileModal === 'skills' ? actor.skills : actor.experience}</p>
                </div>
              </section>
            </div>,
            document.body
        )}
      </main>
  );
};

const COURSE_DATA = {
  'Начинаещи': {
    title: 'Курс за Начинаещи',
    audience: 'Курсът е предназначен за хора без професионален опит, които имат интерес към киното, театъра, кастингите и работата пред камера. Подходящ е за ученици, младежи и възрастни, които искат да развият увереност, сценично присъствие и основни актьорски умения.',
    goal: 'Участниците да преодолеят притеснението пред камера, да усвоят базови актьорски техники и да направят първи уверени стъпки в работата с текст, образ и сценично поведение.',
    syllabus: [
      { id: 1, title: 'Въведение в актьорската професия', desc: 'Какво е актьорско присъствие; Каква е разликата между театър и кино; Какво търси режисьорът от актьора; Основни грешки на начинаещия; Как да се освободим от притеснението.', homework: 'Кратко лично представяне пред камера.' },
      { id: 2, title: 'Глас, тяло и увереност', desc: 'Дишане и контрол на гласа; Ясна дикция и артикулация; Стойка и присъствие; Как тялото издава напрежение; Как да изглеждаме естествено и уверено.', homework: 'Запис на кратко видео с ясно говорене и контролирано присъствие пред камера.' },
      { id: 3, title: 'Работа с текст', desc: 'Как се чете актьорски текст; Какво иска героят; Какво е конфликт; Какво е подтекст; Как да избегнем механичното говорене.', homework: 'Подготовка на кратък монолог или откъс.' },
      { id: 4, title: 'Емоция и естественост', desc: 'Как се създава истинска емоция; Как да не преиграваме; Как камерата улавя мисълта; Сила на паузата и тишината; Как да бъдем естествени, но въздействащи.', homework: 'Изпълнение на кратка емоционална сцена.' },
      { id: 5, title: 'Импровизация', desc: 'Реакция в момента; Слушане на партньора; Работа със зададена ситуация; Как да не блокираме; Как да превърнем грешката в действие.', homework: 'Импровизация по зададена ситуация (практика).' },
      { id: 6, title: 'Изграждане на образ', desc: 'Кой е героят; Какво иска; От какво се страхува; Как говори и се движи; Как да изградим образ без карикатурност.', homework: 'Кратко видео в избран образ.' },
      { id: 7, title: 'Работа пред камера и self-tape', desc: 'Как се снима self-tape; Как да застанем пред камера; Поглед, кадър, светлина и звук; Какво да кажем в представянето си; Какво да избягваме.', homework: 'Запис на кратко представяне и сцена за кастинг.' },
      { id: 8, title: 'Финално представяне и обратна връзка', desc: 'Анализ на финалните видеа; Индивидуални насоки; Силни страни на участника; Какво да развива занапред; Как да продължи към кастинги.', homework: 'Финално обсъждане и закриване.' }
    ]
  },
  'Напреднали': {
    title: 'Курс за Напреднали & Мастърклас',
    audience: 'Този модул е изключително за актьори с предишен опит, студенти по актьорско майсторство или хора преминали базови обучения, които искат да надградят техниката си за големия екран. Внимание: Участниците се селектират лично от преподавателя.',
    goal: 'Дълбоко усвояване на кино-техники, работа със сложни персонажи, изграждане на многопластов образ и успешна реализация на професионални кастинги за главни роли в киното.',
    syllabus: [
      { id: 1, title: 'Дълбок анализ на текст', desc: 'Разбиване на сцена на бийтове. Откриване на активни глаголи и скрити мотиви. Как да четем между редовете и да вадим подтекста на повърхността.', homework: 'Избор и анализ на сложна драматична сцена от съвременен филм.' },
      { id: 2, title: 'Изграждане на многопластов образ', desc: 'Създаване на психологически профил на героя. Физикализация на травмата и вътрешния конфликта. Трансформация на глас и походка.', homework: 'Запис на сцена в пълна физическа и вокална трансформация.' },
      { id: 3, title: 'Емоционална памет и автентичност', desc: 'Използване на личния опит за създаване на органична емоция. Техники за бързо влизане в състояние (тъга, гняв, еуфория) пред камера.', homework: 'Монолог, изискващ рязка смяна на емоционалните състояния.' },
      { id: 4, title: 'Партньорство и динамика на сцената', desc: 'Как да водим и да бъдем водени в диалог. Слушане с цялото тяло. Открадване на сцената чрез реакция, а не чрез реплика.', homework: 'Анализ на динамиката в избрана филмова сцена с двама актьори.' },
      { id: 5, title: 'Специфики на кино-актьорството', desc: 'Разлика между общ план, американски план и близък кадър (close-up). Икономия на жеста. Силата на микродвиженията и погледа.', homework: 'Заснемане на extreme close-up сцена с фокус върху очите и мисълта.' },
      { id: 6, title: 'Структурирана импровизация', desc: 'Задържане в образ при неочаквани обстоятелства. Справяне с режисьорски провокации на терен и промяна на текста в движение.', homework: 'Запис на 3-минутна импровизация по зададена рамка.' },
      { id: 7, title: 'Кастинг стратегия за главни роли', desc: 'Как се печели главна роля. Психология на кастинга. Как да направиш self-tape, който да бъде забелязан от международни кастинг директори.', homework: 'Професионален self-tape по реален бриф за пълнометражен филм.' },
      { id: 8, title: 'Финален мастърклас проект', desc: 'Преглед на материалите. Индивидуална критика от Максим Генчев. Стратегия за професионална реализация. Избор на най-добрите таланти за Masterclass.', homework: 'Финално портфолио.' }
    ]
  },
  'Кандидатстудентски': {
    title: 'Подготовка за изпити (НАТФИЗ)',
    audience: 'Специализиран модул за кандидат-студенти, насочен към интензивна подготовка за приемните изпити в НАТФИЗ и други престижни театрални академии в страната и чужбина.',
    goal: 'Избор и перфектно изработване на задължителния репертоар (монолози, басня, стихотворение), развитие на вокална и двигателна култура, и изграждане на психическа устойчивост пред изпитна комисия.',
    syllabus: [
      { id: 1, title: 'Избор на подходящ репертоар', desc: 'Защо репертоарът е 50% от успеха. Избор на материали (драма, комедия, басня), които пасват на индивидуалния темперамент и типаж на кандидата.', homework: 'Четене на предложени текстове и първоначален избор на материал.' },
      { id: 2, title: 'Работа по басня и стихотворение', desc: 'Логика на стиха. Как да разказваме история през поезията. Олицетворение на животни и характерност в баснята, без да преиграваме.', homework: 'Наизустяване и първо изпълнение на баснята и стихотворението.' },
      { id: 3, title: 'Драматичен монолог', desc: 'Откриване на вътрешната болка и конфликта на героя. Изграждане на кулминация. Как да покажем дълбочина за краткото време пред комисията.', homework: 'Запис на драматичния монолог.' },
      { id: 4, title: 'Комедиен монолог', desc: 'Усещане за ритъм и тайминг в комедията. Парадоксът и контрастът като инструменти за смях. Енергия и физическа свобода.', homework: 'Запис на комедийния монолог.' },
      { id: 5, title: 'Вокална и двигателна култура', desc: 'Упражнения за силен и ясен глас (дори при силно притеснение). Сценична пластика, координация и освобождаване на тялото.', homework: 'Ежедневни гласови и физически упражнения.' },
      { id: 6, title: 'Сценично присъствие и фокус', desc: 'Как се влиза в залата. Къде да гледаме (фокусна точка). Как да се представим пред комисията – име, възраст, материал. Преодоляване на сценичната треска.', homework: 'Тренировка на влизане, представяне и започване на материала.' },
      { id: 7, title: 'Симулация на приемен изпит', desc: 'Провеждане на пълен mock audition (пробен изпит) пред камера. Изпълнение на всички материали един след друг без прекъсване при "стресови" условия.', homework: 'Анализ на собственото представяне от симулацията.' },
      { id: 8, title: 'Финални корекции и психическа подготовка', desc: 'Детайлно изчистване на грешките от симулацията. Как да реагираме на забележки и неочаквани задачи от комисията. Мотивация за изпитния ден.', homework: 'Почивка и психическа настройка преди реалните изпити.' }
    ]
  }
};
const COURSE_PLANS = [
  {
    title: 'Начинаещи',
    price: '252 €',
    period: '/ пълен курс',
    oldPrice: '399 €',
    discount: '-37%',
    href: '/checkout/beginner',
    description: 'За хора без опит или с минимален опит, които искат стабилна основа пред камера.',
    features: ['Онлайн обучение с Максим Генчев', 'Практически задачи и работа с текст', 'Обратна връзка и насоки за развитие']
  },
  {
    title: 'Напреднали',
    price: '355 €',
    period: '/ пълен курс',
    oldPrice: '449 €',
    discount: '-21%',
    href: `tel:${SITE.phoneHref}`,
    description: 'За актьори, студенти и хора с опит, които искат по-дълбока работа с образ и кастинг техника.',
    features: ['Онлайн обучение с Максим Генчев', 'Практически задачи и работа с текст', 'Обратна връзка и насоки за развитие']
  },
  {
    title: 'Академична подготовка',
    price: '249 €',
    period: '/ пълен курс',
    oldPrice: '499 €',
    discount: '-50%',
    href: '/checkout/exam',
    description: 'Интензивна подготовка за НАТФИЗ и други актьорски академии.',
    features: ['Онлайн обучение с Максим Генчев', 'Практически задачи и работа с текст', 'Обратна връзка и насоки за развитие']
  }
];

const CoursePage = () => {
  const [activeTab, setActiveTab] = useState('Начинаещи');
  const currentCourse = COURSE_DATA[activeTab] || COURSE_DATA['Начинаещи'];
  const courseActions = {
    'Начинаещи': { to: '/checkout/beginner', label: 'Купи курса' },
    'Напреднали': { to: `tel:${SITE.phoneHref}`, label: 'Обади се за селекция', external: true },
    'Кандидатстудентски': { to: '/checkout/exam', label: 'Купи подготовката' },
  };
  const prices = {
    'Начинаещи': { current: '252 €', old: '399 €', badge: 'Стартова цена' },
    'Напреднали': { current: '355 €', old: '449 €', badge: 'След одобрение' },
    'Кандидатстудентски': { current: '249 €', old: '499 €', badge: 'Стартова цена' },
  };
  const action = courseActions[activeTab];
  const price = prices[activeTab];

  return (
      <main className="relative min-h-screen overflow-hidden bg-[#070b19] px-4 pb-16 pt-24 md:px-8 md:pb-24 md:pt-28 xl:pt-36">
        <SEO title="Актьорски курсове с Максим Генчев" description="Онлайн обучения за начинаещи, напреднали и кандидат-студенти с практическа работа пред камера, self-tape задачи и професионална обратна връзка." canonical={`${SITE.domain}/courses`} />
        <GlowBackdrop />
        <div className="relative z-10 mx-auto max-w-7xl">
          <SectionHeading eyebrow="Онлайн обучение" title="Актьорско майсторство с" accent="Максим Генчев" description="Три практически програми с ясна структура, малки групи и задачи между занятията. Избери нивото, което отговаря на опита и целите ти." />

          <section className="mb-10 grid grid-cols-1 gap-6 overflow-hidden rounded-3xl border border-white/10 bg-white/[0.04] p-5 backdrop-blur-xl md:mb-14 md:gap-8 md:rounded-[36px] md:p-10 lg:grid-cols-[360px_1fr] lg:items-center">
            <div className="overflow-hidden rounded-2xl border border-white/10 bg-black/30 md:rounded-[28px]">
              <img src={INSTRUCTOR.photo} alt={INSTRUCTOR.name} loading="lazy" decoding="async" className="h-full min-h-[300px] w-full object-cover md:min-h-[420px]" />
            </div>
            <div>
              <p className="mb-2 text-[10px] font-black uppercase tracking-[0.18em] text-[#fbbf24] md:mb-3 md:text-xs md:tracking-[0.22em]">Преподавател</p>
              <h2 className="text-3xl font-black uppercase tracking-tight text-white md:text-6xl">{INSTRUCTOR.name}</h2>
              <p className="mt-2 text-[10px] font-black uppercase tracking-[0.13em] text-[#fb923c] md:mt-3 md:text-sm md:tracking-[0.16em]">{INSTRUCTOR.role}</p>
              <div className="mt-5 space-y-4 text-sm leading-relaxed text-slate-300 md:mt-7 md:space-y-5 md:text-base">
                {INSTRUCTOR.biography.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
              </div>
            </div>
          </section>

          <div className="mg-mobile-scroll mb-7 flex flex-nowrap justify-start gap-2 overflow-x-auto pb-1 md:mb-10 md:flex-wrap md:justify-center md:gap-3 md:overflow-visible md:pb-0">
            {[
              ['Начинаещи', 'Начинаещи'],
              ['Напреднали', 'Напреднали'],
              ['Кандидатстудентски', 'Подготовка за изпити'],
            ].map(([key, label]) => (
                <button key={key} type="button" onClick={() => setActiveTab(key)} className={classNames('flex-none whitespace-nowrap rounded-full border px-4 py-2.5 text-[9px] font-black uppercase tracking-[0.14em] transition-all md:px-5 md:py-3 md:text-xs md:tracking-[0.17em]', activeTab === key ? 'border-[#f59e0b] bg-[#f59e0b] text-black shadow-[0_0_25px_rgba(245,158,11,.25)]' : 'border-white/10 bg-white/5 text-slate-300 hover:bg-white/10')}>{label}</button>
            ))}
          </div>

          <section className="grid grid-cols-1 gap-6 overflow-hidden rounded-3xl border border-white/10 bg-white/[0.045] p-5 backdrop-blur-xl md:gap-8 md:rounded-[38px] md:p-10 lg:grid-cols-[1fr_380px]">
            <div>
              <p className="mb-2 text-[10px] font-black uppercase tracking-[0.18em] text-[#fbbf24] md:mb-3 md:text-xs md:tracking-[0.23em]">Избрана програма</p>
              <h1 className="mb-5 text-3xl font-black uppercase leading-tight tracking-tight text-white md:mb-7 md:text-6xl">{currentCourse.title}</h1>
              <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-5">
                <div className="rounded-2xl border border-white/[0.07] bg-black/20 p-5 md:rounded-3xl md:p-6"><p className="mb-2 text-[9px] font-black uppercase tracking-[0.15em] text-[#fbbf24] md:mb-3 md:text-[10px] md:tracking-[0.18em]">За кого е</p><p className="text-sm leading-relaxed text-slate-300 md:text-base">{currentCourse.audience}</p></div>
                <div className="rounded-2xl border border-white/[0.07] bg-black/20 p-5 md:rounded-3xl md:p-6"><p className="mb-2 text-[9px] font-black uppercase tracking-[0.15em] text-[#fb923c] md:mb-3 md:text-[10px] md:tracking-[0.18em]">Основна цел</p><p className="text-sm leading-relaxed text-slate-300 md:text-base">{currentCourse.goal}</p></div>
              </div>
            </div>
            <aside className="flex flex-col justify-between rounded-2xl border border-[#f59e0b]/25 bg-gradient-to-br from-[#f59e0b]/12 to-[#d97706]/12 p-5 md:rounded-[30px] md:p-7">
              <div>
                <span className="inline-flex rounded-full bg-[#f59e0b]/15 px-3 py-1.5 text-[9px] font-black uppercase tracking-widest text-[#fbbf24] md:text-[10px]">{price.badge}</span>
                <div className="mt-4 flex flex-wrap items-end gap-2 md:mt-5 md:gap-3"><span className="text-4xl font-black tracking-tight text-white md:text-6xl">{price.current}</span><span className="mb-1 text-base font-bold text-slate-500 line-through md:mb-2 md:text-lg">{price.old}</span></div>
                <p className="mt-3 text-sm font-medium leading-relaxed text-slate-300 md:mt-4">8 седмици • 1 онлайн занятие седмично • 90 минути • групи до 5 участници</p>
                <div className="mt-5 space-y-2.5 text-sm text-slate-200 md:mt-6 md:space-y-3">
                  {['Практически видео задачи', 'Работа с текст и образ', 'Персонална обратна връзка', 'Premium профил за 8-седмичния период без автоматично продължаване'].map((item) => <div key={item} className="flex gap-3"><Icon name="check" className="mt-0.5 h-5 w-5 flex-none text-[#fbbf24]" />{item}</div>)}
                </div>
              </div>
              <PrimaryLink to={action.to} external={action.external} className="mt-6 w-full md:mt-8">{action.label}</PrimaryLink>
            </aside>
          </section>

          <section className="py-16 md:py-24">
            <SectionHeading eyebrow="8 седмици практика" title="Програма на" accent="обучението" description={`Съдържанието е адаптирано за ниво „${activeTab === 'Кандидатстудентски' ? 'Подготовка за изпити' : activeTab}“ и поставя акцент върху реално изпълнение, не само теория.`} />
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-5">
              {currentCourse.syllabus.map((item) => <article key={item.id} className="group rounded-2xl border border-white/[0.08] bg-white/[0.035] p-5 transition-all hover:-translate-y-1 hover:border-[#fbbf24]/30 md:rounded-[28px] md:p-7"><div className="flex gap-3 md:gap-5"><span className="flex h-10 w-10 flex-none items-center justify-center rounded-xl border border-white/10 bg-black/30 text-base font-black text-[#fbbf24] transition-colors group-hover:bg-[#f59e0b] group-hover:text-black md:h-12 md:w-12 md:rounded-2xl md:text-lg">{item.id}</span><div><h3 className="mb-2 text-lg font-black text-white md:mb-3 md:text-xl">{item.title}</h3><p className="mb-3 text-sm leading-relaxed text-slate-400 md:mb-4">{item.desc}</p><div className="rounded-xl border border-white/[0.06] bg-black/25 p-3 md:rounded-2xl md:p-4"><p className="mb-1 text-[8px] font-black uppercase tracking-[0.15em] text-[#fb923c] md:text-[9px] md:tracking-[0.18em]">Практическа задача</p><p className="text-xs italic leading-relaxed text-slate-300">{item.homework}</p></div></div></div></article>)}
            </div>
          </section>

          <section className="grid grid-cols-1 gap-5 md:gap-7 lg:grid-cols-2">
            <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-6 md:rounded-[32px] md:p-10"><p className="mb-5 text-[10px] font-black uppercase tracking-[0.18em] text-[#fbbf24] md:mb-6 md:text-xs md:tracking-[0.22em]">Какво получаваш</p><ul className="space-y-3 md:space-y-4">{['Увереност пред камера и публика', 'Практическа работа с текст, образ и партньор', 'Техники за self-tape и професионален кастинг', 'Видео задачи с режисьорска обратна връзка', 'Насоки за развитие според силните ти страни', 'Реален шанс да бъдеш разгледан за подходящи продукции'].map((benefit) => <li key={benefit} className="flex gap-3 text-sm text-slate-300 md:text-base"><Icon name="check" className="mt-0.5 h-5 w-5 flex-none text-[#fbbf24]" />{benefit}</li>)}</ul></div>
            <div className="rounded-2xl border border-[#d97706]/25 bg-gradient-to-br from-[#d97706]/12 to-[#f59e0b]/8 p-6 md:rounded-[32px] md:p-10"><p className="mb-5 text-[10px] font-black uppercase tracking-[0.18em] text-[#fb923c] md:mb-6 md:text-xs md:tracking-[0.22em]">Преди плащане</p><div className="space-y-4 text-sm leading-relaxed text-slate-300 md:space-y-5"><p>След записване ще получиш конкретния график, платформата за занятия и подготовката за първата среща.</p><p>Курсът за напреднали е със селекция. Свържи се с екипа по телефона, за да уточним опита ти и следващите стъпки.</p><p>Еднократната покупка на курс не създава месечен абонамент. Включеният Premium профил приключва след 8-седмичния период, освен ако не избереш отделен план.</p></div><div className="mt-6 flex flex-col gap-2.5 sm:flex-row md:mt-8 md:gap-3"><PrimaryLink to={action.to} external={action.external}>{action.label}</PrimaryLink><a href={`tel:${SITE.phoneHref}`} className="group inline-flex min-h-11 items-center justify-center gap-2.5 rounded-xl border border-white/15 bg-white/[0.06] px-4 py-3 text-[10px] font-black uppercase tracking-[0.14em] text-white backdrop-blur-xl transition-all hover:-translate-y-1 hover:border-[#f59e0b]/60 hover:bg-[#f59e0b]/10 md:min-h-12 md:gap-3 md:rounded-2xl md:px-6 md:py-3.5 md:text-xs md:tracking-[0.18em]"><Icon name="phone" className="h-4 w-4" /> Обади се</a></div></div>
          </section>
        </div>
      </main>
  );
};

const SubscriptionCard = ({ premium = false }) => {
  const productKey = premium ? 'premium' : 'standard';
  const features = premium ? [
    'Всичко от Standard',
    'Приоритетно позициониране пред останалите профили',
    'Отличителна златна Premium лента',
    'Видео визитка и кратък видео preview',
    'По-силно визуално присъствие в каталога',
  ] : [
    'Активен профил в актьорския каталог',
    'Снимки, биография и основна информация',
    'Актуализиране на профила при нужда',
    'Видимост пред режисьори и продукции',
    'Поддръжка от екипа на MG Casting',
  ];
  return (
      <div className={classNames('relative flex h-full flex-col overflow-hidden rounded-3xl border p-5 backdrop-blur-xl transition-all hover:-translate-y-2 md:rounded-[34px] md:p-10', premium ? 'border-amber-400/70 bg-gradient-to-br from-amber-500/[0.12] via-white/[0.04] to-amber-700/[0.07] shadow-[0_0_60px_rgba(245,158,11,.12)]' : 'border-white/10 bg-white/[0.045]')}>
        {premium && <div className="absolute right-[-58px] top-5 w-48 rotate-45 bg-gradient-to-r from-amber-300 to-amber-600 py-1.5 text-center text-[8px] font-black uppercase tracking-widest text-black md:right-[-48px] md:top-6 md:py-2 md:text-[9px]">Най-препоръчван</div>}
        <p className={classNames('mb-2 text-[10px] font-black uppercase tracking-[0.18em] md:mb-3 md:text-xs md:tracking-[0.23em]', premium ? 'text-amber-400' : 'text-[#fbbf24]')}>Месечен актьорски профил</p>
        <h3 className="mb-3 text-3xl font-black uppercase tracking-tight text-white md:mb-4 md:text-4xl">{premium ? 'Premium' : 'Standard'}</h3>
        <p className="mb-6 text-sm leading-relaxed text-slate-400 md:mb-8 md:min-h-[48px]">{premium ? 'Приоритетно и запомнящо се представяне с видео съдържание.' : 'Професионално базово присъствие в каталога на MG Casting.'}</p>
        <div className="mb-6 flex flex-wrap items-end gap-2 md:mb-8"><span className={classNames('text-4xl font-black tracking-tight md:text-6xl', premium ? 'text-amber-400' : 'text-white')}>{premium ? '9,99 €' : '4,99 €'}</span><span className="mb-1 text-xs font-bold text-slate-500 md:mb-2 md:text-sm">/ месец</span></div>
        <ul className="mb-7 flex-grow space-y-3 md:mb-9 md:space-y-4">{features.map((feature) => <li key={feature} className="flex gap-3 text-sm leading-relaxed text-slate-300"><Icon name="check" className={classNames('mt-0.5 h-5 w-5 flex-none', premium ? 'text-amber-400' : 'text-[#fbbf24]')} />{feature}</li>)}</ul>
        <PrimaryLink to={`/checkout/${productKey}`} className={premium ? 'bg-gradient-to-r from-amber-300 to-amber-600 shadow-[0_0_30px_rgba(245,158,11,.2)] hover:shadow-[0_0_45px_rgba(245,158,11,.35)]' : ''}>{premium ? 'Избери Premium' : 'Избери Standard'}</PrimaryLink>
        <p className="mt-3 text-center text-[9px] leading-relaxed text-slate-500 md:mt-4 md:text-[10px]">Автоматично месечно подновяване до прекратяване. Профилът не гарантира роля или кастинг.</p>
      </div>
  );
};

const PricingPage = () => (
    <main className="relative min-h-screen overflow-hidden bg-[#070b19] px-4 pb-16 pt-24 md:px-8 md:pb-24 md:pt-28 xl:pt-36">
      <SEO title="Цени и планове" description="Standard и Premium актьорски профили в MG Casting, както и онлайн актьорски обучения с Максим Генчев." canonical={`${SITE.domain}/pricing`} />
      <GlowBackdrop />
      <div className="relative z-10 mx-auto max-w-7xl">
        <SectionHeading eyebrow="Прозрачни условия" title="Избери своето" accent="присъствие" description="Профилите са месечна услуга. Курсовете са еднократна покупка. Всеки бутон води към защитена Stripe checkout страница." />

        <section className="mb-16 md:mb-24">
          <div className="grid grid-cols-1 gap-5 md:gap-7 lg:grid-cols-2"><SubscriptionCard /><SubscriptionCard premium /></div>
          <div className="mt-5 grid grid-cols-1 gap-4 rounded-2xl border border-white/[0.08] bg-white/[0.035] p-5 text-sm text-slate-300 md:mt-7 md:grid-cols-3 md:rounded-[28px] md:p-7">{[
            ['Активиране', 'До 24 часа след потвърдено плащане се свързваме за необходимите материали.'],
            ['Подновяване', 'Абонаментът се подновява месечно чрез Stripe, докато не бъде прекратен.'],
            ['Прекратяване', 'Профилът остава активен до края на платения период и след това се скрива.'],
          ].map(([title, text]) => <div key={title}><p className="mb-2 text-[10px] font-black uppercase tracking-[0.16em] text-[#fbbf24] md:text-xs md:tracking-[0.18em]">{title}</p><p className="leading-relaxed text-slate-400">{text}</p></div>)}</div>
          <div className="mt-4 flex flex-col items-stretch justify-center gap-2.5 sm:flex-row sm:items-center md:mt-5 md:gap-3"><Link to="/legal/cancellation" className="text-center text-[10px] font-bold text-[#fbbf24] underline underline-offset-4 md:text-xs">Условия за прекратяване</Link>{API_ENDPOINTS.customerPortal ? <a href={API_ENDPOINTS.customerPortal} className="rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-center text-[10px] font-black uppercase tracking-widest text-white md:text-xs">Управление на абонамента</a> : <Link to="/contact?topic=subscription" className="rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-center text-[10px] font-black uppercase tracking-widest text-white md:text-xs">Помощ за абонамент</Link>}</div>
        </section>

        <section>
          <SectionHeading eyebrow="Еднократно плащане" title="Актьорски" accent="обучения" description="Три отделни програми. Курсът за напреднали изисква предварително одобрение, преди да бъде извършено плащане." />
          <div className="grid grid-cols-1 gap-5 md:gap-7 lg:grid-cols-3">
            {COURSE_PLANS.map((plan) => <article key={plan.title} className="flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.04] p-5 backdrop-blur-xl transition-all hover:-translate-y-2 hover:border-[#fbbf24]/30 md:rounded-[32px] md:p-8"><p className="mb-2 text-[9px] font-black uppercase tracking-[0.16em] text-[#fbbf24] md:mb-3 md:text-[10px] md:tracking-[0.2em]">Актьорски курс</p><h3 className="mb-3 text-2xl font-black uppercase leading-tight text-white md:mb-4 md:text-3xl">{plan.title}</h3><p className="mb-5 text-sm leading-relaxed text-slate-400 md:mb-6 md:min-h-[80px]">{plan.description}</p><div className="mb-6 md:mb-7"><div className="mb-2 flex items-center gap-2.5 md:gap-3"><span className="rounded-lg bg-red-600 px-2.5 py-1.5 text-[9px] font-black uppercase tracking-widest text-white md:px-3 md:text-[10px]">{plan.discount}</span><span className="text-xl font-black text-slate-500 line-through md:text-2xl">{plan.oldPrice}</span></div><div className="flex flex-wrap items-end gap-2"><span className="text-4xl font-black text-white md:text-5xl">{plan.price}</span><span className="mb-1 text-[10px] font-bold text-slate-500 md:mb-2 md:text-xs">{plan.period}</span></div></div><ul className="mb-7 flex-grow space-y-2.5 md:mb-8 md:space-y-3">{plan.features.map((feature) => <li key={feature} className="flex gap-3 text-sm text-slate-300"><Icon name="check" className="h-5 w-5 flex-none text-[#fbbf24]" />{feature}</li>)}</ul><PrimaryLink to={plan.href}>{plan.title === 'Напреднали' ? 'Кандидатствай' : 'Купи курса'}</PrimaryLink></article>)}
          </div>
        </section>
      </div>
    </main>
);

const ContactPage = () => (
    <main className="relative min-h-screen overflow-hidden bg-[#070b19] px-4 pb-16 pt-24 md:px-8 md:pb-24 md:pt-28 xl:pt-36">
      <SEO title="Контакти" description="Свържи се с MG Casting директно по телефона." canonical={`${SITE.domain}/contact`} />
      <GlowBackdrop />
      <div className="relative z-10 mx-auto max-w-4xl">
        <SectionHeading eyebrow="Свържи се с екипа" title="Контакти" description="За въпроси, записване, актьорски профили и работа с продукции се свържи директно с нас по телефона." />
        <section className="mx-auto max-w-2xl rounded-3xl border border-white/10 bg-white/[0.045] p-5 text-center backdrop-blur-xl md:rounded-[36px] md:p-12">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-[#f59e0b]/15 text-[#fbbf24] shadow-[0_0_35px_rgba(245,158,11,.16)] md:h-20 md:w-20 md:rounded-3xl"><Icon name="phone" className="h-8 w-8 md:h-9 md:w-9" /></span>
          <p className="mt-5 text-[10px] font-black uppercase tracking-[0.18em] text-[#fbbf24] md:mt-7 md:text-xs md:tracking-[0.24em]">Директен контакт</p>
          <h1 className="mt-3 break-words text-2xl font-black uppercase tracking-tight text-white md:mt-4 md:text-5xl">{SITE.phoneDisplay}</h1>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-slate-300 md:mt-5 md:text-base">Обади се и екипът на MG Casting ще отговори на въпросите ти и ще ти даде ясни насоки за следващите стъпки.</p>
          <a href={`tel:${SITE.phoneHref}`} className="mt-6 inline-flex min-h-12 w-full items-center justify-center gap-2.5 rounded-xl bg-gradient-to-r from-[#f59e0b] to-[#d97706] px-5 py-3.5 text-[10px] font-black uppercase tracking-[0.14em] text-black shadow-[0_0_35px_rgba(245,158,11,.2)] transition-transform hover:-translate-y-1 sm:w-auto md:mt-8 md:min-h-14 md:gap-3 md:rounded-2xl md:px-7 md:py-4 md:text-sm md:tracking-[0.18em]"><Icon name="phone" className="h-5 w-5" /> Обади се</a>
        </section>
      </div>
    </main>
);

const buildLegalDocumentText = (document) => {
  const lines = [document.title, document.updated, ''];

  document.intro.forEach((paragraph) => {
    lines.push(paragraph, '');
  });

  document.sections.forEach((section) => {
    lines.push(section.heading, '');
    section.paragraphs.forEach((paragraph) => lines.push(paragraph, ''));
  });

  return lines.join('\n').trim();
};

const downloadLegalDocument = (document) => {
  const blob = new Blob([buildLegalDocumentText(document)], { type: 'text/plain;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  const anchor = window.document.createElement('a');
  anchor.href = url;
  anchor.download = `MG-Casting-${document.slug}.txt`;
  window.document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.URL.revokeObjectURL(url);
};

const DocumentsPage = () => {
  const location = useLocation();
  const selectedDocument = LEGAL_DOCUMENTS.find((document) => document.route === location.pathname) || null;
  const displayedDocuments = selectedDocument ? [selectedDocument] : LEGAL_DOCUMENTS;

  return (
      <main className="relative min-h-screen overflow-hidden bg-[#070b19] px-4 pb-16 pt-24 md:px-8 md:pb-24 md:pt-28 xl:pt-36">
        <SEO
            title={selectedDocument ? selectedDocument.title : 'Правни документи'}
            description="Правните документи на MG Casting са достъпни за изтегляне."
            canonical={`${SITE.domain}${selectedDocument ? selectedDocument.route : '/legal'}`}
        />
        <GlowBackdrop />
        <div className="relative z-10 mx-auto max-w-5xl">
          {selectedDocument && (
              <Link to="/legal" className="mb-7 inline-flex items-center gap-2 text-[10px] font-black uppercase tracking-[0.16em] text-[#fbbf24] hover:text-white md:mb-9 md:text-xs">
                <Icon name="back" className="h-4 w-4" /> Всички документи
              </Link>
          )}

          <h1 className="mb-4 text-center text-4xl font-black uppercase tracking-tight text-white md:text-7xl">
            {selectedDocument ? 'Изтегли документа' : 'Правни документи'}
          </h1>
          <p className="mx-auto mb-8 max-w-3xl text-center text-sm leading-relaxed text-slate-400 md:mb-12 md:text-base">
            Съдържанието на правните документи не се публикува директно на сайта. За да се запознаеш с избран документ, изтегли го на устройството си.
          </p>

          <div className={classNames('grid grid-cols-1 gap-4 md:gap-5', displayedDocuments.length > 1 && 'md:grid-cols-2')}>
            {displayedDocuments.map((document) => (
                <article key={document.slug} className="flex flex-col items-stretch gap-5 rounded-2xl border border-white/[0.08] bg-white/[0.035] p-5 backdrop-blur-xl md:rounded-[28px] md:p-7">
                  <div className="flex-grow">
                    <h2 className="text-base font-black uppercase tracking-tight text-white md:text-xl">{document.title}</h2>
                    <p className="mt-2 text-xs text-slate-500">{document.updated}</p>
                  </div>
                  <button
                      type="button"
                      onClick={() => downloadLegalDocument(document)}
                      className="inline-flex min-h-12 items-center justify-center gap-2 rounded-xl bg-[#f59e0b] px-5 py-3 text-center text-[10px] font-black uppercase tracking-[0.16em] text-black transition-all hover:-translate-y-0.5 hover:bg-[#fbbf24]"
                  >
                    <Icon name="download" className="h-4 w-4" /> Изтегли документа
                  </button>
                </article>
            ))}
          </div>
        </div>
      </main>
  );
};

const NotFound = ({ compact = false }) => (
    <main className={classNames('relative flex items-center justify-center overflow-hidden bg-[#070b19] px-5 text-center', compact ? 'min-h-[70vh] pt-24 xl:pt-28' : 'min-h-screen pt-24 xl:pt-28')}>
      <SEO title="Страницата не е намерена" description="Търсената страница не съществува." />
      <GlowBackdrop />
      <div className="relative z-10 max-w-2xl"><p className="mb-3 text-7xl font-black tracking-tighter text-[#f59e0b] md:text-9xl">404</p><h1 className="mb-4 text-2xl font-black uppercase text-white md:mb-5 md:text-5xl">Тази сцена липсва</h1><p className="mb-8 text-slate-400">Адресът може да е променен или съдържанието вече да не е достъпно.</p><div className="flex flex-col justify-center gap-3 sm:flex-row"><PrimaryLink to="/">Към началото</PrimaryLink><SecondaryLink to="/actors">Каталог актьори</SecondaryLink></div></div>
    </main>
);

const Footer = () => (
    <footer className="relative border-t border-white/[0.07] bg-[#05070d] px-4 py-10 md:px-8 md:py-12">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 md:grid-cols-2 md:gap-10 lg:grid-cols-[1.3fr_.8fr_.8fr_1fr]">
        <div><Link to="/" className="flex w-fit items-center gap-3"><img src={SITE.logo} alt="MG casting" className="h-12 w-12 rounded-xl object-contain md:h-14 md:w-14 md:rounded-2xl" /><div><span className="block text-lg font-black uppercase tracking-[0.12em] text-white md:text-xl md:tracking-[0.14em]">MG casting</span><span className="text-[8px] font-bold uppercase tracking-[0.2em] text-[#fbbf24] md:text-[9px] md:tracking-[0.24em]">Film casting agency</span></div></Link><p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-500 md:mt-5">Свързваме актьори и нови лица с кино, телевизионни, рекламни и музикални продукции.</p><a href={`tel:${SITE.phoneHref}`} className="mt-5 inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-[#f59e0b] to-[#d97706] px-4 py-3 text-[10px] font-black uppercase tracking-[0.15em] text-black md:mt-6"><Icon name="phone" className="h-4 w-4" /> Запиши се</a></div>
        <div><p className="mb-3 text-[10px] font-black uppercase tracking-[0.18em] text-white md:mb-4 md:text-xs md:tracking-[0.2em]">Навигация</p><div className="space-y-2.5 text-sm text-slate-400 md:space-y-3"><Link className="block hover:text-white" to="/actors">Актьори</Link><Link className="block hover:text-white" to="/courses">Курсове</Link><Link className="block hover:text-white" to="/pricing">Цени</Link><Link className="block hover:text-white" to="/contact">Контакти</Link></div></div>
        <div><p className="mb-3 text-[10px] font-black uppercase tracking-[0.18em] text-white md:mb-4 md:text-xs md:tracking-[0.2em]">Правна информация</p><div className="space-y-2.5 text-sm text-slate-400 md:space-y-3"><Link className="block hover:text-white" to="/legal/terms">Общи условия</Link><Link className="block hover:text-white" to="/legal/privacy">Поверителност</Link><Link className="block hover:text-white" to="/legal/cookies">Бисквитки</Link><Link className="block hover:text-white" to="/legal/cancellation">Абонамент и отказ</Link></div></div>
        <div><p className="mb-3 text-[10px] font-black uppercase tracking-[0.18em] text-white md:mb-4 md:text-xs md:tracking-[0.2em]">Контакт</p><div className="space-y-2.5 text-sm text-slate-400 md:space-y-3"><a className="block hover:text-white" href={`tel:${SITE.phoneHref}`}>{SITE.phoneDisplay}</a><a href={`tel:${SITE.phoneHref}`} className="mt-4 inline-flex items-center gap-2 rounded-xl border border-[#fb923c]/30 bg-[#fb923c]/10 px-4 py-3 text-[10px] font-black uppercase tracking-widest text-[#fed7aa] md:mt-5"><Icon name="phone" className="h-4 w-4" /> Обади се</a></div></div>
      </div>

      <div className="mx-auto mt-8 grid max-w-7xl grid-cols-1 gap-4 rounded-2xl border border-white/[0.06] bg-white/[0.025] p-4 text-[11px] leading-relaxed text-slate-500 md:mt-10 md:grid-cols-[1fr_auto] md:items-center md:p-5 md:text-xs">
        <div><span className="font-bold text-slate-300">{SITE.legalName}</span> · ЕИК {SITE.eik}<span className="mt-1 block">Седалище: {SITE.address}</span><span className="mt-1 block">Управител: {SITE.manager}</span></div>
        <a href={`tel:${SITE.phoneHref}`} className="inline-flex min-h-11 items-center justify-center gap-2 rounded-xl border border-[#f59e0b]/25 bg-[#f59e0b]/8 px-4 font-black uppercase tracking-[0.13em] text-[#fcd34d]"><Icon name="phone" className="h-4 w-4" /> {SITE.phoneDisplay}</a>
      </div>

      <div className="mx-auto mt-6 flex max-w-7xl flex-col gap-2 border-t border-white/[0.06] pt-6 text-[11px] text-slate-600 md:mt-7 md:flex-row md:items-center md:justify-between md:gap-3 md:pt-7 md:text-xs"><span>© {new Date().getFullYear()} MG Casting. Всички права запазени.</span><span>Платен профил не гарантира роля или участие.</span></div>
    </footer>
);

const GlobalStyles = () => <style>{`
  :root { color-scheme: dark; }
  html { scroll-behavior: smooth; background: #070b19; }
  body { margin: 0; overflow-x: hidden; background: #070b19; }
  * { box-sizing: border-box; }
  img, video, iframe { max-width: 100%; }
  button, a { -webkit-tap-highlight-color: transparent; }
  ::selection { background: #f59e0b; color: #111827; }
  :focus-visible { outline: 2px solid #fbbf24; outline-offset: 3px; }
  @keyframes mg-marquee-animation { from { transform: translateX(0); } to { transform: translateX(-50%); } }
  @keyframes mg-premium-reveal { from { opacity: 0; transform: translateY(28px) scale(.985); filter: blur(8px); } to { opacity: 1; transform: translateY(0) scale(1); filter: blur(0); } }
  @keyframes mg-premium-hero { from { transform: scale(1.09); filter: saturate(.78) brightness(.82); } to { transform: scale(1.03); filter: saturate(1.05) brightness(1); } }
  @keyframes mg-premium-shimmer { 0% { transform: translateX(-120%) skewX(-14deg); opacity: 0; } 18% { opacity: 1; } 58%,100% { transform: translateX(520%) skewX(-14deg); opacity: 0; } }
  @keyframes mg-premium-pulse { 0%,100% { box-shadow: 0 0 0 rgba(251,191,36,0); } 50% { box-shadow: 0 0 28px rgba(251,191,36,.28); } }
  @keyframes mg-premium-gallery-in { from { opacity: 0; transform: translateY(20px) scale(.97); filter: blur(5px); } to { opacity: 1; transform: translateY(0) scale(1); filter: blur(0); } }
  @keyframes mg-premium-cta-title { 0% { opacity: 0; transform: translateY(18px); letter-spacing: .02em; } 100% { opacity: 1; transform: translateY(0); letter-spacing: .005em; } }
  @keyframes mg-premium-name-glow { 0%,100% { text-shadow: 0 0 0 rgba(251,191,36,0); } 50% { text-shadow: 0 0 28px rgba(251,191,36,.18); } }
  .mg-marquee { animation: mg-marquee-animation 25s linear infinite; }
  .mg-premium-reveal { animation: mg-premium-reveal .85s cubic-bezier(.2,.75,.2,1) both; }
  .mg-premium-delay-1 { animation-delay: .08s; }
  .mg-premium-delay-2 { animation-delay: .22s; }
  .mg-premium-delay-3 { animation-delay: .32s; }
  .mg-premium-delay-4 { animation-delay: .42s; }
  .mg-premium-hero-image { animation: mg-premium-hero 1.35s cubic-bezier(.2,.75,.2,1) both; }
  .mg-premium-shimmer { animation: mg-premium-shimmer 5.5s 1s ease-in-out infinite; }
  .mg-premium-pulse { animation: mg-premium-pulse 2.7s ease-in-out infinite; }
  .mg-premium-name { font-weight: 700; letter-spacing: -.025em; text-transform: none; animation: mg-premium-name-glow 3.4s ease-in-out infinite; }
  .mg-premium-gallery-item { animation: mg-premium-gallery-in .72s cubic-bezier(.2,.75,.2,1) both; position: relative; }
  .mg-premium-gallery-item::after { content: ""; position: absolute; inset: 5px; border: 1px solid rgba(251,191,36,.2); border-radius: inherit; pointer-events: none; }
  .mg-premium-cta-title { animation: mg-premium-cta-title 1s .48s cubic-bezier(.2,.75,.2,1) both; font-weight: 700; line-height: 1.08; letter-spacing: .005em; }
  .mg-mobile-scroll { scrollbar-width: none; }
  .mg-mobile-scroll::-webkit-scrollbar { display: none; }
  @media (prefers-reduced-motion: reduce) {
    html { scroll-behavior: auto; }
    *, *::before, *::after { animation-duration: .01ms !important; animation-iteration-count: 1 !important; transition-duration: .01ms !important; }
    .mg-marquee { animation: none !important; transform: none !important; }
  }
`}</style>;

function App() {
  useEffect(() => {
    let icon = document.querySelector("link[rel~='icon']");
    if (!icon) { icon = document.createElement('link'); icon.rel = 'icon'; document.head.appendChild(icon); }
    icon.href = SITE.logo;

    let viewport = document.querySelector('meta[name="viewport"]');
    if (!viewport) {
      viewport = document.createElement('meta');
      viewport.setAttribute('name', 'viewport');
      document.head.appendChild(viewport);
    }
    viewport.setAttribute('content', 'width=device-width, initial-scale=1, viewport-fit=cover');
  }, []);

  return (
      <Router>
        <GlobalStyles />
        <ScrollToTop />
        <PaymentSuccessModal />
        <CookieConsent />
        <div className="flex min-h-screen flex-col bg-[#070b19] font-sans text-white antialiased">
          <Navbar />
          <div className="flex-grow">
            <Routes>
              <Route path="/" element={<MainPage />} />
              <Route path="/projects/:id" element={<ProjectDetails />} />
              <Route path="/actors" element={<ActorsPage />} />
              <Route path="/actors/:id" element={<ActorProfile />} />
              <Route path="/courses" element={<CoursePage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/checkout/:productKey" element={<CheckoutRedirect />} />
              <Route path="/legal" element={<DocumentsPage />} />
              <Route path="/legal/terms" element={<DocumentsPage />} />
              <Route path="/legal/privacy" element={<DocumentsPage />} />
              <Route path="/legal/cookies" element={<DocumentsPage />} />
              <Route path="/legal/cancellation" element={<DocumentsPage />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </Router>
  );
}

export default App;
